function ownKeys$1(s, h) {
  var v = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var m = Object.getOwnPropertySymbols(s);
    (h &&
      (m = m.filter(function (h) {
        return Object.getOwnPropertyDescriptor(s, h).enumerable;
      })),
      v.push.apply(v, m));
  }
  return v;
}

function _objectSpread2$1(s) {
  for (var h = 1; h < arguments.length; h++) {
    var v = null != arguments[h] ? arguments[h] : {};
    h % 2
      ? ownKeys$1(Object(v), !0).forEach(function (h) {
          _defineProperty$1(s, h, v[h]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(v))
        : ownKeys$1(Object(v)).forEach(function (h) {
            Object.defineProperty(s, h, Object.getOwnPropertyDescriptor(v, h));
          });
  }
  return s;
}

function _typeof(s) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (s) {
          return typeof s;
        }
      : function (s) {
          return s &&
            "function" == typeof Symbol &&
            s.constructor === Symbol &&
            s !== Symbol.prototype
            ? "symbol"
            : typeof s;
        })(s);
}

function _classCallCheck(s, h) {
  if (!(s instanceof h)) throw TypeError("Cannot call a class as a function");
}

function _defineProperties(s, h) {
  for (var v = 0; v < h.length; v++) {
    var m = h[v];
    ((m.enumerable = m.enumerable || !1),
      (m.configurable = !0),
      "value" in m && (m.writable = !0),
      Object.defineProperty(s, m.key, m));
  }
}

function _createClass(s, h, v) {
  return (
    h && _defineProperties(s.prototype, h),
    v && _defineProperties(s, v),
    Object.defineProperty(s, "prototype", {
      writable: !1,
    }),
    s
  );
}

function _defineProperty$1(s, h, v) {
  return (
    h in s
      ? Object.defineProperty(s, h, {
          value: v,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (s[h] = v),
    s
  );
}

function _slicedToArray(s, h) {
  return (
    _arrayWithHoles(s) ||
    _iterableToArrayLimit(s, h) ||
    _unsupportedIterableToArray(s, h) ||
    _nonIterableRest()
  );
}

function _toConsumableArray$1(s) {
  return (
    _arrayWithoutHoles(s) ||
    _iterableToArray(s) ||
    _unsupportedIterableToArray(s) ||
    _nonIterableSpread()
  );
}

function _arrayWithoutHoles(s) {
  if (Array.isArray(s)) return _arrayLikeToArray(s);
}

function _arrayWithHoles(s) {
  if (Array.isArray(s)) return s;
}

function _iterableToArray(s) {
  if (
    ("undefined" != typeof Symbol && null != s[Symbol.iterator]) ||
    null != s["@@iterator"]
  )
    return Array.from(s);
}

function _iterableToArrayLimit(s, h) {
  var v,
    m,
    g =
      null == s
        ? null
        : ("undefined" != typeof Symbol && s[Symbol.iterator]) ||
          s["@@iterator"];
  if (null != g) {
    var y = [],
      b = !0,
      _ = !1;
    try {
      for (
        g = g.call(s);
        !(b = (v = g.next()).done) && (y.push(v.value), !h || y.length !== h);
        b = !0
      );
    } catch ($) {
      ((_ = !0), (m = $));
    } finally {
      try {
        b || null == g.return || g.return();
      } finally {
        if (_) throw m;
      }
    }
    return y;
  }
}

function _unsupportedIterableToArray(s, h) {
  if (s) {
    if ("string" == typeof s) return _arrayLikeToArray(s, h);
    var v = Object.prototype.toString.call(s).slice(8, -1);
    if (
      ("Object" === v && s.constructor && (v = s.constructor.name),
      "Map" === v || "Set" === v)
    )
      return Array.from(s);
    if ("Arguments" === v || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v))
      return _arrayLikeToArray(s, h);
  }
}

function _arrayLikeToArray(s, h) {
  (null == h || h > s.length) && (h = s.length);
  for (var v = 0, m = Array(h); v < h; v++) m[v] = s[v];
  return m;
}

function _nonIterableSpread() {
  throw TypeError(
    "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}

function _nonIterableRest() {
  throw TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}
var timer,
  _window$Shopify,
  SECTION_ID_ATTR$1 = "data-section-id";

function Section(s, h) {
  ((this.container = validateContainerElement(s)),
    (this.id = s.getAttribute(SECTION_ID_ATTR$1)),
    (this.extensions = []),
    Object.assign(this, validatePropertiesObject(h)),
    this.onLoad());
}

function validateContainerElement(s) {
  if (!(s instanceof Element))
    throw TypeError(
      "Theme Sections: Attempted to load section. The section container provided is not a DOM element.",
    );
  if (null === s.getAttribute(SECTION_ID_ATTR$1))
    throw Error(
      "Theme Sections: The section container provided does not have an id assigned to the " +
        SECTION_ID_ATTR$1 +
        " attribute.",
    );
  return s;
}

function validatePropertiesObject(s) {
  if ((void 0 !== s && "object" != typeof s) || null === s)
    throw TypeError(
      "Theme Sections: The properties object provided is not a valid",
    );
  return s;
}
((Section.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,
  extend: function s(h) {
    this.extensions.push(h);
    var v = Object.assign({}, h);
    (delete v.init,
      Object.assign(this, v),
      "function" == typeof h.init && h.init.apply(this));
  },
}),
  "function" != typeof Object.assign &&
    Object.defineProperty(Object, "assign", {
      value: function s(h) {
        if (null == h)
          throw TypeError("Cannot convert undefined or null to object");
        for (var v = Object(h), m = 1; m < arguments.length; m++) {
          var g = arguments[m];
          if (null != g)
            for (var y in g)
              Object.prototype.hasOwnProperty.call(g, y) && (v[y] = g[y]);
        }
        return v;
      },
      writable: !0,
      configurable: !0,
    }));
var SECTION_TYPE_ATTR = "data-section-type",
  SECTION_ID_ATTR = "data-section-id";
((window.Shopify = window.Shopify || {}),
  (window.Shopify.theme = window.Shopify.theme || {}),
  (window.Shopify.theme.sections = window.Shopify.theme.sections || {}));
var registered = (window.Shopify.theme.sections.registered =
    window.Shopify.theme.sections.registered || {}),
  instances = (window.Shopify.theme.sections.instances =
    window.Shopify.theme.sections.instances || []);

function register(s, h) {
  if ("string" != typeof s)
    throw TypeError(
      "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered",
    );
  if (void 0 !== registered[s])
    throw Error(
      'Theme Sections: A section of type "' +
        s +
        '" has already been registered. You cannot register the same section type twice',
    );

  function v(s) {
    Section.call(this, s, h);
  }
  return (
    (v.constructor = Section),
    (v.prototype = Object.create(Section.prototype)),
    (v.prototype.type = s),
    (registered[s] = v)
  );
}

function load(s, h) {
  ((s = normalizeType(s)),
    void 0 === h &&
      (h = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]")),
    (h = normalizeContainers(h)),
    s.forEach(function (s) {
      var v = registered[s];
      void 0 !== v &&
        (h = h.filter(function (h) {
          return (
            !isInstance(h) &&
            null !== h.getAttribute(SECTION_TYPE_ATTR) &&
            (h.getAttribute(SECTION_TYPE_ATTR) !== s ||
              (instances.push(new v(h)), !1))
          );
        }));
    }));
}

function unload(s) {
  getInstances(s).forEach(function (s) {
    var h = instances
      .map(function (s) {
        return s.id;
      })
      .indexOf(s.id);
    (instances.splice(h, 1), s.onUnload());
  });
}

function getInstances(s) {
  var h = [];
  if (NodeList.prototype.isPrototypeOf(s) || Array.isArray(s)) var v = s[0];
  return (
    s instanceof Element || v instanceof Element
      ? normalizeContainers(s).forEach(function (s) {
          h = h.concat(
            instances.filter(function (h) {
              return h.container === s;
            }),
          );
        })
      : ("string" == typeof s || "string" == typeof v) &&
        normalizeType(s).forEach(function (s) {
          h = h.concat(
            instances.filter(function (h) {
              return h.type === s;
            }),
          );
        }),
    h
  );
}

function getInstanceById(s) {
  for (var h, v = 0; v < instances.length; v++)
    if (instances[v].id === s) {
      h = instances[v];
      break;
    }
  return h;
}

function isInstance(s) {
  return getInstances(s).length > 0;
}

function normalizeType(s) {
  return (
    "*" === s
      ? (s = Object.keys(registered))
      : "string" == typeof s
        ? (s = [s])
        : s.constructor === Section
          ? (s = [s.prototype.type])
          : Array.isArray(s) &&
            s[0].constructor === Section &&
            (s = s.map(function (s) {
              return s.prototype.type;
            })),
    (s = s.map(function (s) {
      return s.toLowerCase();
    }))
  );
}

function normalizeContainers(s) {
  return (
    NodeList.prototype.isPrototypeOf(s) && s.length > 0
      ? (s = Array.prototype.slice.call(s))
      : NodeList.prototype.isPrototypeOf(s) && 0 === s.length
        ? (s = [])
        : null === s
          ? (s = [])
          : !Array.isArray(s) && s instanceof Element && (s = [s]),
    s
  );
}

function n$2(s, h) {
  return (void 0 === h && (h = document), h.querySelector(s));
}

function t$2(s, h) {
  return (void 0 === h && (h = document), [].slice.call(h.querySelectorAll(s)));
}

function c$1(s, h) {
  return Array.isArray(s) ? s.forEach(h) : h(s);
}

function r$2(s) {
  return function (h, v, m) {
    return c$1(h, function (h) {
      return h[s + "EventListener"](v, m);
    });
  };
}

function e$2(s, h, v) {
  return (
    r$2("add")(s, h, v),
    function () {
      return r$2("remove")(s, h, v);
    }
  );
}

function o$2(s) {
  return function (h) {
    var v = arguments;
    return c$1(h, function (h) {
      var m;
      return (m = h.classList)[s].apply(m, [].slice.call(v, 1));
    });
  };
}

function u$1(s) {
  o$2("add").apply(void 0, [s].concat([].slice.call(arguments, 1)));
}

function i$1(s) {
  o$2("remove").apply(void 0, [s].concat([].slice.call(arguments, 1)));
}

function l(s) {
  o$2("toggle").apply(void 0, [s].concat([].slice.call(arguments, 1)));
}

function a$1(s, h) {
  return s.classList.contains(h);
}

function getDefaultExportFromCjs(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default")
    ? s.default
    : s;
}
window.Shopify.designMode &&
  (document.addEventListener("shopify:section:load", function (s) {
    var h = s.detail.sectionId,
      v = s.target.querySelector("[" + SECTION_ID_ATTR + '="' + h + '"]');
    null !== v && load(v.getAttribute(SECTION_TYPE_ATTR), v);
  }),
  document.addEventListener("shopify:section:unload", function (s) {
    var h = s.detail.sectionId,
      v = s.target.querySelector("[" + SECTION_ID_ATTR + '="' + h + '"]');
    "object" == typeof getInstances(v)[0] && unload(v);
  }),
  document.addEventListener("shopify:section:select", function (s) {
    var h = getInstanceById(s.detail.sectionId);
    "object" == typeof h && h.onSelect(s);
  }),
  document.addEventListener("shopify:section:deselect", function (s) {
    var h = getInstanceById(s.detail.sectionId);
    "object" == typeof h && h.onDeselect(s);
  }),
  document.addEventListener("shopify:block:select", function (s) {
    var h = getInstanceById(s.detail.sectionId);
    "object" == typeof h && h.onBlockSelect(s);
  }),
  document.addEventListener("shopify:block:deselect", function (s) {
    var h = getInstanceById(s.detail.sectionId);
    "object" == typeof h && h.onBlockDeselect(s);
  }));
var isMobile$2 = {
  exports: {},
};
((isMobile$2.exports = isMobile),
  (isMobile$2.exports.isMobile = isMobile),
  (isMobile$2.exports.default = isMobile));
var mobileRE =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i,
  tabletRE =
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;

function isMobile(s) {
  s || (s = {});
  var h = s.ua;
  if (
    (h || "undefined" == typeof navigator || (h = navigator.userAgent),
    h &&
      h.headers &&
      "string" == typeof h.headers["user-agent"] &&
      (h = h.headers["user-agent"]),
    "string" != typeof h)
  )
    return !1;
  var v = s.tablet ? tabletRE.test(h) : mobileRE.test(h);
  return (
    !v &&
      s.tablet &&
      s.featureDetect &&
      navigator &&
      navigator.maxTouchPoints > 1 &&
      -1 !== h.indexOf("Macintosh") &&
      -1 !== h.indexOf("Safari") &&
      (v = !0),
    v
  );
}
var isMobile$1 = isMobile$2.exports,
  browser = {
    exports: {},
  };
!(function (s, h) {
  function v(s) {
    ((this.listenerMap = [{}, {}]),
      s && this.root(s),
      (this.handle = v.prototype.handle.bind(this)),
      (this._removedListeners = []));
  }

  function m(s, h) {
    return s.toLowerCase() === h.tagName.toLowerCase();
  }

  function g(s, h) {
    return this.rootElement === window
      ? h === document || h === document.documentElement || h === window
      : this.rootElement === h;
  }

  function y(s, h) {
    return s === h.id;
  }
  (Object.defineProperty(h, "__esModule", {
    value: !0,
  }),
    (h.default = void 0),
    (v.prototype.root = function (s) {
      var h,
        v = this.listenerMap;
      if (this.rootElement) {
        for (h in v[1])
          v[1].hasOwnProperty(h) &&
            this.rootElement.removeEventListener(h, this.handle, !0);
        for (h in v[0])
          v[0].hasOwnProperty(h) &&
            this.rootElement.removeEventListener(h, this.handle, !1);
      }
      if (!s || !s.addEventListener)
        return (this.rootElement && delete this.rootElement, this);
      for (h in ((this.rootElement = s), v[1]))
        v[1].hasOwnProperty(h) &&
          this.rootElement.addEventListener(h, this.handle, !0);
      for (h in v[0])
        v[0].hasOwnProperty(h) &&
          this.rootElement.addEventListener(h, this.handle, !1);
      return this;
    }),
    (v.prototype.captureForType = function (s) {
      return (
        -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(s)
      );
    }),
    (v.prototype.on = function (s, h, v, b) {
      var _, $, k, S;
      if (!s) throw TypeError("Invalid event type: " + s);
      if (
        ("function" == typeof h && ((b = v), (v = h), (h = null)),
        void 0 === b && (b = this.captureForType(s)),
        "function" != typeof v)
      )
        throw TypeError("Handler must be a type of Function");
      return (
        (_ = this.rootElement),
        ($ = this.listenerMap[b ? 1 : 0])[s] ||
          (_ && _.addEventListener(s, this.handle, b), ($[s] = [])),
        h
          ? /^[a-z]+$/i.test(h)
            ? ((S = h), (k = m))
            : /^#[a-z0-9\-_]+$/i.test(h)
              ? ((S = h.slice(1)), (k = y))
              : ((S = h), (k = Element.prototype.matches))
          : ((S = null), (k = g.bind(this))),
        $[s].push({
          selector: h,
          handler: v,
          matcher: k,
          matcherParam: S,
        }),
        this
      );
    }),
    (v.prototype.off = function (s, h, v, m) {
      var g, y, b, _, $;
      if (
        ("function" == typeof h && ((m = v), (v = h), (h = null)), void 0 === m)
      )
        return (this.off(s, h, v, !0), this.off(s, h, v, !1), this);
      if (((b = this.listenerMap[m ? 1 : 0]), !s)) {
        for ($ in b) b.hasOwnProperty($) && this.off($, h, v);
        return this;
      }
      if (!(_ = b[s]) || !_.length) return this;
      for (g = _.length - 1; g >= 0; g--)
        ((y = _[g]),
          (h && h !== y.selector) ||
            (v && v !== y.handler) ||
            (this._removedListeners.push(y), _.splice(g, 1)));
      return (
        !_.length &&
          (delete b[s],
          this.rootElement &&
            this.rootElement.removeEventListener(s, this.handle, m)),
        this
      );
    }),
    (v.prototype.handle = function (s) {
      var h,
        v,
        m,
        g,
        y,
        b,
        _,
        $,
        k = s.type,
        S = [],
        E = "ftLabsDelegateIgnore";
      if (!0 !== s[E]) {
        switch (
          (3 === (_ = s.target).nodeType && (_ = _.parentNode),
          _.correspondingUseElement && (_ = _.correspondingUseElement),
          (m = this.rootElement),
          (g = s.eventPhase || (s.target !== s.currentTarget ? 3 : 2)))
        ) {
          case 1:
            S = this.listenerMap[1][k];
            break;
          case 2:
            (this.listenerMap[0] &&
              this.listenerMap[0][k] &&
              (S = S.concat(this.listenerMap[0][k])),
              this.listenerMap[1] &&
                this.listenerMap[1][k] &&
                (S = S.concat(this.listenerMap[1][k])));
            break;
          case 3:
            S = this.listenerMap[0][k];
        }
        var T = [];
        for (v = S.length; _ && v; ) {
          for (h = 0; h < v && (y = S[h]); h++)
            _.tagName &&
            ["button", "input", "select", "textarea"].indexOf(
              _.tagName.toLowerCase(),
            ) > -1 &&
            _.hasAttribute("disabled")
              ? (T = [])
              : y.matcher.call(_, y.matcherParam, _) && T.push([s, _, y]);
          if (
            _ === m ||
            ((v = S.length),
            (_ = _.parentElement || _.parentNode) instanceof HTMLDocument)
          )
            break;
        }
        for (h = 0; h < T.length; h++)
          if (
            !(this._removedListeners.indexOf(T[h][2]) > -1) &&
            !1 === (b = this.fire.apply(this, T[h]))
          ) {
            ((T[h][0][E] = !0), T[h][0].preventDefault(), ($ = !1));
            break;
          }
        return $;
      }
    }),
    (v.prototype.fire = function (s, h, v) {
      return v.handler.call(h, s, h);
    }),
    (v.prototype.destroy = function () {
      (this.off(), this.root());
    }),
    (h.default = v),
    (s.exports = h.default));
})(browser, browser.exports);
var Delegate = getDefaultExportFromCjs(browser.exports),
  pageTransition = function () {
    var s = document.querySelector("#page-transition-overlay");
    s &&
      (s.classList.remove("skip-transition"),
      setTimeout(function () {
        s.classList.remove("active");
      }, 0),
      setTimeout(function () {
        s.classList.remove("active");
      }, 200),
      new Delegate(document.body).on(
        "click",
        'a[href]:not([href^="#"]):not(.no-transition):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
        function h(v, m) {
          if (!v.ctrlKey && !v.metaKey) {
            v.preventDefault();
            var g = document.createElement("link");
            (g.setAttribute("rel", "prerender"),
              g.setAttribute("href", m.href),
              document.head.appendChild(g),
              setTimeout(function () {
                window.location.href = m.href;
              }, 200),
              s.classList.add("active"));
          }
        },
      ),
      (window.onpageshow = function (h) {
        h.persisted && s.classList.remove("active");
      }));
  },
  candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details",
  ],
  candidateSelector = candidateSelectors.join(","),
  matches =
    "undefined" == typeof Element
      ? function () {}
      : Element.prototype.matches ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector,
  getCandidates = function s(h, v, m) {
    var g = Array.prototype.slice.apply(h.querySelectorAll(candidateSelector));
    return (
      v && matches.call(h, candidateSelector) && g.unshift(h),
      (g = g.filter(m))
    );
  },
  isContentEditable = function s(h) {
    return "true" === h.contentEditable;
  },
  getTabindex = function s(h) {
    var v = parseInt(h.getAttribute("tabindex"), 10);
    return isNaN(v)
      ? isContentEditable(h) ||
        (("AUDIO" === h.nodeName ||
          "VIDEO" === h.nodeName ||
          "DETAILS" === h.nodeName) &&
          null === h.getAttribute("tabindex"))
        ? 0
        : h.tabIndex
      : v;
  },
  sortOrderedTabbables = function s(h, v) {
    return h.tabIndex === v.tabIndex
      ? h.documentOrder - v.documentOrder
      : h.tabIndex - v.tabIndex;
  },
  isInput = function s(h) {
    return "INPUT" === h.tagName;
  },
  isHiddenInput = function s(h) {
    return isInput(h) && "hidden" === h.type;
  },
  isDetailsWithSummary = function s(h) {
    return (
      "DETAILS" === h.tagName &&
      Array.prototype.slice.apply(h.children).some(function (s) {
        return "SUMMARY" === s.tagName;
      })
    );
  },
  getCheckedRadio = function s(h, v) {
    for (var m = 0; m < h.length; m++)
      if (h[m].checked && h[m].form === v) return h[m];
  },
  isTabbableRadio = function s(h) {
    if (!h.name) return !0;
    var v,
      m = h.form || h.ownerDocument,
      g = function s(h) {
        return m.querySelectorAll('input[type="radio"][name="' + h + '"]');
      };
    if (
      "undefined" != typeof window &&
      void 0 !== window.CSS &&
      "function" == typeof window.CSS.escape
    )
      v = g(window.CSS.escape(h.name));
    else
      try {
        v = g(h.name);
      } catch (y) {
        return (
          console.error(
            "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
            y.message,
          ),
          !1
        );
      }
    var b = getCheckedRadio(v, h.form);
    return !b || b === h;
  },
  isRadio = function s(h) {
    return isInput(h) && "radio" === h.type;
  },
  isNonTabbableRadio = function s(h) {
    return isRadio(h) && !isTabbableRadio(h);
  },
  isHidden = function s(h, v) {
    if ("hidden" === getComputedStyle(h).visibility) return !0;
    var m = matches.call(h, "details>summary:first-of-type")
      ? h.parentElement
      : h;
    if (matches.call(m, "details:not([open]) *")) return !0;
    if (v && "full" !== v) {
      if ("non-zero-area" === v) {
        var g = h.getBoundingClientRect(),
          y = g.width,
          b = g.height;
        return 0 === y && 0 === b;
      }
    } else
      for (; h; ) {
        if ("none" === getComputedStyle(h).display) return !0;
        h = h.parentElement;
      }
    return !1;
  },
  isDisabledFromFieldset = function s(h) {
    if (
      isInput(h) ||
      "SELECT" === h.tagName ||
      "TEXTAREA" === h.tagName ||
      "BUTTON" === h.tagName
    )
      for (var v = h.parentElement; v; ) {
        if ("FIELDSET" === v.tagName && v.disabled) {
          for (var m = 0; m < v.children.length; m++) {
            var g = v.children.item(m);
            if ("LEGEND" === g.tagName) {
              if (g.contains(h)) return !1;
              break;
            }
          }
          return !0;
        }
        v = v.parentElement;
      }
    return !1;
  },
  isNodeMatchingSelectorFocusable = function s(h, v) {
    return !(
      v.disabled ||
      isHiddenInput(v) ||
      isHidden(v, h.displayCheck) ||
      isDetailsWithSummary(v) ||
      isDisabledFromFieldset(v)
    );
  },
  isNodeMatchingSelectorTabbable = function s(h, v) {
    return !(
      !isNodeMatchingSelectorFocusable(h, v) ||
      isNonTabbableRadio(v) ||
      0 > getTabindex(v)
    );
  },
  tabbable = function s(h, v) {
    var m = [],
      g = [];
    return (
      getCandidates(
        h,
        (v = v || {}).includeContainer,
        isNodeMatchingSelectorTabbable.bind(null, v),
      ).forEach(function (s, h) {
        var v = getTabindex(s);
        0 === v
          ? m.push(s)
          : g.push({
              documentOrder: h,
              tabIndex: v,
              node: s,
            });
      }),
      g
        .sort(sortOrderedTabbables)
        .map(function (s) {
          return s.node;
        })
        .concat(m)
    );
  },
  focusableCandidateSelector = candidateSelectors.concat("iframe").join(","),
  isFocusable = function s(h, v) {
    if (((v = v || {}), !h)) throw Error("No node provided");
    return (
      !1 !== matches.call(h, focusableCandidateSelector) &&
      isNodeMatchingSelectorFocusable(v, h)
    );
  };
/*!
 * focus-trap 6.7.1
 * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
 */
function ownKeys(s, h) {
  var v = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var m = Object.getOwnPropertySymbols(s);
    (h &&
      (m = m.filter(function (h) {
        return Object.getOwnPropertyDescriptor(s, h).enumerable;
      })),
      v.push.apply(v, m));
  }
  return v;
}

function _objectSpread2(s) {
  for (var h = 1; h < arguments.length; h++) {
    var v = null != arguments[h] ? arguments[h] : {};
    h % 2
      ? ownKeys(Object(v), !0).forEach(function (h) {
          _defineProperty(s, h, v[h]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(v))
        : ownKeys(Object(v)).forEach(function (h) {
            Object.defineProperty(s, h, Object.getOwnPropertyDescriptor(v, h));
          });
  }
  return s;
}

function _defineProperty(s, h, v) {
  return (
    h in s
      ? Object.defineProperty(s, h, {
          value: v,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (s[h] = v),
    s
  );
}
var activeFocusTraps = (function () {
    var s = [];
    return {
      activateTrap: function h(v) {
        if (s.length > 0) {
          var m = s[s.length - 1];
          m !== v && m.pause();
        }
        var g = s.indexOf(v);
        (-1 === g || s.splice(g, 1), s.push(v));
      },
      deactivateTrap: function h(v) {
        var m = s.indexOf(v);
        (-1 !== m && s.splice(m, 1), s.length > 0 && s[s.length - 1].unpause());
      },
    };
  })(),
  isSelectableInput = function s(h) {
    return (
      h.tagName &&
      "input" === h.tagName.toLowerCase() &&
      "function" == typeof h.select
    );
  },
  isEscapeEvent = function s(h) {
    return "Escape" === h.key || "Esc" === h.key || 27 === h.keyCode;
  },
  isTabEvent = function s(h) {
    return "Tab" === h.key || 9 === h.keyCode;
  },
  delay = function s(h) {
    return setTimeout(h, 0);
  },
  findIndex = function s(h, v) {
    var m = -1;
    return (
      h.every(function (s, h) {
        return !v(s) || ((m = h), !1);
      }),
      m
    );
  },
  valueOrHandler = function s(h) {
    for (
      var v = arguments.length, m = Array(v > 1 ? v - 1 : 0), g = 1;
      g < v;
      g++
    )
      m[g - 1] = arguments[g];
    return "function" == typeof h ? h.apply(void 0, m) : h;
  },
  getActualTarget = function s(h) {
    return h.target.shadowRoot && "function" == typeof h.composedPath
      ? h.composedPath()[0]
      : h.target;
  },
  createFocusTrap = function s(h, v) {
    var m,
      g = (null == v ? void 0 : v.document) || document,
      y = _objectSpread2(
        {
          returnFocusOnDeactivate: !0,
          escapeDeactivates: !0,
          delayInitialFocus: !0,
        },
        v,
      ),
      b = {
        containers: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0,
      },
      _ = function s(h, v, m) {
        return h && void 0 !== h[v] ? h[v] : y[m || v];
      },
      $ = function s(h) {
        return !!(
          h &&
          b.containers.some(function (s) {
            return s.contains(h);
          })
        );
      },
      k = function s(h) {
        var v = y[h];
        if ("function" == typeof v) {
          for (
            var m = arguments.length, b = Array(m > 1 ? m - 1 : 0), _ = 1;
            _ < m;
            _++
          )
            b[_ - 1] = arguments[_];
          v = v.apply(void 0, b);
        }
        if (!v) {
          if (void 0 === v || !1 === v) return v;
          throw Error(
            "`".concat(
              h,
              "` was specified but was not a node, or did not return a node",
            ),
          );
        }
        var $ = v;
        if ("string" == typeof v && !($ = g.querySelector(v)))
          throw Error("`".concat(h, "` as selector refers to no known node"));
        return $;
      },
      S = function s() {
        var h = k("initialFocus");
        if (!1 === h) return !1;
        if (void 0 === h) {
          if ($(g.activeElement)) h = g.activeElement;
          else {
            var v = b.tabbableGroups[0];
            h = (v && v.firstTabbableNode) || k("fallbackFocus");
          }
        }
        if (!h)
          throw Error(
            "Your focus-trap needs to have at least one focusable element",
          );
        return h;
      },
      E = function s() {
        if (
          ((b.tabbableGroups = b.containers
            .map(function (s) {
              var h = tabbable(s);
              if (h.length > 0)
                return {
                  container: s,
                  firstTabbableNode: h[0],
                  lastTabbableNode: h[h.length - 1],
                };
            })
            .filter(function (s) {
              return !!s;
            })),
          b.tabbableGroups.length <= 0 && !k("fallbackFocus"))
        )
          throw Error(
            "Your focus-trap must have at least one container with at least one tabbable node in it at all times",
          );
      },
      T = function s(h) {
        if (!1 !== h && h !== g.activeElement) {
          if (!h || !h.focus) {
            s(S());
            return;
          }
          (h.focus({
            preventScroll: !!y.preventScroll,
          }),
            (b.mostRecentlyFocusedNode = h),
            isSelectableInput(h) && h.select());
        }
      },
      C = function s(h) {
        var v = k("setReturnFocus", h);
        return v || (!1 !== v && h);
      },
      I = function s(h) {
        var v = getActualTarget(h);
        if (!$(v)) {
          if (valueOrHandler(y.clickOutsideDeactivates, h)) {
            m.deactivate({
              returnFocus: y.returnFocusOnDeactivate && !isFocusable(v),
            });
            return;
          }
          !valueOrHandler(y.allowOutsideClick, h) && h.preventDefault();
        }
      },
      A = function s(h) {
        var v = getActualTarget(h),
          m = $(v);
        m || v instanceof Document
          ? m && (b.mostRecentlyFocusedNode = v)
          : (h.stopImmediatePropagation(), T(b.mostRecentlyFocusedNode || S()));
      },
      L = function s(h) {
        var v = getActualTarget(h);
        E();
        var m = null;
        if (b.tabbableGroups.length > 0) {
          var g = findIndex(b.tabbableGroups, function (s) {
            return s.container.contains(v);
          });
          if (g < 0)
            m = h.shiftKey
              ? b.tabbableGroups[b.tabbableGroups.length - 1].lastTabbableNode
              : b.tabbableGroups[0].firstTabbableNode;
          else if (h.shiftKey) {
            var y = findIndex(b.tabbableGroups, function (s) {
              return v === s.firstTabbableNode;
            });
            if (
              (y < 0 && b.tabbableGroups[g].container === v && (y = g), y >= 0)
            ) {
              var _ = 0 === y ? b.tabbableGroups.length - 1 : y - 1;
              m = b.tabbableGroups[_].lastTabbableNode;
            }
          } else {
            var $ = findIndex(b.tabbableGroups, function (s) {
              return v === s.lastTabbableNode;
            });
            if (
              ($ < 0 && b.tabbableGroups[g].container === v && ($ = g), $ >= 0)
            ) {
              var S = $ === b.tabbableGroups.length - 1 ? 0 : $ + 1;
              m = b.tabbableGroups[S].firstTabbableNode;
            }
          }
        } else m = k("fallbackFocus");
        m && (h.preventDefault(), T(m));
      },
      B = function s(h) {
        if (isEscapeEvent(h) && !1 !== valueOrHandler(y.escapeDeactivates, h)) {
          (h.preventDefault(), m.deactivate());
          return;
        }
        if (isTabEvent(h)) {
          L(h);
          return;
        }
      },
      P = function s(h) {
        if (!valueOrHandler(y.clickOutsideDeactivates, h)) {
          var v = getActualTarget(h);
          !($(v) || valueOrHandler(y.allowOutsideClick, h)) &&
            (h.preventDefault(), h.stopImmediatePropagation());
        }
      },
      x = function s() {
        if (b.active)
          return (
            activeFocusTraps.activateTrap(m),
            (b.delayInitialFocusTimer = y.delayInitialFocus
              ? delay(function () {
                  T(S());
                })
              : T(S())),
            g.addEventListener("focusin", A, !0),
            g.addEventListener("mousedown", I, {
              capture: !0,
              passive: !1,
            }),
            g.addEventListener("touchstart", I, {
              capture: !0,
              passive: !1,
            }),
            g.addEventListener("click", P, {
              capture: !0,
              passive: !1,
            }),
            g.addEventListener("keydown", B, {
              capture: !0,
              passive: !1,
            }),
            m
          );
      },
      M = function s() {
        if (b.active)
          return (
            g.removeEventListener("focusin", A, !0),
            g.removeEventListener("mousedown", I, !0),
            g.removeEventListener("touchstart", I, !0),
            g.removeEventListener("click", P, !0),
            g.removeEventListener("keydown", B, !0),
            m
          );
      };
    return (
      (m = {
        activate: function s(h) {
          if (b.active) return this;
          var v = _(h, "onActivate"),
            m = _(h, "onPostActivate"),
            y = _(h, "checkCanFocusTrap");
          (y || E(),
            (b.active = !0),
            (b.paused = !1),
            (b.nodeFocusedBeforeActivation = g.activeElement),
            v && v());
          var $ = function s() {
            (y && E(), x(), m && m());
          };
          return y ? (y(b.containers.concat()).then($, $), this) : ($(), this);
        },
        deactivate: function s(h) {
          if (!b.active) return this;
          (clearTimeout(b.delayInitialFocusTimer),
            (b.delayInitialFocusTimer = void 0),
            M(),
            (b.active = !1),
            (b.paused = !1),
            activeFocusTraps.deactivateTrap(m));
          var v = _(h, "onDeactivate"),
            g = _(h, "onPostDeactivate"),
            y = _(h, "checkCanReturnFocus");
          v && v();
          var $ = _(h, "returnFocus", "returnFocusOnDeactivate"),
            k = function s() {
              delay(function () {
                ($ && T(C(b.nodeFocusedBeforeActivation)), g && g());
              });
            };
          return $ && y
            ? (y(C(b.nodeFocusedBeforeActivation)).then(k, k), this)
            : (k(), this);
        },
        pause: function s() {
          return (b.paused || !b.active || ((b.paused = !0), M()), this);
        },
        unpause: function s() {
          return (b.paused && b.active && ((b.paused = !1), E(), x()), this);
        },
        updateContainerElements: function s(h) {
          var v = [].concat(h).filter(Boolean);
          return (
            (b.containers = v.map(function (s) {
              return "string" == typeof s ? g.querySelector(s) : s;
            })),
            b.active && E(),
            this
          );
        },
      }).updateContainerElements(h),
      m
    );
  };

function _toConsumableArray(s) {
  if (!Array.isArray(s)) return Array.from(s);
  for (var h = 0, v = Array(s.length); h < s.length; h++) v[h] = s[h];
  return v;
}
var hasPassiveEvents = !1;
if ("undefined" != typeof window) {
  var s = {
    get passive() {
      hasPassiveEvents = !0;
      return;
    },
  };
  (window.addEventListener("testPassive", null, s),
    window.removeEventListener("testPassive", null, s));
}
var isIosDevice =
    "undefined" != typeof window &&
    window.navigator &&
    window.navigator.platform &&
    (/iP(ad|hone|od)/.test(window.navigator.platform) ||
      ("MacIntel" === window.navigator.platform &&
        window.navigator.maxTouchPoints > 1)),
  locks = [],
  documentListenerAdded = !1,
  initialClientY = -1,
  previousBodyOverflowSetting = void 0,
  previousBodyPaddingRight = void 0,
  allowTouchMove = function s(h) {
    return locks.some(function (s) {
      return !!(s.options.allowTouchMove && s.options.allowTouchMove(h));
    });
  },
  preventDefault$1 = function s(h) {
    var v = h || window.event;
    return (
      !!allowTouchMove(v.target) ||
      v.touches.length > 1 ||
      (v.preventDefault && v.preventDefault(), !1)
    );
  },
  setOverflowHidden = function s(h) {
    if (void 0 === previousBodyPaddingRight) {
      var v = !!h && !0 === h.reserveScrollBarGap,
        m = window.innerWidth - document.documentElement.clientWidth;
      v &&
        m > 0 &&
        ((previousBodyPaddingRight = document.body.style.paddingRight),
        (document.body.style.paddingRight = m + "px"));
    }
    void 0 === previousBodyOverflowSetting &&
      ((previousBodyOverflowSetting = document.body.style.overflow),
      (document.body.style.overflow = "hidden"));
  },
  restoreOverflowSetting = function s() {
    (void 0 !== previousBodyPaddingRight &&
      ((document.body.style.paddingRight = previousBodyPaddingRight),
      (previousBodyPaddingRight = void 0)),
      void 0 !== previousBodyOverflowSetting &&
        ((document.body.style.overflow = previousBodyOverflowSetting),
        (previousBodyOverflowSetting = void 0)));
  },
  isTargetElementTotallyScrolled = function s(h) {
    return !!h && h.scrollHeight - h.scrollTop <= h.clientHeight;
  },
  handleScroll = function s(h, v) {
    var m = h.targetTouches[0].clientY - initialClientY;
    return (
      !allowTouchMove(h.target) &&
      ((v && 0 === v.scrollTop && m > 0) ||
      (isTargetElementTotallyScrolled(v) && m < 0)
        ? preventDefault$1(h)
        : (h.stopPropagation(), !0))
    );
  },
  disableBodyScroll = function s(h, v) {
    if (!h) {
      console.error(
        "disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.",
      );
      return;
    }
    !locks.some(function (s) {
      return s.targetElement === h;
    }) &&
      ((locks = [].concat(_toConsumableArray(locks), [
        {
          targetElement: h,
          options: v || {},
        },
      ])),
      isIosDevice
        ? ((h.ontouchstart = function (s) {
            1 === s.targetTouches.length &&
              (initialClientY = s.targetTouches[0].clientY);
          }),
          (h.ontouchmove = function (s) {
            1 === s.targetTouches.length && handleScroll(s, h);
          }),
          documentListenerAdded ||
            (document.addEventListener(
              "touchmove",
              preventDefault$1,
              hasPassiveEvents
                ? {
                    passive: !1,
                  }
                : void 0,
            ),
            (documentListenerAdded = !0)))
        : setOverflowHidden(v));
  },
  enableBodyScroll = function s(h) {
    if (!h) {
      console.error(
        "enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.",
      );
      return;
    }
    ((locks = locks.filter(function (s) {
      return s.targetElement !== h;
    })),
      isIosDevice
        ? ((h.ontouchstart = null),
          (h.ontouchmove = null),
          documentListenerAdded &&
            0 === locks.length &&
            (document.removeEventListener(
              "touchmove",
              preventDefault$1,
              hasPassiveEvents
                ? {
                    passive: !1,
                  }
                : void 0,
            ),
            (documentListenerAdded = !1)))
        : locks.length || restoreOverflowSetting());
  },
  n$1 = function (s) {
    var h;
    if ("object" != typeof (h = s) || Array.isArray(h))
      throw "state should be an object";
  },
  t$1 = function (s, h, v, m) {
    var g;
    return (g = s)
      .reduce(function (s, h, v) {
        return s.indexOf(h) > -1 ? s : s.concat(h);
      }, [])
      .reduce(function (s, v) {
        return s.concat(h[v] || []);
      }, [])
      .map(function (s) {
        return s(v, m);
      });
  },
  e$1 = a(),
  c = e$1.on,
  r$1 = e$1.emit,
  o$1 = e$1.hydrate;

function a(s) {
  void 0 === s && (s = {});
  var h = {};
  return {
    getState: function () {
      return Object.assign({}, s);
    },
    hydrate: function (v) {
      return (
        n$1(v),
        Object.assign(s, v),
        function () {
          t$1(["*"].concat(Object.keys(v)), h, s);
        }
      );
    },
    on: function (s, v) {
      return (
        (s = [].concat(s)).map(function (s) {
          return (h[s] = (h[s] || []).concat(v));
        }),
        function () {
          return s.map(function (s) {
            return h[s].splice(h[s].indexOf(v), 1);
          });
        }
      );
    },
    emit: function (v, m, g) {
      var y = ("*" === v ? [] : ["*"]).concat(v);
      ((m = "function" == typeof m ? m(s) : m) &&
        (n$1(m), Object.assign(s, m), (y = y.concat(Object.keys(m)))),
        t$1(y, h, s, g));
    },
  };
}

function wrapIframes() {
  var s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  s.forEach(function (s) {
    var h = document.createElement("div");
    (h.classList.add("rte__iframe"),
      s.parentNode.insertBefore(h, s),
      h.appendChild(s),
      (s.src = s.src));
  });
}

function wrapTables() {
  var s = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
  s.forEach(function (s) {
    var h = document.createElement("div");
    (h.classList.add("rte__table-wrapper"),
      (h.tabIndex = 0),
      s.parentNode.insertBefore(h, s),
      h.appendChild(s));
  });
}
var classes$F = {
    visible: "is-visible",
    active: "active",
    fixed: "is-fixed",
  },
  selectors$1G = {
    closeBtn: "[data-modal-close]",
    wash: ".modal__wash",
    modalContent: ".modal__content",
  },
  modal = function s(h) {
    var v = createFocusTrap(h, {
        allowOutsideClick: !0,
      }),
      m = n$2(selectors$1G.modalContent, h);
    new Delegate(document).on("click", selectors$1G.wash, function () {
      return _();
    });
    var g = [
        e$2(n$2(selectors$1G.closeBtn, h), "click", function (s) {
          (s.preventDefault(), _());
        }),
        e$2(h, "keydown", function (s) {
          27 === s.keyCode && _();
        }),
        c("modal:open", function (s, v) {
          var m = v.modalContent,
            g = v.narrow;
          (l(h, "modal--narrow", void 0 !== g && g), y(m), b());
        }),
      ],
      y = function s(h) {
        var v = h.cloneNode(!0);
        ((m.innerHTML = ""),
          m.appendChild(v),
          wrapIframes(t$2("iframe", m)),
          wrapTables(t$2("table", m)));
      },
      b = function s() {
        (u$1(h, classes$F.active),
          document.body.setAttribute("data-fluorescent-overlay-open", "true"),
          v.activate(),
          disableBodyScroll(h, {
            allowTouchMove: function s(h) {
              for (; h && h !== document.body; ) {
                if (null !== h.getAttribute("data-scroll-lock-ignore"))
                  return !0;
                h = h.parentNode;
              }
            },
            reserveScrollBarGap: !0,
          }));
      },
      _ = function s() {
        (v.deactivate(),
          i$1(h, classes$F.active),
          document.body.setAttribute("data-fluorescent-overlay-open", "false"),
          enableBodyScroll(h),
          setTimeout(function () {
            m.innerHTML = "";
          }, 300));
      };
    return {
      unload: function s() {
        g.forEach(function (s) {
          return s();
        });
      },
    };
  },
  AnimateProductItem = function (s) {
    var h = [];
    return (
      s.forEach(function (s) {
        var v = n$2(".product-item__image--one", s),
          m = n$2(".product-item__image--two", s);
        (t$2(".product-item-options__list", s),
          h.push(
            e$2(s, "mouseenter", function () {
              var s, h, g;
              ((s = v), (h = m), h && u$1(h, "active"));
            }),
          ),
          h.push(
            e$2(s, "mouseleave", function () {
              var s, h, g;
              ((s = v), (h = m), h && i$1(h, "active"));
            }),
          ));
      }),
      {
        destroy: function s() {
          h.forEach(function (s) {
            return s();
          });
        },
      }
    );
  };

function getMediaQuery(s) {
  var h = getComputedStyle(document.documentElement).getPropertyValue(
    "--media-".concat(s),
  );
  return h || (console.warn("Invalid querySize passed to getMediaQuery"), !1);
}
var intersectionWatcher = function (s) {
    var h = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
      v = window.matchMedia(getMediaQuery("above-720")).matches ? 200 : 100,
      m = 0;
    h || (m = Math.min(v / s.offsetHeight, 0.5));
    var g = new IntersectionObserver(
      function (h) {
        _slicedToArray(h, 1)[0].isIntersecting &&
          (u$1(s, "is-visible"), g.disconnect());
      },
      {
        threshold: m,
      },
    );
    return (
      g.observe(s),
      {
        destroy: function s() {
          null == g || g.disconnect();
        },
      }
    );
  },
  delayOffset = function (s, h) {
    var v = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
      m = v;
    h.forEach(function (h) {
      t$2(h, s).forEach(function (s) {
        (s.style.setProperty("--delay-offset-multiplier", m), m++);
      });
    });
  },
  sectionsBlocksToAnimate = {
    sectionBlockItems: ".animation--section-blocks",
  },
  animateGlobalSectionsBlocks = function (s) {
    delayOffset(s, [sectionsBlocksToAnimate.sectionBlockItems], 6);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  sectionsContainersToAnimate = [
    ".collection-category-sellection",
    ".about-us-quality",
    ".columns-teaser",
    ".company-numbers",
    ".gallery",
  ];
sectionsContainersToAnimate.forEach((s) => {
  let h = document.querySelectorAll(s);
  h &&
    h.length > 0 &&
    h.forEach((s) => {
      animateGlobalSectionsBlocks(s);
    });
});
var shouldAnimate = function (s) {
    return (
      a$1(s, "animation") &&
      !a$1(document.documentElement, "prefers-reduced-motion")
    );
  },
  selectors$1F = {
    sectionBlockItems: ".section-blocks > *",
    image: ".image-with-text__image .image__img",
    imageSmall: ".image-with-text__small-image .image__img",
    imageCaption: ".image-with-text__image-caption",
  },
  animateImageWithText = function (s) {
    (delayOffset(s, [
      selectors$1F.image,
      selectors$1F.imageSmall,
      selectors$1F.imageCaption,
    ]),
      delayOffset(s, [selectors$1F.sectionBlockItems], 6));
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1E = {
    sectionBlockItems: ".section-blocks > *",
    image: ".image-with-text-split__image .image__img",
  },
  animateImageWithTextSplit = function (s) {
    (delayOffset(s, [selectors$1E.image]),
      delayOffset(s, [selectors$1E.sectionBlockItems], 6));
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1D = {
    content: ".testimonials__item-content > *",
    image: ".testimonials__item-product-image",
    imageCaption: ".testimonials__item-product-title",
    item: ".animation--item",
  },
  classes$E = {
    imageRight: "testimonials__item--image-placement-right",
  },
  animateTestimonials = function (s) {
    var h = [];
    (a$1(s, classes$E.imageRight)
      ? (h.push(selectors$1D.content),
        h.push(selectors$1D.image),
        h.push(selectors$1D.imageCaption))
      : (h.push(selectors$1D.image),
        h.push(selectors$1D.imageCaption),
        h.push(selectors$1D.content)),
      delayOffset(s, h, 2),
      delayOffset(s, [selectors$1D.item]));
  },
  selectors$1C = {
    content: ".quote__item-inner > *",
  },
  animateQuotes = function (s) {
    delayOffset(s, [selectors$1C.content]);
  },
  selectors$1B = {
    sectionBlockItems: ".animation--section-introduction > *",
    controls: ".animation--controls",
    items: ".animation--item",
  },
  animateListSlider = function (s) {
    delayOffset(s, [
      selectors$1B.sectionBlockItems,
      selectors$1B.controls,
      selectors$1B.items,
    ]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1A = {
    introductionItems: ".section-introduction > *",
    media:
      ".complete-the-look__image-wrapper .image__img, .complete-the-look__image-wrapper .video",
    product: ".complete-the-look__product",
    products: ".complete-the-look__products",
  },
  classes$D = {
    imageLeft: "complete-the-look--image-left",
  },
  animateCompleteTheLook = function (s) {
    var h = [];
    (h.push(selectors$1A.introductionItems),
      a$1(s, classes$D.imageLeft) ||
      window.matchMedia(getMediaQuery("below-720")).matches
        ? (h.push(selectors$1A.media),
          h.push(selectors$1A.products),
          h.push(selectors$1A.product))
        : (h.push(selectors$1A.products),
          h.push(selectors$1A.product),
          h.push(selectors$1A.media)),
      delayOffset(s, h));
    var v = intersectionWatcher(s);
    return {
      destroy: function s() {
        v.destroy();
      },
    };
  },
  selectors$1z = {
    introductionItems: ".section-introduction > *",
    image: ".shoppable-image__image-wrapper .image__img",
    hotspots: ".shoppable-item__hotspot-wrapper",
  },
  animateShoppableImage = function (s) {
    delayOffset(s, [
      selectors$1z.introductionItems,
      selectors$1z.image,
      selectors$1z.hotspots,
    ]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        h.destroy();
      },
    };
  },
  selectors$1y = {
    introductionItems: ".section-introduction > *",
    carousel:
      ".shoppable-feature__secondary-content .shoppable-feature__carousel-outer",
    hotspots: ".shoppable-item__hotspot-wrapper",
    mobileDrawerItems:
      ".animation--shoppable-feature-mobile-drawer  .shoppable-feature__carousel-outer > *:not(.swiper-pagination)",
  },
  animateShoppableFeature = function (s) {
    (delayOffset(s, [selectors$1y.introductionItems, selectors$1y.carousel], 1),
      delayOffset(s, [selectors$1y.hotspots], 1),
      delayOffset(s, [selectors$1y.mobileDrawerItems], 1));
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        h.destroy();
      },
    };
  },
  selectors$1x = {
    textContent: ".image-hero-split-item__text-container-inner > *",
  },
  animateImageHeroSplit = function (s) {
    delayOffset(s, [selectors$1x.textContent], 1);
  },
  selectors$1w = {
    textContent: ".image-hero__text-container-inner > *",
  },
  animateImageHero = function (s) {
    delayOffset(s, [selectors$1w.textContent], 3);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  classes$C = {
    animation: "animation--image-compare",
  },
  selectors$1v = {
    introductionItems: ".animation--section-introduction > *",
    image: ".image_compare__image-wrapper .image__img",
    labels: ".image-compare__label-container",
    sliderLine: ".image-compare__slider-line",
    sliderButton: ".image-compare__slider-button",
  },
  animateImageCompare = function (s) {
    delayOffset(s, [
      selectors$1v.introductionItems,
      selectors$1v.image,
      selectors$1v.labels,
      selectors$1v.sliderLine,
      selectors$1v.sliderButton,
    ]);
    var h = Math.min(
        (window.matchMedia(getMediaQuery("above-720")).matches ? 200 : 100) /
          s.offsetHeight,
        0.5,
      ),
      v = new IntersectionObserver(
        function (h) {
          _slicedToArray(h, 1)[0].isIntersecting &&
            (u$1(s, "is-visible"),
            setTimeout(function () {
              i$1(s, classes$C.animation);
            }, 1200),
            v.disconnect());
        },
        {
          threshold: h,
        },
      );
    return (
      v.observe(s),
      {
        destroy: function s() {
          v.destroy();
        },
      }
    );
  },
  selectors$1u = {
    textContent: ".video__text-container > *",
  },
  animateVideo = function (s) {
    delayOffset(s, [selectors$1u.textContent], 3);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1t = {
    textContent: ".video-hero__text-container > *",
  },
  animateVideoHero = function (s) {
    delayOffset(s, [selectors$1t.textContent], 3);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1s = {
    articleHeading:
      "\n    .article__image-container,\n    .article__header-inner > *\n  ",
    articleContent: ".article__content",
  },
  animateArticle = function (s) {
    delayOffset(s, [selectors$1s.articleHeading, selectors$1s.articleContent]);
    var h = t$2(selectors$1s.articleHeading, s),
      v = n$2(selectors$1s.articleContent, s),
      m = h.map(function (s) {
        return intersectionWatcher(s);
      });
    return (
      m.push(intersectionWatcher(v)),
      {
        destroy: function s() {
          m.forEach(function (s) {
            return s.destroy();
          });
        },
      }
    );
  },
  selectors$1r = {
    image: ".collection-banner__image-container",
    content: ".collection-banner__text-container-inner > *",
  },
  animateCollectionBanner = function (s) {
    delayOffset(s, [selectors$1r.image, selectors$1r.content]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1q = {
    partial: "[data-partial]",
    filterBar: "[data-filter-bar]",
    mobileFilterBar: "[data-mobile-filters]",
    productItems: ".animation--item:not(.animation--item-revealed)",
  },
  classes$B = {
    hideProducts: "animation--collection-products-hide",
    itemRevealed: "animation--item-revealed",
  },
  animateCollection = function (s) {
    var h = n$2(selectors$1q.partial, s),
      v = n$2(selectors$1q.filterBar, s),
      m = n$2(selectors$1q.mobileFilterBar, s),
      g = null;
    v && (g = intersectionWatcher(v, !0));
    var y = null;

    function b() {
      var h = t$2(selectors$1q.productItems, s);
      (delayOffset(s, [selectors$1q.productItems]),
        setTimeout(function () {
          u$1(h, classes$B.itemRevealed);
        }, 0));
    }
    return (
      m && (y = intersectionWatcher(m, !0)),
      b(),
      {
        updateContents: function s() {
          var m;
          (b(),
            i$1(h, classes$B.hideProducts),
            (m =
              h.getBoundingClientRect().top +
              window.pageYOffset -
              v.getBoundingClientRect().height),
            window.scrollTo({
              top: m,
              behavior: "smooth",
            }));
        },
        infiniteScrollReveal: function s() {
          b();
        },
        destroy: function s() {
          var h, v;
          (null === (h = g) || void 0 === h || h.destroy(),
            null === (v = y) || void 0 === v || v.destroy());
        },
      }
    );
  },
  selectors$1p = {
    saleAmount: ".animation--sale-amount",
    sectionBlockItems: ".animation--section-blocks > *",
    saleItems:
      ".sale-promotion .sale-promotion__type,\n  .sale-promotion .sale-promotion__unit-currency,\n  .sale-promotion .sale-promotion__unit-percent,\n  .sale-promotion .sale-promotion__unit-off,\n  .sale-promotion .sale-promotion__amount,\n  .sale-promotion .sale-promotion__per-month,\n  .sale-promotion .sale-promotion__per-year,\n  .sale-promotion .sale-promotion__terms,\n  .sale-promotion .sales-banner__button",
  },
  animateSalesBanner = function (s) {
    var h = [selectors$1p.saleAmount, selectors$1p.saleItems],
      v = [selectors$1p.sectionBlockItems];
    (delayOffset(s, h), delayOffset(s, v, 1));
    var m = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == m || m.destroy();
      },
    };
  },
  selectors$1o = {
    sectionBlockItems: ".section-blocks > *",
  },
  animateCountdownBanner = function (s) {
    var h = intersectionWatcher(s);
    return (
      delayOffset(s, [selectors$1o.sectionBlockItems]),
      {
        destroy: function s() {
          null == h || h.destroy();
        },
      }
    );
  },
  selectors$1n = {
    items:
      "\n  .sales-banner__bar-item--heading,\n  .sales-banner__bar-text,\n  .sales-banner__button,\n  .countdown-banner__bar-item--heading,\n  .countdown-banner__bar-item--timer,\n  .countdown-banner__bar-text,\n  .countdown-banner__button",
  },
  animateCountdownBar = function (s) {
    var h = intersectionWatcher(s);
    return (
      delayOffset(s, [selectors$1n.items]),
      {
        destroy: function s() {
          null == h || h.destroy();
        },
      }
    );
  },
  animatePromotionBar = function (s) {
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1m = {
    headerItems: ".animation--blog-header > *",
    articleItem: ".article-item",
    pagination: ".blog__pagination",
  },
  animateBlog = function (s) {
    delayOffset(s, [
      selectors$1m.headerItems,
      selectors$1m.articleItem,
      selectors$1m.pagination,
    ]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1l = {
    flyouts: "[data-filter-modal]",
    animationFilterDrawerItem: ".animation--filter-drawer-item",
  },
  classes$A = {
    animationRevealed: "animation--filter-bar-revealed",
    animationFilterDrawerItem: "animation--filter-drawer-item",
  },
  animateFilterDrawer = function (s) {
    return (
      t$2(selectors$1l.flyouts, s).forEach(function s(h) {
        delayOffset(h, [selectors$1l.animationFilterDrawerItem]);
      }),
      {
        open: function s(h) {
          u$1(h, classes$A.animationRevealed);
        },
        close: function s(h) {
          i$1(h, classes$A.animationRevealed);
        },
      }
    );
  },
  selectors$1k = {
    animationItem: ".animation--drawer-menu-item",
  },
  classes$z = {
    animationRevealed: "animation--drawer-menu-revealed",
  },
  animateDrawerMenu = function (s) {
    return (
      delayOffset(s, [selectors$1k.animationItem]),
      {
        open: function h() {
          shouldAnimate(s) && u$1(s, classes$z.animationRevealed);
        },
        close: function h() {
          shouldAnimate(s) && i$1(s, classes$z.animationRevealed);
        },
      }
    );
  },
  selectors$1j = {
    animationItem:
      ".animation--quick-cart-items > *, .animation--quick-cart-footer",
  },
  classes$y = {
    animationRevealed: "animation--quick-cart-revealed",
  },
  animateQuickCart = function (s) {
    function h() {
      delayOffset(s, [selectors$1j.animationItem]);
    }
    return (
      h(),
      {
        open: function h() {
          u$1(s, classes$y.animationRevealed);
        },
        close: function h() {
          i$1(s, classes$y.animationRevealed);
        },
        setup: h,
      }
    );
  },
  selectors$1i = {
    animationItems: ".animation--quick-view-items > *",
  },
  classes$x = {
    animationRevealed: "animation--quick-view-revealed",
  },
  animateQuickView = function (s) {
    return {
      animate: function h() {
        (delayOffset(s, [selectors$1i.animationItems]),
          setTimeout(function () {
            u$1(s, classes$x.animationRevealed);
          }, 0));
      },
      reset: function h() {
        i$1(s, classes$x.animationRevealed);
      },
    };
  },
  selectors$1h = {
    columns: ".meganav__list-parent > li",
    image: ".meganav__promo-image .image__img",
    overlay: ".meganav__secondary-promo-overlay",
    promoItems: ".meganav__secondary-promo-text > *",
    hasPromo: "meganav--has-promo",
    promoLeft: "meganav--promo-position-left",
  },
  animateMeganav = function (s) {
    var h = t$2(selectors$1h.columns, s);

    function v(s) {
      var h,
        v = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      s.forEach(function (s, m) {
        var g = s.getBoundingClientRect
          ? s.getBoundingClientRect().left
          : s.offsetLeft;
        (0 === m && (h = g),
          h != g && ((h = g), v++),
          s.style.setProperty("--delay-offset-multiplier", v));
      });
    }
    (a$1(s, selectors$1h.hasPromo)
      ? (delayOffset(s, [
          selectors$1h.image,
          selectors$1h.overlay,
          selectors$1h.promoItems,
        ]),
        a$1(s, selectors$1h.promoLeft) ? v(h, 4) : v(h))
      : v(h),
      delayOffset(s, []));
  },
  selectors$1g = {
    heading: ".list-collections__heading",
    productItems: ".animation--item",
  },
  animateListCollections = function (s) {
    delayOffset(s, [selectors$1g.heading, selectors$1g.productItems]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        h.destroy();
      },
    };
  },
  selectors$1f = {
    gridItems: ".grid-item",
  },
  animateGrid = function (s) {
    delayOffset(s, [selectors$1f.gridItems]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        h.destroy();
      },
    };
  },
  selectors$1e = {
    animationItems: ".animation--purchase-confirmation-item",
    animationFooterItems: ".animation--purchase-confirmation-footer-item",
  },
  classes$w = {
    animationRevealed: "animation--purchase-confirmation-revealed",
  },
  animatePurchaseConfirmation = function (s) {
    return {
      animate: function h() {
        (delayOffset(s, [selectors$1e.animationItems]),
          delayOffset(s, [selectors$1e.animationFooterItems]),
          setTimeout(function () {
            u$1(s, classes$w.animationRevealed);
          }, 0));
      },
      reset: function h() {
        i$1(s, classes$w.animationRevealed);
      },
    };
  },
  selectors$1d = {
    pageItems: ".page-section__inner > *",
  },
  animatePage = function (s) {
    delayOffset(s, [selectors$1d.pageItems]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        h.forEach(function (s) {
          return s.destroy();
        });
      },
    };
  },
  selectors$1c = {
    items: ".collapsible-row-list__inner > *",
  },
  animateCollapsibleRowList = function (s) {
    delayOffset(s, [selectors$1c.items]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1b = {
    items: ".animation--section-blocks > *",
  },
  animateRichText = function (s) {
    delayOffset(s, [selectors$1b.items]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$1a = {
    headerItems: ".animation--section-introduction > *",
    articleItem: ".article-item",
  },
  animateBlogPosts = function (s) {
    delayOffset(s, [selectors$1a.headerItems, selectors$1a.articleItem]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$19 = {
    intro: ".animation--section-introduction > *",
    items: ".animation--item",
  },
  animateFeaturedCollectionGrid = function (s) {
    delayOffset(s, [selectors$19.intro, selectors$19.items]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$18 = {
    productItems: ".animation--item",
    introductionItems: ".animation--section-introduction > *",
  },
  animateCollectionListGrid = function (s) {
    delayOffset(s, [selectors$18.introductionItems, selectors$18.productItems]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$17 = {
    animationItems: ".animation--store-availability-drawer-items > *",
  },
  classes$v = {
    animationRevealed: "animation--store-availability-drawer-revealed",
  },
  animateStoreAvailabilityDrawer = function (s) {
    return {
      animate: function h() {
        (t$2(selectors$17.animationItems, s).forEach(function (s, h) {
          s.style.setProperty("--position-offset-multiplier", h);
        }),
          setTimeout(function () {
            u$1(s, classes$v.animationRevealed);
          }, 0));
      },
      reset: function h() {
        i$1(s, classes$v.animationRevealed);
      },
    };
  },
  selectors$16 = {
    media: ".animation--product-media",
  },
  animateProduct = function (s) {
    delayOffset(s, [selectors$16.media]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$15 = {
    headerItems: ".animation--section-introduction > *",
    animationItem: ".animation--item",
  },
  animateContactForm = function (s) {
    delayOffset(s, [selectors$15.headerItems, selectors$15.animationItem]);
    var h = intersectionWatcher(s, !0);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$14 = {
    partial: "[data-partial]",
    filterBar: "[data-filter-bar]",
    mobileFilterBar: "[data-mobile-filters]",
    productItems: ".animation--item:not(.animation--item-revealed)",
  },
  classes$u = {
    hideProducts: "animation--search-products-hide",
    itemRevealed: "animation--item-revealed",
  },
  animateSearch = function (s) {
    var h = n$2(selectors$14.partial, s),
      v = n$2(selectors$14.filterBar, s),
      m = n$2(selectors$14.mobileFilterBar, s),
      g = null;
    v && (g = intersectionWatcher(v, !0));
    var y = null;

    function b() {
      var h = t$2(selectors$14.productItems, s);
      (delayOffset(s, [selectors$14.productItems]),
        setTimeout(function () {
          u$1(h, classes$u.itemRevealed);
        }, 0));
    }
    return (
      m && (y = intersectionWatcher(m, !0)),
      b(),
      {
        updateContents: function s() {
          var m;
          (b(),
            i$1(h, classes$u.hideProducts),
            (m =
              h.getBoundingClientRect().top +
              window.pageYOffset -
              v.getBoundingClientRect().height),
            window.scrollTo({
              top: m,
              behavior: "smooth",
            }));
        },
        infiniteScrollReveal: function s() {
          b();
        },
        destroy: function s() {
          var h, v;
          (null === (h = g) || void 0 === h || h.destroy(),
            null === (v = y) || void 0 === v || v.destroy());
        },
      }
    );
  },
  selectors$13 = {
    content: ".animation--section-blocks > *",
  },
  animateSearchBanner = function (s) {
    delayOffset(s, [selectors$13.content]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$12 = {
    headerItems: ".animation--section-introduction > *",
    columnItems: ".multi-column__grid-item",
  },
  animateMultiColumn = function (s) {
    delayOffset(s, [selectors$12.headerItems, selectors$12.columnItems]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        h.destroy();
      },
    };
  },
  selectors$11 = {
    textContent: ".password__text-container-inner > *",
  },
  animatePassword = function (s) {
    delayOffset(s, [selectors$11.textContent], 3);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$10 = {
    animationItem: ".animation--popup-item",
  },
  classes$t = {
    animationRevealed: "animation--popup-revealed",
  },
  animatePopup = function (s) {
    return (
      delayOffset(s, [selectors$10.animationItem]),
      {
        open: function h() {
          shouldAnimate(s) && u$1(s, classes$t.animationRevealed);
        },
        close: function h() {
          shouldAnimate(s) && i$1(s, classes$t.animationRevealed);
        },
      }
    );
  },
  selectors$$ = {
    items: ".animation--section-blocks > *",
  },
  selectors$Z = {
    headerItems: ".animation--section-introduction > *",
    eventItems: ".event-item",
  },
  animateEvents = function (s) {
    delayOffset(s, [selectors$Z.headerItems]);
    var h = intersectionWatcher(s, !0);
    return {
      animateEventItems: function h() {
        (delayOffset(s, [selectors$Z.eventItems]),
          setTimeout(function () {
            u$1(s, "animate-event-items");
          }, 50));
      },
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$Y = {
    giantHeading: ".animation--giant-heading",
    sectionBlockItems: ".animation--section-blocks > *",
  },
  animatePromoBanner = function (s) {
    delayOffset(s, [selectors$Y.giantHeading, selectors$Y.sectionBlockItems]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$X = {
    controls: ".product-tabs__tab-buttons",
    items: ".product-tabs__tab-list-wrapper",
    accordionItems: ".accordion",
  },
  animateProductTabs = function (s) {
    (delayOffset(s, [selectors$X.controls, selectors$X.items]),
      delayOffset(s, [selectors$X.accordionItems]));
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  },
  selectors$W = {
    intro: ".animation--section-introduction > *",
    items: ".animation--item",
  },
  animateApps = function (s) {
    delayOffset(s, [selectors$W.intro, selectors$W.items]);
    var h = intersectionWatcher(s);
    return {
      destroy: function s() {
        null == h || h.destroy();
      },
    };
  };

function makeRequest(s, h) {
  return new Promise(function (v, m) {
    var g = new XMLHttpRequest();
    (g.open(s, h),
      (g.onload = function () {
        this.status >= 200 && this.status < 300
          ? v(g.response)
          : m(Error(this.status));
      }),
      (g.onerror = function () {
        m(Error(this.status));
      }),
      g.send());
  });
}
var classes$s = {
    active: "active",
  },
  selectors$V = {
    drawerTrigger: "[data-store-availability-drawer-trigger]",
    closeBtn: "[data-store-availability-close]",
    productTitle: "[data-store-availability-product-title]",
    variantTitle: "[data-store-availability-variant-title]",
    storeListContainer: "[data-store-list-container]",
    storeListContent: "[data-store-availability-list-content]",
    wash: "[data-store-availability-drawer-wash]",
    parentWrapper: "[data-store-availability-container]",
  },
  storeAvailabilityDrawer = function s(h) {
    var v = createFocusTrap(h, {
        allowOutsideClick: !0,
      }),
      m = n$2(selectors$V.wash, h.parentNode),
      g = n$2(selectors$V.productTitle),
      y = n$2(selectors$V.variantTitle),
      b = n$2(selectors$V.storeListContainer, h),
      _ = null;
    shouldAnimate(h) && (_ = animateStoreAvailabilityDrawer(h));
    var $ = [
        e$2([n$2(selectors$V.closeBtn, h), m], "click", function (s) {
          (s.preventDefault(), E());
        }),
        e$2(h, "keydown", function (s) {
          27 === s.keyCode && E();
        }),
      ],
      k = function s(h) {
        var v = h.closest(selectors$V.parentWrapper).dataset,
          m = v.baseUrl,
          _ = v.variantId,
          $ = v.productTitle,
          k = v.variantTitle;
        makeRequest(
          "GET",
          ""
            .concat(m, "/variants/")
            .concat(_, "/?section_id=store-availability"),
        )
          .then(function (s) {
            var h = document.createElement("div");
            ((h.innerHTML = s),
              (g.innerText = $),
              (y.innerText = "null" === k ? "" : k));
            var v = n$2(selectors$V.storeListContent, h);
            ((b.innerHTML = ""), b.appendChild(v));
          })
          .then(S);
      },
      S = function s() {
        (u$1(h, classes$s.active),
          shouldAnimate(h) && _.animate(),
          h.setAttribute("aria-hidden", "false"),
          v.activate(),
          document.body.setAttribute("data-fluorescent-overlay-open", "true"),
          disableBodyScroll(h, {
            allowTouchMove: function s(h) {
              for (; h && h !== document.body; ) {
                if (null !== h.getAttribute("data-scroll-lock-ignore"))
                  return !0;
                h = h.parentNode;
              }
            },
            reserveScrollBarGap: !0,
          }));
      },
      E = function s() {
        (v.deactivate(),
          i$1(h, classes$s.active),
          h.setAttribute("aria-hidden", "true"),
          setTimeout(function () {
            (shouldAnimate(h) && _.reset(),
              document.body.setAttribute(
                "data-fluorescent-overlay-open",
                "false",
              ),
              enableBodyScroll(h));
          }, 500));
      };
    return (
      new Delegate(document.body).on(
        "click",
        selectors$V.drawerTrigger,
        function (s, h) {
          return k(h);
        },
      ),
      {
        unload: function s() {
          $.forEach(function (s) {
            return s();
          });
        },
      }
    );
  },
  strings$7 = window.theme.strings.accessibility,
  handleTab = function s() {
    var h = null,
      v = ["INPUT", "TEXTAREA", "SELECT"];

    function m(s) {
      9 !== s.keyCode ||
        v.includes(document.activeElement.tagName) ||
        (document.body.classList.add("user-is-tabbing"),
        h(),
        (h = e$2(window, "mousedown", g)));
    }

    function g() {
      (document.body.classList.remove("user-is-tabbing"),
        h(),
        (h = e$2(window, "keydown", m)));
    }
    h = e$2(window, "keydown", m);
  },
  focusFormStatus = function s(h) {
    var v = n$2(".form-status", h);
    if (v) {
      var m = n$2("[data-form-status]", v);
      m && m.focus();
    }
  },
  prefersReducedMotion = function s() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  };

function backgroundVideoHandler(s) {
  var h = n$2(".video-pause", s),
    v = s.getElementsByTagName("VIDEO")[0];
  if (h && v) {
    var m = function s() {
        (v.pause(), (h.innerText = strings$7.play_video));
      },
      g = function s() {
        (v.play(), (h.innerText = strings$7.pause_video));
      };
    prefersReducedMotion() && m();
    var y = e$2(h, "click", function (s) {
      (s.preventDefault(), v.paused ? g() : m());
    });
    return function () {
      return y();
    };
  }
}
var classes$r = {
    hidden: "hidden",
  },
  sectionClasses = function () {
    function s() {
      t$2(".main .shopify-section").forEach(function (s) {
        var h = s.firstElementChild;
        h && h.classList.contains(classes$r.hidden) && u$1(s, classes$r.hidden);
      });
    }
    (s(), e$2(document, "shopify:section:load", s));
  },
  dispatchCustomEvent = function s(h) {
    var v = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      m = new CustomEvent(
        h,
        v
          ? {
              detail: v,
            }
          : null,
      );
    document.dispatchEvent(m);
  };

function getVariantFromId(s, h) {
  if ((_validateProductStructure(s), "number" != typeof h))
    throw TypeError(h + " is not a Number.");
  return (
    s.variants.filter(function (s) {
      return s.id === h;
    })[0] || null
  );
}

function getVariantFromSerializedArray(s, h) {
  _validateProductStructure(s);
  var v = _createOptionArrayFromOptionCollection(s, h);
  return getVariantFromOptionArray(s, v);
}

function getVariantFromOptionArray(s, h) {
  return (
    _validateProductStructure(s),
    _validateOptionsArray(h),
    s.variants.filter(function (s) {
      return h.every(function (h, v) {
        return s.options[v] === h;
      });
    })[0] || null
  );
}

function _createOptionArrayFromOptionCollection(s, h) {
  (_validateProductStructure(s), _validateSerializedArray(h));
  var v = [];
  return (
    h.forEach(function (h) {
      for (var m = 0; m < s.options.length; m++)
        if (s.options[m].name.toLowerCase() === h.name.toLowerCase()) {
          v[m] = h.value;
          break;
        }
    }),
    v
  );
}

function _validateProductStructure(s) {
  if ("object" != typeof s) throw TypeError(s + " is not an object.");
  if (0 === Object.keys(s).length && s.constructor === Object)
    throw Error(s + " is empty.");
}

function _validateSerializedArray(s) {
  if (!Array.isArray(s)) throw TypeError(s + " is not an array.");
  if (0 === s.length) return [];
  if (s[0].hasOwnProperty("name")) {
    if ("string" != typeof s[0].name)
      throw TypeError(
        "Invalid value type passed for name of option " +
          s[0].name +
          ". Value should be string.",
      );
  } else throw Error(s[0] + "does not contain name key.");
}

function _validateOptionsArray(s) {
  if (Array.isArray(s) && "object" == typeof s[0])
    throw Error(s + "is not a valid array of options.");
}

function getUrlWithVariant(s, h) {
  return /variant=/.test(s)
    ? s.replace(/(variant=)[^&]+/, "$1" + h)
    : /\?/.test(s)
      ? s.concat("&variant=").concat(h)
      : s.concat("?variant=").concat(h);
}
var selectors$U = {
  sentinal: ".scroll-sentinal",
  scrollButtons: ".scroll-button",
  scrollViewport: "[data-scroll-container-viewport]",
};
window.scrollContainer = function s(h) {
  var v = t$2(selectors$U.sentinal, h),
    m = t$2(selectors$U.scrollButtons, h),
    g = h.dataset,
    y = g.axis,
    b = g.startAtEnd,
    _ = n$2(selectors$U.scrollViewport, h);
  window.addEventListener(
    "load",
    function () {
      var s;
      (u$1(h, "scroll-container-initialized"),
        "true" === b &&
          ((_["vertical" == y ? "scrollTop" : "scrollLeft"] =
            2 * _["vertical" == y ? "scrollHeight" : "scrollWidth"]),
          (h.dataset.startAtEnd = !1)));
    },
    {
      once: !0,
    },
  );
  var $,
    k = [
      e$2(m, "click", function (s) {
        var h = s.currentTarget,
          v = "vertical" == y ? "scrollTop" : "scrollLeft";
        "start" === h.dataset.position
          ? _[v] < 150
            ? (_[v] = 0)
            : (_[v] -= 100)
          : (_[v] += 100);
      }),
    ],
    S = new IntersectionObserver(
      function (s) {
        s.forEach(function (s) {
          var v = s.target.dataset.position,
            m = s.isIntersecting;
          h.setAttribute("data-at-".concat(v), m ? "true" : "false");
        });
      },
      {
        root: _,
      },
    );
  return (
    v.forEach(function (s) {
      S.observe(s);
    }),
    {
      unload: function s() {
        (v.forEach(function (s) {
          S.unobserve(s);
        }),
          k.forEach(function (s) {
            return s();
          }));
      },
    }
  );
};
var n,
  e,
  i,
  o,
  t,
  r,
  f,
  d,
  p,
  u = [];

function w(s, h) {
  return (
    (e = window.pageXOffset),
    (o = window.pageYOffset),
    (r = window.innerHeight),
    (d = window.innerWidth),
    void 0 === i && (i = e),
    void 0 === t && (t = o),
    void 0 === p && (p = d),
    void 0 === f && (f = r),
    (h || o !== t || e !== i || r !== f || d !== p) &&
      ((function (s) {
        for (var h = 0; h < u.length; h++)
          u[h](
            {
              x: e,
              y: o,
              px: i,
              py: t,
              vh: r,
              pvh: f,
              vw: d,
              pvw: p,
            },
            s,
          );
      })(s),
      (i = e),
      (t = o),
      (f = r),
      (p = d)),
    requestAnimationFrame(w)
  );
}

function srraf(s) {
  return (
    0 > u.indexOf(s) && u.push(s),
    (n = n || w(performance.now())),
    {
      update: function () {
        return (w(performance.now(), !0), this);
      },
      destroy: function () {
        u.splice(u.indexOf(s), 1);
      },
    }
  );
}
var atBreakpointChange = function s(h, v) {
    var m = (window.innerWidth || document.documentElement.clientWidth) <= h,
      g = srraf(function (s) {
        var g = s.vw <= h;
        if (g !== m) return ((m = g), v());
      });
    return {
      unload: function s() {
        g.destroy();
      },
    };
  },
  sel$3 = {
    container: ".social-share",
    button: ".social-share__button",
    popup: ".social-sharing__popup",
    copyURLButton: ".social-share__copy-url",
    successMessage: ".social-share__success-message",
  },
  classes$q = {
    hidden: "hidden",
    linkCopied: "social-sharing__popup--success",
  },
  SocialShare = function (s) {
    if (!s) return Function();
    var h = n$2(sel$3.button, s),
      v = n$2(sel$3.popup, s),
      m = n$2(sel$3.copyURLButton, s),
      g = n$2(sel$3.successMessage, s),
      y = e$2(window, "click", function s(g) {
        var y,
          _ = g.target.closest(sel$3.button) === h,
          S = g.target.closest(sel$3.popup) === v,
          E = g.target.closest(sel$3.copyURLButton) === m,
          T = !1;
        if (
          (_ && (T = "true" === h.getAttribute("aria-expanded")),
          S || b(),
          _ &&
            !T &&
            (h.setAttribute("aria-expanded", !0),
            v.setAttribute("aria-hidden", !1)),
          E)
        ) {
          ((y = m.dataset.url), navigator.clipboard.writeText(y)).then($, k);
        }
      });

    function b() {
      (h.setAttribute("aria-expanded", !1), v.setAttribute("aria-hidden", !0));
    }

    function _(s) {
      ((g.innerHTML = s),
        i$1(g, classes$q.hidden),
        u$1(v, classes$q.linkCopied),
        setTimeout(function () {
          (u$1(g, classes$q.hidden), i$1(v, classes$q.linkCopied));
        }, 2e3));
    }

    function $() {
      _(m.dataset.successMessage);
    }

    function k() {
      _(m.dataset.errorMessage || "Error copying link.");
    }
    return (
      (navigator.clipboard && navigator.clipboard.writeText) ||
        u$1(m, classes$q.hidden),
      function s() {
        (b(), y());
      }
    );
  };

function localStorageAvailable() {
  var s = "test";
  try {
    if ((localStorage.setItem(s, s), localStorage.getItem(s) !== s)) return !1;
    return (localStorage.removeItem(s), !0);
  } catch (h) {
    return !1;
  }
}
var PREFIX = "fluco_";

function getStorage(s) {
  return localStorageAvailable()
    ? JSON.parse(localStorage.getItem(PREFIX + s))
    : null;
}

function removeStorage(s) {
  return localStorageAvailable()
    ? (localStorage.removeItem(PREFIX + s), !0)
    : null;
}

function setStorage(s, h) {
  return localStorageAvailable()
    ? (localStorage.setItem(PREFIX + s, h), !0)
    : null;
}
var routes = window.theme.routes.cart || {},
  paths = {
    base: "".concat(routes.base || "/cart", ".js"),
    add: "".concat(routes.add || "/cart/add", ".js"),
    change: "".concat(routes.change || "/cart/change", ".js"),
    clear: "".concat(routes.clear || "/cart/clear", ".js"),
    update: "".concat(routes.update || "/cart/update", ".js"),
  },
  strings$6 = window.theme.strings.cart;

function sortCart(s) {
  var h = getStorage("cart_order") || [];
  return h.length
    ? ((s.sorted = _toConsumableArray$1(s.items).sort(function (s, v) {
        return h.indexOf(s.variant_id) - h.indexOf(v.variant_id);
      })),
      s)
    : ((s.sorted = s.items), s);
}

function updateItem(s, h) {
  return get().then(function (v) {
    for (
      var m = v.items,
        g = {
          line_item: s,
          line_qty: 0,
          product_qtys: h,
          cart_qtys: 0,
          cart_price: 0,
        },
        y = 0;
      y < m.length;
      y++
    )
      m[y].key === s
        ? ((g.cart_qtys += h),
          (g.cart_price += m[y].price * h),
          (g.line_qty = y + 1))
        : ((g.cart_qtys += m[y].quantity),
          (g.cart_price += m[y].price * m[y].quantity));
    if (cart.cartLimiter(g)) return changeItem(g.line_qty, s, h);
  });
}

function updateItems(items) {
  // `updates` is an Object that takes in the line item keys and their new quantities.
  var updates = {};
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    updates[item.key] = item.quantity;
  }

  return (
    r$1("cart:updating"),
    fetch(paths.update, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates,
      }),
    })
      .then(function (s) {
        return s.json();
      })
      .then(function (s) {
        return get().then(function (s) {
          document.dispatchEvent(
            new CustomEvent("quick-cart:updated", {
              detail: {
                cart: s,
              },
            }),
          );

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                cart: s,
              },
            }),
          );

          return (
            r$1("quick-cart:updated"),
            r$1("cart:updated", {
              cart: s,
            }),
            {
              res: h,
              cart: s,
            }
          );
        });
      })
  );
}

function addItems(items) {
  return (
    r$1("cart:updating"),
    fetch(paths.add, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then(function (s) {
        return s.json();
      })
      .then(function (h) {
        if ("422" == h.status) {
          var v = {
            code: 422,
            message: h.description,
          };
          throw (
            dispatchCustomEvent("cart:error", {
              errorMessage: h.description,
            }),
            r$1("quick-cart:error", null, {
              id: s,
            }),
            r$1("cart:error", null, {
              id: s,
            }),
            v
          );
        }
        return get().then(function (s) {
          document.dispatchEvent(
            new CustomEvent("quick-cart:updated", {
              detail: {
                cart: s,
              },
            }),
          );

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                cart: s,
              },
            }),
          );

          return (
            r$1("quick-cart:updated"),
            r$1("cart:updated", {
              cart: s,
            }),
            {
              res: h,
              cart: s,
            }
          );
        });
      })
  );
}

function changeItem(s, h, v) {
  return fetch(paths.change, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      line: s,
      quantity: v,
    }),
  })
    .then(function (s) {
      return s.json();
    })
    .then(function (s) {
      window.cartData = s;
      var m = s.items.find(function (s) {
        return s.key === h;
      });
      if (m && m.quantity === v - 1 && 0 != m.line_price) {
        var g = {
          code: 422,
          message: strings$6.quantityError,
        };
        throw (
          dispatchCustomEvent("cart:error", {
            errorMessage: strings$6.quantityError,
          }),
          r$1("quick-cart:error", null, {
            key: h,
            errorMessage: strings$6.quantityError,
          }),
          r$1("cart:error", null, {
            key: h,
            errorMessage: strings$6.quantityError,
          }),
          g
        );
      }

      document.dispatchEvent(
        new CustomEvent("quick-cart:updated", {
          detail: {
            cart: s,
          },
        }),
      );
      document.dispatchEvent(
        new CustomEvent("cart:updated", {
          detail: {
            cart: s,
          },
        }),
      );
      return (
        r$1("cart:updated", {
          cart: s,
        }),
        r$1("quick-cart:updated"),
        sortCart(s)
      );
    });
}

function addItemById(s, h, v) {
  // `v` stands for `is_gift`.
  if (!v) {
    for (
      var m = {
          line_item: s,
          line_qty: h,
          product_qtys: 0,
          cart_qtys: 0,
          cart_price: 0,
        },
        g = window.cartData.items,
        y = 0;
      y < g.length;
      y++
    )
      g[y].id == m.line_item
        ? ((m.cart_qtys += g[y].quantity + m.line_qty),
          (m.cart_price += g[y].price * (g[y].quantity + m.line_qty)),
          (m.product_qtys = g[y].quantity + m.line_qty))
        : ((m.cart_qtys += g[y].quantity),
          (m.cart_price += g[y].price * g[y].quantity));
    if (m.product_qtys < 1) {
      ((m.product_qtys = m.line_qty), (m.cart_qtys += m.line_qty));
      var b = JSON.parse(
        document.querySelector(`[data-product-variant-json_${s}]`).innerHTML,
      ).find(function (s) {
        return s.id === parseInt(m.line_item);
      });
      m.cart_price += b.price;
    }
    if (!cart.cartLimiter(m)) {
      var _ = document.querySelectorAll(".limiter-atc");
      if (_.length > 0) for (var y = 0; y < _.length; y++) i$1(_[y], "loading");
      return !1;
    }
  }

  // Create default body.
  const body = {
    items: [
      {
        id: s,
        quantity: h,
      },
    ],
  };

  return (
    r$1("cart:updating"),
    fetch(paths.add, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(function (s) {
        return s.json();
      })
      .then(function (h) {
        if ("422" == h.status) {
          var v = {
            code: 422,
            message: h.description,
          };
          throw (
            dispatchCustomEvent("cart:error", {
              errorMessage: h.description,
            }),
            r$1("quick-cart:error", null, {
              id: s,
            }),
            r$1("cart:error", null, {
              id: s,
            }),
            v
          );
        }
        return get().then(function (s) {
          document.dispatchEvent(
            new CustomEvent("quick-cart:updated", {
              detail: {
                cart: s,
              },
            }),
          );

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                cart: s,
              },
            }),
          );

          return (
            r$1("quick-cart:updated"),
            r$1("cart:updated", {
              cart: s,
            }),
            {
              res: h,
              cart: s,
            }
          );
        });
      })
  );
}

function get() {
  return fetch(paths.base, {
    method: "GET",
    credentials: "include",
  })
    .then(function (s) {
      return s.json();
    })
    .then(function (s) {
      var h = sortCart(s);
      return ((window.cartData = h), h);
    });
}
let cart_popup_timeoutId = null;

function addItem(s) {
  var h = {
      line_item: "",
      line_qty: 0,
      product_qtys: 0,
      cart_qtys: 0,
      cart_price: 0,
    },
    v = "",
    m = new URLSearchParams(serialize(s));
  for (let [g, y] of m)
    ("id" === g && (h.line_item = y),
      "quantity" === g && (h.line_qty = parseInt(y)),
      "product-id" === g && (v = parseInt(y)));
  for (var b = window.cartData.items, _ = 0; _ < b.length; _++)
    b[_].id == h.line_item
      ? ((h.cart_qtys += b[_].quantity + h.line_qty),
        (h.cart_price += b[_].price * (b[_].quantity + h.line_qty)),
        (h.product_qtys = b[_].quantity + h.line_qty))
      : ((h.cart_qtys += b[_].quantity),
        (h.cart_price += b[_].price * b[_].quantity));
  if (h.product_qtys < 1) {
    ((h.product_qtys = h.line_qty), (h.cart_qtys += h.line_qty));
    var $ = JSON.parse(
      document.querySelector(`[data-product-json_${v}]`).innerHTML,
    ).find(function (s) {
      return s.id === parseInt(h.line_item);
    });
    h.cart_price += $.price;
  }
  if (!cart.cartLimiter(h)) {
    var k = document.querySelectorAll(".limiter-atc");
    if (k.length > 0) for (var _ = 0; _ < k.length; _++) i$1(k[_], "loading");
    return !1;
  }
  return (
    r$1("cart:updating"),
    fetch(paths.add, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: serialize(s),
    })
      .then(function (s) {
        return s.json();
      })
      .then(function (s) {
        if ("422" == s.status) {
          var h = {
            code: 422,
            message: s.description,
          };
          throw (
            dispatchCustomEvent("cart:error", {
              errorMessage: s.description,
            }),
            h
          );
        }
        return get().then(function (h) {
          var v = getStorage("cart_order") || [],
            m = [s.variant_id].concat(
              _toConsumableArray$1(
                v.filter(function (h) {
                  return h !== s.variant_id;
                }),
              ),
            );

          document.dispatchEvent(
            new CustomEvent("quick-cart:updated", {
              detail: {
                cart: h,
              },
            }),
          );

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                cart: h,
              },
            }),
          );

          return (
            setStorage("cart_order", JSON.stringify(m)),
            r$1("cart:updated", {
              cart: sortCart(h),
            }),
            r$1("quick-cart:updated"),
            r$1("quick-view:close"),
            dispatchCustomEvent("cart:updated", {
              cart: sortCart(h),
            }),
            {
              item: s,
              cart: sortCart(h),
            }
          );
        });
      })
  );
}

function serialize(s) {
  var h = [];
  return (
    Array.prototype.slice.call(s.elements).forEach(function (s) {
      if (
        !(
          !s.name ||
          s.disabled ||
          ["file", "reset", "submit", "button"].indexOf(s.type) > -1
        )
      ) {
        if ("select-multiple" === s.type) {
          Array.prototype.slice.call(s.options).forEach(function (v) {
            v.selected &&
              h.push(
                encodeURIComponent(s.name) + "=" + encodeURIComponent(v.value),
              );
          });
          return;
        }
        (!(["checkbox", "radio"].indexOf(s.type) > -1) || s.checked) &&
          h.push(
            encodeURIComponent(s.name) + "=" + encodeURIComponent(s.value),
          );
      }
    }),
    h.join("&")
  );
}

function cartLimiter(s) {
  let h = parseInt(document.getElementById("cart_limit_quantity_data").value),
    v = 100 * parseInt(document.getElementById("cart_limit_price_data").value),
    m = parseInt(document.getElementById("cart_limit_pre_product_data").value),
    g = document.getElementById("custom_popup_limiter"),
    y = {
      quantity: document.getElementById("limiter_quantity_popup"),
      price: document.getElementById("limiter_price_popup"),
      perProduct: document.getElementById("limiter_per_product_popup"),
    },
    b = !0;
  return (
    h > 0 && h < parseInt(s.cart_qtys) && ((b = !1), _(y.quantity)),
    v > 0 && v <= parseInt(s.cart_price) && ((b = !1), _(y.price)),
    m > 0 && m < parseInt(s.product_qtys) && ((b = !1), _(y.perProduct)),
    b ||
      ((cart_popup_timeoutId = setTimeout(
        function s() {
          (g.classList.remove("cart_limiter_visible"),
            (y.quantity.style.display = "none"),
            (y.price.style.display = "none"),
            (y.perProduct.style.display = "none"));
        },
        1e3 * parseInt(g.dataset.cartLimitPopCloseTime),
      )),
      console.log("Stop Cart..."),
      r$1("quick-cart:updated")),
    b
  );

  function _(s) {
    g &&
      s &&
      (g.classList.add("cart_limiter_visible"), (s.style.display = "block"));
  }
}
document.addEventListener("click", async function (s) {
  if (s.target.hasAttribute("data-variant-click-atc")) {
    if (window.disableAutomaticCartDrawer === true) {
      // New logic for experiment. It's the same as in the `else` block, but instead of opening the cart drawer,
      // it will just add the item to the cart and fire an event to open the pre cart drawer popup.
      s.preventDefault();
      s.target.disabled = !0;
      var variantId = s.target.dataset.variantId;
      var quantity = s.target.dataset.variantQuantity;

      // Get variant data from the quick view element's JSON data.
      const product = JSON.parse(
        s.target
          .closest(".product-item__quick-view")
          .querySelector("script[data-product-json]").innerHTML,
      );

      if (variantId && quantity) {
        !1 != (await cart.addItemById(variantId, parseInt(quantity), !1));
        s.target.disabled = !1;

        document.dispatchEvent(
          new CustomEvent("cart:item-added", {
            detail: {
              product: product,
            },
          }),
        );
      } else {
        (console.error("Check dataset value."), (s.target.disabled = !1));
      }

      return;
    } else {
      (s.preventDefault(), (s.target.disabled = !0));
      var h = s.target.dataset.variantId,
        v = s.target.dataset.variantQuantity;
      h && v
        ? (!1 != (await cart.addItemById(h, parseInt(v), !1)) &&
            r$1("quick-cart:open"),
          (s.target.disabled = !1))
        : (console.error("Check dataset value."), (s.target.disabled = !1));
    }
  } else
    s.target.hasAttribute("data-limiter-popup-close")
      ? (s.preventDefault(),
        clearTimeout(cart_popup_timeoutId),
        document
          .getElementById("custom_popup_limiter")
          .classList.remove("cart_limiter_visible"),
        (document.getElementById("limiter_quantity_popup").style.display =
          "none"),
        (document.getElementById("limiter_price_popup").style.display = "none"),
        (document.getElementById("limiter_per_product_popup").style.display =
          "none"))
      : s.target.hasAttribute("data-limiter-popup-anchor") &&
        (s.preventDefault(), r$1("quick-cart:open"));
});
var cart = {
  addItem: addItem,
  addItems: addItems,
  get: get,
  updateItem: updateItem,
  updateItems: updateItems,
  addItemById: addItemById,
  cartLimiter: cartLimiter,
};
const moneyFormat = "${{amount}}";

function formatMoney$1(s, h) {
  "string" == typeof s && (s = s.replace(".", ""));
  let v = "",
    m = /\{\{\s*(\w+)\s*\}\}/,
    g = h || "${{amount}}";

  function y(s, h = 2, v = ",", m = ".") {
    if (isNaN(s) || null == s) return 0;
    s = (s / 100).toFixed(h);
    let g = s.split("."),
      y = g[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${v}`),
      b = g[1] ? m + g[1] : "";
    return y + b;
  }
  switch (g.match(m)[1]) {
    case "amount":
      v = y(s, 2);
      break;
    case "amount_no_decimals":
      v = y(s, 0);
      break;
    case "amount_with_comma_separator":
      v = y(s, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      v = y(s, 0, ".", ",");
  }
  return g.replace(m, v);
}
var formatMoney = function (s) {
    return formatMoney$1(s, window.theme.moneyFormat || "${{amount}}");
  },
  getProduct = function (s) {
    return function (h) {
      return fetch(
        "".concat(window.theme.routes.products, "/").concat(s, ".js"),
      )
        .then(function (s) {
          return s.json();
        })
        .then(function (s) {
          return h(s);
        })
        .catch(function (s) {
          return console.log(s.message);
        });
    };
  },
  global = window,
  isPromiseSuppoted = "function" == typeof global.Promise,
  PromiseLike = isPromiseSuppoted
    ? global.Promise
    : function s(h) {
        var v = function () {};
        return (
          h(function () {
            v();
          }),
          {
            then: function (s) {
              v = s;
            },
          }
        );
      },
  pool = [],
  inAnimItems = {
    add: function (s, h, v, m) {
      (this.remove(s),
        pool.push({
          el: s,
          defaultStyle: h,
          timeoutId: v,
          onCancelled: m,
        }));
    },
    remove: function (s) {
      var h = inAnimItems.findIndex(s);
      if (-1 !== h) {
        var v = pool[h];
        (clearTimeout(v.timeoutId), v.onCancelled(), pool.splice(h, 1));
      }
    },
    find: function (s) {
      return pool[inAnimItems.findIndex(s)];
    },
    findIndex: function (s) {
      var h = -1;
      return (
        pool.some(function (v, m) {
          return v.el === s && ((h = m), !0);
        }),
        h
      );
    },
  },
  CSS_EASEOUT_EXPO = "cubic-bezier( 0.19, 1, 0.22, 1 )";

function slideDown(s, h) {
  return (
    void 0 === h && (h = {}),
    new PromiseLike(function (v) {
      if (-1 === inAnimItems.findIndex(s)) {
        var m = isVisible(s),
          g = "number" == typeof h.endHeight,
          y = h.display || "block",
          b = h.duration || 400,
          _ = h.onCancelled || function () {},
          $ = s.getAttribute("style") || "",
          k = window.getComputedStyle(s),
          S = getDefaultStyles(s, y),
          E = /border-box/.test(k.getPropertyValue("box-sizing")),
          T = S.height,
          C = S.minHeight,
          I = S.paddingTop,
          A = S.paddingBottom,
          L = S.borderTop,
          B = S.borderBottom,
          P = b + "ms",
          x = CSS_EASEOUT_EXPO,
          M = [
            "height " + P + " " + x,
            "min-height " + P + " " + x,
            "padding " + P + " " + x,
            "border-width " + P + " " + x,
          ].join(),
          H = m ? k.height : "0px",
          q = m ? k.minHeight : "0px",
          O = m ? k.paddingTop : "0px",
          D = m ? k.paddingBottom : "0px",
          R = m ? k.borderTopWidth : "0px",
          V = m ? k.borderBottomWidth : "0px",
          N = g ? h.endHeight + "px" : E ? T + L + B + "px" : T - I - A + "px",
          F = C + "px",
          U = I + "px",
          W = A + "px",
          j = L + "px",
          G = B + "px";
        if (H === N && O === U && D === W && R === j && V === G) {
          v();
          return;
        }
        requestAnimationFrame(function () {
          ((s.style.height = H),
            (s.style.minHeight = q),
            (s.style.paddingTop = O),
            (s.style.paddingBottom = D),
            (s.style.borderTopWidth = R),
            (s.style.borderBottomWidth = V),
            (s.style.display = y),
            (s.style.overflow = "hidden"),
            (s.style.visibility = "visible"),
            (s.style.transition = M),
            (s.style.webkitTransition = M),
            requestAnimationFrame(function () {
              ((s.style.height = N),
                (s.style.minHeight = F),
                (s.style.paddingTop = U),
                (s.style.paddingBottom = W),
                (s.style.borderTopWidth = j),
                (s.style.borderBottomWidth = G));
            }));
        });
        var z = setTimeout(function () {
          (resetStyle(s),
            (s.style.display = y),
            g &&
              ((s.style.height = h.endHeight + "px"),
              (s.style.overflow = "hidden")),
            inAnimItems.remove(s),
            v());
        }, b);
        inAnimItems.add(s, $, z, _);
      }
    })
  );
}

function slideUp(s, h) {
  return (
    void 0 === h && (h = {}),
    new PromiseLike(function (v) {
      if (-1 === inAnimItems.findIndex(s)) {
        var m = isVisible(s),
          g = h.display || "block",
          y = h.duration || 400,
          b = h.onCancelled || function () {};
        if (!m) {
          v();
          return;
        }
        var _ = s.getAttribute("style") || "",
          $ = window.getComputedStyle(s),
          k = /border-box/.test($.getPropertyValue("box-sizing")),
          S = pxToNumber($.getPropertyValue("min-height")),
          E = pxToNumber($.getPropertyValue("padding-top")),
          T = pxToNumber($.getPropertyValue("padding-bottom")),
          C = pxToNumber($.getPropertyValue("border-top-width")),
          I = pxToNumber($.getPropertyValue("border-bottom-width")),
          A = s.scrollHeight,
          L = y + "ms",
          B = CSS_EASEOUT_EXPO,
          P = [
            "height " + L + " " + B,
            "padding " + L + " " + B,
            "border-width " + L + " " + B,
          ].join(),
          x = k ? A + C + I + "px" : A - E - T + "px",
          M = S + "px",
          H = E + "px",
          q = T + "px",
          O = C + "px",
          D = I + "px";
        requestAnimationFrame(function () {
          ((s.style.height = x),
            (s.style.minHeight = M),
            (s.style.paddingTop = H),
            (s.style.paddingBottom = q),
            (s.style.borderTopWidth = O),
            (s.style.borderBottomWidth = D),
            (s.style.display = g),
            (s.style.overflow = "hidden"),
            (s.style.transition = P),
            (s.style.webkitTransition = P),
            requestAnimationFrame(function () {
              ((s.style.height = "0"),
                (s.style.minHeight = "0"),
                (s.style.paddingTop = "0"),
                (s.style.paddingBottom = "0"),
                (s.style.borderTopWidth = "0"),
                (s.style.borderBottomWidth = "0"));
            }));
        });
        var R = setTimeout(function () {
          (resetStyle(s),
            (s.style.display = "none"),
            inAnimItems.remove(s),
            v());
        }, y);
        inAnimItems.add(s, _, R, b);
      }
    })
  );
}

function slideStop(s) {
  if (inAnimItems.find(s)) {
    var h = window.getComputedStyle(s),
      v = h.height,
      m = h.paddingTop,
      g = h.paddingBottom,
      y = h.borderTopWidth,
      b = h.borderBottomWidth;
    (resetStyle(s),
      (s.style.height = v),
      (s.style.paddingTop = m),
      (s.style.paddingBottom = g),
      (s.style.borderTopWidth = y),
      (s.style.borderBottomWidth = b),
      (s.style.overflow = "hidden"),
      inAnimItems.remove(s));
  }
}

function isVisible(s) {
  return 0 !== s.offsetHeight;
}

function resetStyle(s) {
  ((s.style.visibility = ""),
    (s.style.height = ""),
    (s.style.minHeight = ""),
    (s.style.paddingTop = ""),
    (s.style.paddingBottom = ""),
    (s.style.borderTopWidth = ""),
    (s.style.borderBottomWidth = ""),
    (s.style.overflow = ""),
    (s.style.transition = ""),
    (s.style.webkitTransition = ""));
}

function getDefaultStyles(s, h) {
  void 0 === h && (h = "block");
  var v = s.getAttribute("style") || "",
    m = window.getComputedStyle(s);
  ((s.style.visibility = "hidden"), (s.style.display = h));
  var g = pxToNumber(m.getPropertyValue("width"));
  ((s.style.position = "absolute"),
    (s.style.width = g + "px"),
    (s.style.height = ""),
    (s.style.minHeight = ""),
    (s.style.paddingTop = ""),
    (s.style.paddingBottom = ""),
    (s.style.borderTopWidth = ""),
    (s.style.borderBottomWidth = ""));
  var y = pxToNumber(m.getPropertyValue("min-height")),
    b = pxToNumber(m.getPropertyValue("padding-top")),
    _ = pxToNumber(m.getPropertyValue("padding-bottom")),
    $ = pxToNumber(m.getPropertyValue("border-top-width")),
    k = pxToNumber(m.getPropertyValue("border-bottom-width")),
    S = s.scrollHeight;
  return (
    s.setAttribute("style", v),
    {
      height: S,
      minHeight: y,
      paddingTop: b,
      paddingBottom: _,
      borderTop: $,
      borderBottom: k,
    }
  );
}

function pxToNumber(s) {
  return +s.replace(/px/, "");
}

function accordion(s, h) {
  var v = t$2(".accordion__label", s),
    m = t$2(".accordion__content", s);
  (v.forEach(function (s) {
    s.href = "#";
  }),
    m.forEach(function (s) {
      return u$1(s, "measure");
    }));
  var g = e$2(v, "click", function (s) {
    s.preventDefault();
    var h,
      v,
      m,
      g = s.currentTarget,
      b = g.parentNode,
      _ = g.nextElementSibling;
    (slideStop(_),
      isVisible(_)
        ? ((h = g),
          (v = b),
          (m = _),
          slideUp(m),
          v.setAttribute("data-open", !1),
          h.setAttribute("aria-expanded", !1),
          m.setAttribute("aria-hidden", !0))
        : y(g, b, _));
  });

  function y(s, h, v) {
    (slideDown(v),
      h.setAttribute("data-open", !0),
      s.setAttribute("aria-expanded", !0),
      v.setAttribute("aria-hidden", !1));
  }
  if (h.firstOpen) {
    var b = v[0],
      _ = b.parentNode,
      $ = b.nextElementSibling;
    y(v[0], _, $);
  }
  return {
    destroy: function s() {
      return function () {
        return g();
      };
    },
  };
}

function Accordions(s) {
  var h = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
  if (!Array.isArray(s) || s.length) {
    var v = Object.assign(
        {
          firstOpen: !0,
        },
        h,
      ),
      m = [];
    return (
      s.length
        ? (m = s.map(function (s) {
            return accordion(s, v);
          }))
        : m.push(accordion(s, v)),
      {
        unload: function s() {
          m.forEach(function (s) {
            return s.destroy();
          });
        },
      }
    );
  }
}

function Media(s) {
  if (s) {
    var h = window,
      v = h.Shopify,
      m = h.YT,
      g = t$2("[data-interactive]", s);
    if (g.length) {
      var y = ["video", "model", "external_video"],
        b = null,
        _ = !1,
        $ = {};
      return (
        _ && g.forEach(k),
        window.Shopify.loadFeatures(
          [
            {
              name: "model-viewer-ui",
              version: "1.0",
            },
            {
              name: "shopify-xr",
              version: "1.0",
            },
            {
              name: "video-ui",
              version: "1.0",
            },
          ],
          function () {
            ((_ = !0),
              "YT" in window && Boolean(m.loaded)
                ? g.forEach(k)
                : (window.onYouTubeIframeAPIReady = function () {
                    g.forEach(k);
                  }));
          },
        ),
        {
          pauseActiveMedia: S,
        }
      );
    }
  }

  function k(s) {
    var h = s.dataset,
      g = h.mediaId,
      _ = h.mediaType;
    if (_ && y.includes(_) && !Object.keys($).includes(g)) {
      var k = {
        id: g,
        type: _,
        container: s,
        media: s.children[0],
      };
      switch (k.type) {
        case "video":
          k.player = new v.Plyr(k.media, {
            loop: {
              active: "true" == s.dataset.loop,
            },
          });
          break;
        case "external_video":
          k.player = new m.Player(k.media);
          var E = n$2(".external-video-overlay", s);
          E &&
            (e$2(E, "click", function (s) {
              var h;
              (s.preventDefault(),
                null !== (h = k.player) &&
                  void 0 !== h &&
                  h.playVideo &&
                  k.player.playVideo(),
                u$1(E, "hidden"));
            }),
            k.player.addEventListener("onStateChange", function (s) {
              2 === s.data && i$1(E, "hidden");
            }));
          break;
        case "model":
          ((k.viewer = new v.ModelViewerUI(n$2("model-viewer", s))),
            e$2(n$2(".model-poster", s), "click", function (s) {
              var h;
              (s.preventDefault(),
                (h = k),
                S(h),
                h.viewer.play(),
                u$1(h.container, "model-active"),
                (b = h),
                setTimeout(function () {
                  n$2("model-viewer", h.container).focus();
                }, 300));
            }));
      }
      (($[g] = k),
        k.player &&
          ("video" === k.type
            ? k.player.on("playing", function () {
                (S(k), (b = k));
              })
            : "external_video" === k.type &&
              k.player.addEventListener("onStateChange", function (s) {
                1 === s.data && (S(k), (b = k));
              })));
    }
  }

  function S(s) {
    if (b && s != b) {
      if (b.player) {
        ("video" === b.type
          ? b.player.pause()
          : "external_video" === b.type && b.player.pauseVideo(),
          (b = null));
        return;
      }
      b.viewer &&
        (i$1(b.container, "model-active"), b.viewer.pause(), (b = null));
    }
  }
}
var selectors$T = {
  idInput: '[name="id"]',
  optionInput: '[name^="options"]',
  quantityInput: "[data-quantity-input]",
  formQuantity: '[name="quantity"]',
  propertyInput: '[name^="properties"]',
};

function ProductForm(s, h, v) {
  var m = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
    g = validateProductObject(v),
    y = [],
    b = function s() {
      return _serializeOptionValues(I, function (s) {
        return ((s.name = /(?:^(options\[))(.*?)(?:\])/.exec(s.name)[2]), s);
      });
    },
    _ = function s() {
      return getVariantFromSerializedArray(g, b());
    },
    $ = function s() {
      var h = _serializePropertyValues(L, function (s) {
        return /(?:^(properties\[))(.*?)(?:\])/.exec(s)[2];
      });
      return 0 === Object.entries(h).length ? null : h;
    },
    k = function s() {
      return {
        options: b(),
        variant: _(),
        properties: $(),
        quantity: A[0] ? Number.parseInt(A[0].value, 10) : 1,
      };
    },
    S = function s(h) {
      if (void 0 !== h)
        return function (s) {
          ((s.dataset = k()), h(s));
        };
    },
    E = function s(v) {
      var m = h.querySelector(selectors$T.idInput);
      (m ||
        (((m = document.createElement("input")).type = "hidden"),
        (m.name = "id"),
        h.appendChild(m)),
        (m.value = v.toString()));
    },
    T = function s(h) {
      if (window.disableAutomaticCartDrawer) {
        h.dataset = k();
        E(h.dataset.variant.id);
        m.onNewFormSubmit && m.onNewFormSubmit(h);
      } else {
        ((h.dataset = k()),
          E(h.dataset.variant.id),
          m.onFormSubmit && m.onFormSubmit(h));
      }
    },
    C = function h(v, m) {
      return _toConsumableArray$1(s.querySelectorAll(v)).map(function (s) {
        return (y.push(e$2(s, "change", S(m))), s);
      });
    };
  y.push(e$2(h, "submit", T));
  var I = C(selectors$T.optionInput, m.onOptionChange),
    A = C(selectors$T.quantityInput, m.onQuantityChange),
    L = C(selectors$T.propertyInput, m.onPropertyChange);
  return {
    getVariant: _,
    destroy: function s() {
      y.forEach(function (s) {
        return s();
      });
    },
  };
}

function validateProductObject(s) {
  if ("object" !== _typeof(s)) throw TypeError(s + " is not an object.");
  if (void 0 === s.variants[0].options)
    throw TypeError(
      "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route",
    );
  return s;
}

function _serializeOptionValues(s, h) {
  return s.reduce(function (s, v) {
    return (
      (v.checked || ("radio" !== v.type && "checkbox" !== v.type)) &&
        s.push(
          h({
            name: v.name,
            value: v.value,
          }),
        ),
      s
    );
  }, []);
}

function _serializePropertyValues(s, h) {
  return s.reduce(function (s, v) {
    return (
      (v.checked || ("radio" !== v.type && "checkbox" !== v.type)) &&
        (s[h(v.name)] = v.value),
      s
    );
  }, {});
}
var preventDefault = function (s) {
    return function (h) {
      (h.preventDefault(), s());
    };
  },
  selectors$S = {
    imageById: function s(h) {
      return "[data-media-item-id='".concat(h, "']");
    },
    imageWrapper: "[data-product-media-wrapper]",
    inYourSpace: "[data-in-your-space]",
  },
  classes$p = {
    hidden: "hidden",
  };

function switchImage(s, h, v) {
  var m = n$2(selectors$S.imageWrapper + selectors$S.imageById(h), s),
    g = t$2(
      ""
        .concat(selectors$S.imageWrapper, ":not(")
        .concat(selectors$S.imageById(h), ")"),
      s,
    );
  (i$1(m, classes$p.hidden),
    v &&
      "model" === m.dataset.mediaType &&
      v.setAttribute("data-shopify-model3d-id", m.dataset.mediaItemId),
    g.forEach(function (s) {
      return u$1(s, classes$p.hidden);
    }));
}

function provideResizeObserver() {
  return window.ResizeObserver
    ? Promise.resolve({
        ResizeObserver: ResizeObserver,
      })
    : import(flu.chunks.polyfillResizeObserver);
}

function quantityInput(s) {
  var h = n$2(".quantity-input", s);
  if (h) {
    var v = n$2("[data-quantity-input]", h),
      m = n$2("[data-add-quantity]", h),
      g = n$2("[data-subtract-quantity]", h),
      y = function s() {
        var h = parseInt(v.value);
        1 !== h && ((v.value = h - 1), v.dispatchEvent(new Event("change")));
      },
      b = [
        e$2(m, "click", function s() {
          var h = parseInt(v.value);
          ((v.value = h + 1), v.dispatchEvent(new Event("change")));
        }),
        e$2(g, "click", y),
      ];
    return {
      unload: function s() {
        b.forEach(function (s) {
          return s();
        });
      },
    };
  }
}
var selectors$R = {
    popupTrigger: "[data-popup-trigger]",
  },
  informationPopup = function s(h) {
    var v = [],
      m = t$2(selectors$R.popupTrigger, h);
    if (m.length) {
      var g = e$2(m, "click", function (s) {
        (s.preventDefault(), s.stopPropagation());
        var v = s.target.dataset.modalContentId,
          m = n$2("#".concat(v), h);
        r$1("modal:open", null, {
          modalContent: m,
        });
      });
      return (
        v.push(g),
        {
          unload: function s() {
            v.forEach(function (s) {
              return s();
            });
          },
        }
      );
    }
  },
  selectors$Q = {
    moreButton: "[data-more-media]",
    moreBar: "[data-more-media-bar]",
    productMedia: "[data-product-media]",
  },
  states = {
    closed: "closed",
    beforeOpen: "beforeOpen",
    opening: "opening",
    open: "open",
  },
  moreMedia = function s(h) {
    var v = n$2(selectors$Q.moreButton, h);
    if (v) {
      var m = n$2(selectors$Q.moreBar, h),
        g = n$2(selectors$Q.productMedia, h),
        y = parseFloat(window.getComputedStyle(g).aspectRatio),
        b = !1,
        _ = function s(h) {
          v.innerHTML = v.dataset[h ? "langLessMedia" : "langMoreMedia"];
        },
        $ = function s() {
          if (b) {
            if (!isFinite(y)) {
              ((g.dataset.productMedia = states.closed), (b = !1), _(!1));
              return;
            }
            ((g.dataset.productMedia = states.opening),
              window.requestAnimationFrame(function () {
                var s = e$2(g, "transitionend", function () {
                  (s(), (g.dataset.productMedia = states.closed), (b = !1));
                });
                ((g.dataset.productMedia = states.beforeOpen), _(!1));
              }));
          }
        },
        k = function s() {
          if (!b) {
            if (!isFinite(y)) {
              ((g.dataset.productMedia = states.open), (b = !0), _(!0));
              return;
            }
            ((g.dataset.productMedia = states.beforeOpen),
              window.requestAnimationFrame(function () {
                var s = g.getBoundingClientRect().width,
                  h = g.scrollHeight,
                  v = parseInt(window.getComputedStyle(g).rowGap, 10),
                  y = parseInt(window.getComputedStyle(m).bottom, 10);
                g.style.setProperty(
                  "--overflow-gallery-aspect-ratio-open",
                  s / (h - v - y),
                );
                var $ = e$2(g, "transitionend", function (s) {
                  s.target === g &&
                    ($(), (g.dataset.productMedia = states.open), (b = !0));
                });
                ((g.dataset.productMedia = states.opening), _(!0));
              }));
          }
        },
        S = e$2(v, "click", function () {
          b ? $() : k();
        }),
        E = e$2(window, "resize", function () {
          return $();
        }),
        T = [S, E];
      return {
        unload: function s() {
          T.forEach(function (s) {
            return s();
          });
        },
      };
    }
  },
  strings$5 = window.theme.strings.products,
  selectors$P = {
    price: "[data-price]",
    comparePrice: "[data-compare-price]",
    saleBadge: ".product-badge__wrapper-sale",
    preSaleElements: "[data-pre-sale-content]",
  };

function updatePrices(s, h) {
  var container = s;
  var v = t$2(selectors$P.price, s),
    m = t$2(selectors$P.comparePrice, s),
    g = strings$5.product.unavailable;
  if (!h) {
    ((v[0].innerHTML = g),
      m.forEach(function (s) {
        return (s.innerHTML = "");
      }));
    return;
  }

  function populatePrice(price, comparePrice, el, isPreSale = false) {
    el.parentNode.querySelector(selectors$P.price).innerHTML =
      formatMoney(price);
    el.parentNode.querySelector(selectors$P.price).dataset.price = price / 100;
    el.innerHTML = comparePrice > price ? formatMoney(comparePrice) : "";
    comparePrice > price
      ? el.parentNode.querySelector(selectors$P.price).classList.add("sale")
      : el.parentNode.querySelector(selectors$P.price).classList.remove("sale");

    if (isPreSale) return;

    const saleBadgeElement = el.parentNode.querySelector(selectors$P.saleBadge);

    if (saleBadgeElement) {
      saleBadgeElement.innerHTML =
        comparePrice > price
          ? "<span>-" +
            (((comparePrice - price) / comparePrice) * 100).toFixed(0) +
            "%</span>"
          : "";
    }

    if (comparePrice > price) {
      if (saleBadgeElement) {
        saleBadgeElement.parentNode.classList.remove("hidden");
      }

      el.parentNode.querySelector(selectors$P.price).classList.add("sale");
    } else {
      if (saleBadgeElement) {
        saleBadgeElement.parentNode.classList.add("hidden");
      }

      el.parentNode.querySelector(selectors$P.price).classList.remove("sale");
    }
  }

  ((v[0].innerHTML = formatMoney(h.price)),
    m.forEach(function (s) {
      const preSaleData = s.parentNode
        .querySelector(selectors$P.price)
        .getAttribute("data-pre-sale")
        ? JSON.parse(
            s.parentNode
              .querySelector(selectors$P.price)
              .getAttribute("data-pre-sale"),
          )
        : null;
      var price = h.price;
      var compareAtPrice = h.compare_at_price;
      var isPreSale = false;

      if (
        preSaleData &&
        Object.keys(preSaleData).length > 0 &&
        preSaleData[h.id] &&
        preSaleData[h.id] > 0
      ) {
        price = parseInt(preSaleData[h.id]);
        compareAtPrice = h.price;
        isPreSale = true;
        container
          .querySelectorAll(selectors$P.preSaleElements)
          ?.forEach((el) => el.classList.remove("hidden"));
      } else {
        container
          .querySelectorAll(selectors$P.preSaleElements)
          ?.forEach((el) => el.classList.add("hidden"));
      }

      populatePrice(price, compareAtPrice, s, isPreSale);
    }));
}
var selectors$O = {
    productSku: "[data-product-sku]",
    productSkuContainer: ".product__vendor_and_sku",
  },
  strings$4 = window.theme.strings.products;

function updateSku(s, h) {
  var v = n$2(selectors$O.productSku, s),
    m = n$2(selectors$O.productSkuContainer, s);
  if (v) {
    var g,
      y = strings$4.product.sku;
    if (!h || !h.sku) {
      ((v.innerText = ""), m.setAttribute("data-showing-sku", !1));
      return;
    }
    ((v.innerText = ((g = h.sku), "".concat(y, ": ").concat(g))),
      m.setAttribute("data-showing-sku", !0));
  }
}

function updateBuyButton(s, h, v) {
  // `s` is the Buy Button element. It appears that this is sometimes being called with it being `null`.
  // Therefore we need to check if it is null before proceeding.
  // TODO: Check where this is the case and fix at the source.
  if (!s) return;

  var m = n$2("[data-add-to-cart-text]", s),
    g = s.dataset,
    y = g.langAvailable,
    b = g.langUnavailable,
    _ = g.langSoldOut;
  null !== m &&
    (h
      ? h.available
        ? (s.removeAttribute("disabled"), (m.textContent = y))
        : (s.setAttribute("disabled", "disabled"), (m.textContent = _))
      : (s.setAttribute("disabled", "disabled"), (m.textContent = b)));
}
var selectors$N = {
    accordionShell: ".accordion.product-reviews",
    accordionContent: ".accordion__content",
  },
  classes$o = {
    hidden: "hidden",
    accordion: "accordion",
  };

function reviewsHandler(s, h) {
  if (s) {
    var v = s.parentNode,
      m = n$2(selectors$N.accordionShell, h);
    (n$2(selectors$N.accordionContent, m).appendChild(s),
      v.appendChild(m),
      u$1(v, classes$o.accordion),
      i$1(m, classes$o.hidden));
  }
}

function OptionButtons(s) {
  var h = s.map(createOptionGroup);
  return {
    groups: h,
    destroy: function s() {
      h &&
        h.forEach(function (s) {
          return s();
        });
    },
  };
}

function createOptionGroup(s) {
  var h = n$2("select", s),
    v = t$2("[data-button]", s),
    m = e$2(v, "click", function (s) {
      s.preventDefault();
      var m = s.currentTarget.dataset.optionHandle;
      (v.forEach(function (s) {
        l(s, "selected", s.dataset.optionHandle === m);
      }),
        (n$2('[data-value-handle="'.concat(m, '"]'), h).selected = !0),
        h.dispatchEvent(new Event("change")));
    });
  return function () {
    return m();
  };
}
var selectors$M = {
    counterContainer: "[data-inventory-counter]",
    inventoryMessage: ".inventory-counter__message",
    countdownBar: ".inventory-counter__bar",
    progressBar: ".inventory-counter__bar-progress",
  },
  classes$n = {
    hidden: "hidden",
    inventoryLow: "inventory--low",
    inventoryEmpty: "inventory--empty",
    inventoryUnavailable: "inventory--unavailable",
  },
  inventoryCounter = function s(h, v) {
    var m = v.variantsInventories,
      g = n$2(selectors$M.counterContainer, h),
      y = n$2(selectors$M.inventoryMessage, h),
      b = n$2(selectors$M.progressBar, h),
      _ = g.dataset,
      $ = _.lowInventoryThreshold,
      k = _.showUntrackedQuantity,
      S = _.stockCountdownMax,
      E = _.unavailableText;
    if ($.match(/^[0-9]+$/) && S.match(/^[0-9]+$/)) {
      var T,
        C = parseInt($, 10),
        I = parseInt(S, 10);
      return (
        l(g, classes$n.hidden, !P(m[v.id])),
        A(m[v.id]),
        L(m[v.id].inventory_quantity, m[v.id].inventory_management),
        B(m[v.id].inventory_message),
        {
          update: function s(h) {
            if (!h) {
              (i$1(g, classes$n.hidden),
                u$1(g, classes$n.inventoryUnavailable),
                g.setAttribute("data-stock-category", "unavailable"),
                L(0),
                B(E));
              return;
            }
            (l(g, classes$n.hidden, !P(m[h.id])),
              A(m[h.id]),
              L(m[h.id].inventory_quantity, m[h.id].inventory_management),
              B(m[h.id].inventory_message));
          },
        }
      );
    }

    function A(s) {
      var h = s.inventory_policy,
        v = s.inventory_quantity,
        m = s.inventory_management;
      (i$1(g, classes$n.inventoryLow),
        null !== m
          ? v <= 0 && "deny" === h
            ? (u$1(g, classes$n.inventoryEmpty),
              g.setAttribute("data-stock-category", "empty"))
            : v <= C || (v <= 0 && "continue" === h)
              ? g.setAttribute("data-stock-category", "low")
              : g.setAttribute("data-stock-category", "sufficient")
          : null === m &&
            "true" == k &&
            g.setAttribute("data-stock-category", "sufficient"));
    }

    function L(s, h) {
      if (null === h && "true" == k) {
        b.style.width = "".concat(100, "%");
        return;
      }
      if (s <= 0) {
        b.style.width = "".concat(0, "%");
        return;
      }
      b.style.width = "".concat(s < I ? (s / I) * 100 : 100, "%");
    }

    function B(s) {
      y.innerText = s;
    }

    function P(s) {
      return (
        s.inventory_message &&
        (null !== s.inventory_management ||
          (null === s.inventory_management && "true" == k))
      );
    }
  },
  lerp = function s(h, v, m) {
    return (1 - m) * h + m * v;
  },
  selectors$L = {
    productMeta: ".product__meta",
  },
  classes$m = {
    hasSticky: "product--has-sticky-scroll",
  };

function stickyScroll(s) {
  var h = n$2(selectors$L.productMeta, s);
  s.style.setProperty("--product-meta-top", 0);
  var v = window.scrollY,
    m = 0,
    g = 0,
    y = g,
    b = y,
    _ = h.offsetHeight,
    $ = _ + g,
    k = $ - window.innerHeight,
    S = srraf(function (s) {
      T(s.y);
    });

  function E() {
    ((_ = h.offsetHeight),
      (g = parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue("--header-desktop-sticky-height")
          .replace(/px/gi, ""),
      )),
      (k = ($ = _ + g) - window.innerHeight),
      $ > window.innerHeight && s.offsetHeight > $
        ? (u$1(s, classes$m.hasSticky), T(window.scrollY))
        : i$1(s, classes$m.hasSticky));
  }

  function T(s) {
    var h = y + (m = v - s),
      b = g;
    ((y = Math.max(-k + g - 40, Math.min(h, b))), (v = s));
  }
  return (
    provideResizeObserver().then(function (s) {
      var v = new s.ResizeObserver(E);
      (v.observe(h), v.observe(document.documentElement));
    }),
    requestAnimationFrame(function () {
      return (function h() {
        (y !== b &&
          ((b = lerp(b, y, 0.5)),
          s.style.setProperty("--product-meta-top", "".concat(b, "px"))),
          requestAnimationFrame(function () {
            return h();
          }));
      })();
    }),
    {
      destroy: function s() {
        var h;
        (null == S || S.scroller.destroy(),
          null === (h = resizeObserver) || void 0 === h || h.disconnect());
      },
    }
  );
}
var selectors$K = {
    item: ".product-item",
    itemInner: ".product-item__inner",
    quickViewButton: ".show-product-quickview",
  },
  resultContainer = document.querySelector(".result-section");
resultContainer && ProductItem();
var collectionSlider = document.querySelector(
  ".featured-collection-slider__products",
);

function ProductItem(s) {
  var h = t$2(selectors$K.item, s);
  if (h.length) {
    (h.forEach(function (s, v) {
      return s.style.setProperty("--z-index-item", h.length - v);
    }),
      h.forEach(function (s, h) {
        return s.style.setProperty("order", h + 1);
      }));
    var v = AnimateProductItem(h),
      m = t$2(selectors$K.quickViewButton, s),
      g = [
        e$2(m, "click", function (s) {
          (s.preventDefault(),
            s.stopPropagation(),
            r$1("quick-view:open", null, {
              productUrl: s.currentTarget.getAttribute("href"),
            }));
        }),
      ];
    return {
      unload: function s() {
        (v.destroy(),
          g.forEach(function (s) {
            return s();
          }));
      },
    };
  }
}
collectionSlider && ProductItem();
var selectors$J = {
    sliderContainer: ".swiper",
    visibleSlides: ".swiper-slide-visible",
  },
  classes$l = {
    overflow: "has-overflow",
    carousel: "carousel",
  },
  Carousel = function (s) {
    var h,
      v = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      m = a$1(s, classes$l.carousel) ? s : n$2(selectors$J.sliderContainer, s);
    if (m) {
      var g = [],
        y = {
          slidesPerView: 2,
          grabCursor: !0,
          watchSlidesProgress: !0,
          on: {
            init: function s() {
              k(this.slides);
            },
            breakpoint: function s() {
              S(this.slides);
            },
          },
        },
        b = n$2("[data-next]", s),
        _ = n$2("[data-prev]", s),
        $ = b && _,
        k = function s(h) {
          setTimeout(function () {
            var s = a$1(m, classes$l.overflow),
              v = t$2(selectors$J.visibleSlides, m).length !== h.length;
            !s && v
              ? u$1(m, classes$l.overflow)
              : s && !v && i$1(m, classes$l.overflow);
          }, 0);
        },
        S = function s(h) {
          k(h);
        };
      return (
        import(flu.chunks.swiper).then(function (s) {
          var k = s.Swiper,
            S = s.Navigation,
            T = Object.assign(y, v);
          ("navigation" in T
            ? (T = Object.assign(T, {
                modules: [S],
              }))
            : $ &&
              (T = Object.assign(T, {
                modules: [S],
                navigation: {
                  nextEl: b,
                  prevEl: _,
                },
              })),
            (h = new k(m, T)),
            g.push(e$2(m, "focusin", E)));
        }),
        {
          destroy: function s() {
            var v;
            (null === (v = h) || void 0 === v || v.destroy(),
              g.forEach(function (s) {
                return s();
              }));
          },
          resetScroll: function s() {
            h && h.slideTo(0);
          },
          update: function s() {
            h && h.update();
          },
          getInternalSwiper: function() { return h; }
        }
      );
    }

    function E(s) {
      var v = s.target.closest(".swiper-slide"),
        m = _toConsumableArray$1(v.parentElement.children).indexOf(v);
      document.body.classList.contains("user-is-tabbing") && h.slideTo(m);
    }
  },
  selectors$I = {
    wrappingContainer: ".product__block-featured-products",
    featuredProducts: "[data-featured-products]",
    featuredProductsContent: "[data-featured-products-content]",
    leftSideMobileFeaturedProducts:
      ".left-side-blocks.for-mobile [data-featured-products]",
  },
  featuredProducts = function s(h) {
    var v,
      m,
      g,
      s = t$2(selectors$I.featuredProducts, h);
    if (s.length) {
      var y = s[0].dataset,
        b = y.recommendationsType,
        _ = y.productId,
        $ = y.sectionId,
        k = y.enableMobileSwiper,
        S = y.maxRecommendations;
      return (
        "app-recommendations" === b
          ? fetch(
              ""
                .concat(
                  window.theme.routes.productRecommendations,
                  "?section_id=",
                )
                .concat($, "&limit=")
                .concat(S, "&product_id=")
                .concat(_, "&intent=complementary"),
            )
              .then(function (s) {
                return s.text();
              })
              .then(function (h) {
                var m = document.createElement("div");
                m.innerHTML = h;
                var g = n$2(selectors$I.featuredProductsContent, m);
                g &&
                  g.innerHTML.trim().length &&
                  (s.forEach(function (s) {
                    return (s.innerHTML = g.innerHTML);
                  }),
                  (v = s.map(function (s) {
                    return ProductItem(s);
                  })),
                  s.forEach(function (s) {
                    i$1(s.closest(selectors$I.wrappingContainer), "hidden");
                  }),
                  E());
              })
              .catch(function (s) {
                throw s;
              })
          : ((v = s.forEach(function (s) {
              return ProductItem(s);
            })),
            E()),
        {
          unload: function s() {
            var h;
            (v.forEach(function (s) {
              return s.unload();
            }),
              null === (h = m) || void 0 === h || h.destroy());
          },
        }
      );
    }

    function E() {
      "true" === k &&
        ((g =
          n$2(selectors$I.leftSideMobileFeaturedProducts, h) ||
          n$2(selectors$I.featuredProducts, h)),
        window.matchMedia(getMediaQuery("below-720")).matches && T(),
        atBreakpointChange(720, function () {
          if (window.matchMedia(getMediaQuery("below-720")).matches) T();
          else {
            var s;
            null === (s = m) || void 0 === s || s.destroy();
          }
        }));
    }

    function T() {
      m = Carousel(g, {
        slidesPerView: 2.1,
        spaceBetween: 12,
      });
    }
  },
  classes$k = {
    disabled: "disabled",
  },
  selectors$H = {
    variantsWrapper: ".product__variants-wrapper",
    variantsJson: "[data-variant-json]",
    input: ".dynamic-variant-input",
    inputWrap: ".dynamic-variant-input-wrap",
    inputWrapWithValue: function s(h) {
      return "".concat(selectors$H.inputWrap, '[data-index="').concat(h, '"]');
    },
    buttonWrap: ".dynamic-variant-button",
    buttonWrapWithValue: function s(h) {
      return ""
        .concat(selectors$H.buttonWrap, '[data-option-value="')
        .concat(h, '"]');
    },
  };

function variantAvailability(s) {
  var h = n$2(selectors$H.variantsWrapper, s);
  if (h) {
    var v = h.dataset,
      m = v.enableDynamicProductOptions,
      g = v.currentVariantId;
    if ("false" !== m) {
      var y = JSON.parse(n$2(selectors$H.variantsJson, s).innerText),
        b = t$2(selectors$H.input, s),
        _ = t$2(selectors$H.inputWrap, s),
        $ = [];
      return (
        b.forEach(function (s) {
          $.push(e$2(s, "change", S));
        }),
        (function s() {
          _.forEach(function (s) {
            var h;
            return (
              (h = s),
              void (
                a$1(h, "select-wrapper") ||
                t$2(selectors$H.buttonWrap, h).forEach(function (s) {
                  return u$1(s, classes$k.disabled);
                })
              )
            );
          });
          for (
            var h = y
                .find(function (s) {
                  return s.id === parseInt(g, 10);
                })
                .options.map(function (s, h) {
                  return {
                    value: s,
                    index: "option".concat(h + 1),
                  };
                }),
              v = k(y, h),
              m = 0,
              b = Object.entries(v);
            m < b.length;
            m++
          ) {
            var $,
              S = _slicedToArray(b[m], 2);
            E(S[0], S[1]);
          }
        })(),
        {
          unload: function s() {
            $.forEach(function (s) {
              return s();
            });
          },
        }
      );
    }
  }

  function k(s, h) {
    return s.reduce(
      function (s, v) {
        return (
          Object.keys(s).forEach(function (m) {
            if (null !== v[m]) {
              var g = s[m].find(function (s) {
                return s.value === v[m];
              });
              void 0 === g &&
                ((g = {
                  value: v[m],
                  soldOut: !0,
                }),
                s[m].push(g));
              var y = h.find(function (s) {
                  return "option1" === s.index;
                }),
                b = h.find(function (s) {
                  return "option2" === s.index;
                });
              switch (m) {
                case "option1":
                  g.soldOut = (!g.soldOut || !v.available) && g.soldOut;
                  break;
                case "option2":
                  y &&
                    v.option1 === y.value &&
                    (g.soldOut = (!g.soldOut || !v.available) && g.soldOut);
                  break;
                case "option3":
                  y &&
                    v.option1 === y.value &&
                    b &&
                    v.option2 === b.value &&
                    (g.soldOut = (!g.soldOut || !v.available) && g.soldOut);
              }
            }
          }),
          s
        );
      },
      {
        option1: [],
        option2: [],
        option3: [],
      },
    );
  }

  function S() {
    !(function s(h) {
      for (var v = k(y, h), m = 0, g = Object.entries(v); m < g.length; m++) {
        var b,
          _ = _slicedToArray(g[m], 2);
        E(_[0], _[1]);
      }
    })(
      b.map(function (s) {
        return {
          value: s.value,
          index: s.id,
        };
      }),
    );
  }

  function E(h, v) {
    var m = n$2(selectors$H.inputWrapWithValue(h), s);
    v.forEach(function (s) {
      !(function s(h, v) {
        var m,
          g,
          y =
            ((m = v.value),
            (g = {
              '"': '\\"',
              "'": "\\'",
            }),
            m.replace(/"|'/g, function (s) {
              return g[s];
            }));
        if (!a$1(h, "select-wrapper")) {
          var b = n$2(selectors$H.buttonWrapWithValue(y), h);
          (i$1(b, classes$k.disabled), v.soldOut && u$1(b, classes$k.disabled));
        }
      })(m, s);
    });
  }
}
var selectors$G = {
  siblingProducts: "[data-sibling-products]",
  siblingSwatch: "[data-sibling-swatch]",
  siblingLabelEl: "[data-sibling-label-value]",
};

function siblingProducts(s) {
  var h = n$2(selectors$G.siblingProducts, s);
  if (h) {
    var v = t$2(selectors$G.siblingSwatch, h),
      m = n$2(selectors$G.siblingLabelEl, h),
      g = m.innerText,
      y = [];
    return (
      v.forEach(function (s) {
        y.push(
          e$2(s, "mouseout", function () {
            m.innerText !== g && (m.innerText = g);
          }),
          e$2(s, "mouseover", function (s) {
            var h, v;
            return (
              (h = s),
              (v = h.target.dataset.siblingCutline),
              void (m.innerText = v)
            );
          }),
        );
      }),
      {
        unload: function s() {
          y.forEach(function (s) {
            return s();
          });
        },
      }
    );
  }
}
window.theme.strings.products;
var selectors$F = {
    unitPriceContainer: "[data-unit-price-container]",
    unitPrice: "[data-unit-price]",
    unitPriceBase: "[data-unit-base]",
    preSaleData: "[data-pre-sale]",
  },
  classes$j = {
    available: "unit-price--available",
  },
  updateUnitPrices = function s(h, v) {
    const isPreSale = h
      .querySelector(selectors$F.preSaleData)
      ?.getAttribute("data-pre-sale")
      ? true
      : false;
    const preSaleData = isPreSale
      ? JSON.parse(
          h
            .querySelector(selectors$F.preSaleData)
            .getAttribute("data-pre-sale"),
        )
      : null;
    var unitPrice = v && v.unit_price ? v.unit_price : null;

    if (
      isPreSale &&
      preSaleData &&
      preSaleData[v.id] &&
      preSaleData[v.id] > 0 &&
      unitPrice
    ) {
      const preSalePrice = preSaleData[v.id];
      const measurementMultiplier = unitPrice / v.price;

      unitPrice = preSalePrice * measurementMultiplier;
      console.log("Adjusted unit price for pre-sale:", unitPrice);
    }

    var m = t$2(selectors$F.unitPriceContainer, h),
      g = t$2(selectors$F.unitPrice, h),
      y = t$2(selectors$F.unitPriceBase, h),
      b = !v || !unitPrice;
    (l(m, classes$j.available, !b),
      unitPrice &&
        (_replaceText(g, formatMoney(unitPrice)),
        _replaceText(y, _getBaseUnit(v.unit_price_measurement))));
  },
  _getBaseUnit = function s(h) {
    return 1 === h.reference_value
      ? h.reference_unit
      : h.reference_value + h.reference_unit;
  },
  _replaceText = function s(h, v) {
    h.forEach(function (s) {
      return (s.innerText = v);
    });
  },
  storeAvailability = function s(h, v, m) {
    var g = function s(m) {
      ((h.innerHTML = ""),
        m &&
          makeRequest(
            "GET",
            ""
              .concat(h.dataset.baseUrl, "/variants/")
              .concat(m.id, "/?section_id=store-availability"),
          ).then(function (s) {
            "" !== s.trim() &&
              ((h.innerHTML = s.trim()),
              (h.innerHTML = h.firstElementChild.innerHTML),
              h.setAttribute("data-variant-id", m.id),
              h.setAttribute("data-product-title", v.title),
              h.setAttribute("data-variant-title", m.public_title));
          }));
    };
    return (
      g(m),
      {
        unload: function s() {
          h.innerHTML = "";
        },
        update: g,
      }
    );
  },
  selectors$E = {
    form: "[data-product-form]",
    addToCart: "[data-add-to-cart]",
    stickyAddToCart: "[data-sticky-add-to-cart]",
    variantSelect: "[data-variant-select]",
    optionById: function s(h) {
      return "[value='".concat(h, "']");
    },
    thumbs: "[data-product-thumbnails]",
    thumb: "[data-product-thumbnail]",
    storeAvailability: "[data-store-availability-container]",
    quantityError: "[data-quantity-error]",
    productOption: ".product__option",
    optionLabelValue: "[data-selected-value-for-option]",
    displayedDiscount: "[data-discount-display]",
    displayedDiscountByVariantId: function s(h) {
      return '[variant-discount-display][variant-id="'.concat(h, '"]');
    },
    nonSprRatingCountLink: ".product__rating-count-potential-link",
    photosMobile: ".product__media-container.below-mobile",
    photosDesktop: ".product__media-container.above-mobile",
    priceWrapper: ".product__price",
    quickCart: ".quick-cart",
    purchaseConfirmation: ".purchase-confirmation-popup",
    productReviews: "#shopify-product-reviews",
    customOptionInputs: "[data-custom-option-input]",
    customOptionInputTargetsById: function s(h) {
      return "[data-custom-option-target='".concat(h, "']");
    },
  },
  Product = (function () {
    function s(h) {
      var v = this;
      (_classCallCheck(this, s), (this.container = h), (this.accordions = []));
      var m = this.container.dataset,
        g = m.isQuickView,
        y = m.isFullProduct,
        b = m.isFeaturedProduct,
        _ = m.enableStickyProductDetails;
      ((this.isQuickView = g),
        (this.isFullProduct = y),
        (this.isFeaturedProduct = b),
        (this.formElement = n$2(selectors$E.form, this.container)),
        (this.quantityError = n$2(selectors$E.quantityError, this.container)),
        (this.displayedDiscount = n$2(
          selectors$E.displayedDiscount,
          this.container,
        )),
        (this.viewInYourSpace = n$2("[data-in-your-space]", this.container)),
        this.viewInYourSpace &&
          l(this.viewInYourSpace, "visible", isMobile$1()),
        (this.photosDesktop = n$2(selectors$E.photosDesktop, this.container)),
        (this.breakPointHandler = atBreakpointChange(960, function () {
          if (window.matchMedia(getMediaQuery("below-960")).matches)
            v._initPhotoCarousel();
          else {
            var s;
            null === (s = v.mobileSwiper) || void 0 === s || s.destroy();
          }
        })),
        window.matchMedia(getMediaQuery("below-960")).matches &&
          this._initPhotoCarousel(),
        (this.productThumbnails = n$2(selectors$E.thumbs, this.container)),
        (this.productThumbnailItems = t$2(selectors$E.thumb, this.container)),
        this.productThumbnails &&
          (this.productThumbnailsScroller = scrollContainer(
            this.productThumbnails,
          )),
        (this.moreMedia = moreMedia(this.container)),
        (this.storeAvailabilityContainer = n$2(
          selectors$E.storeAvailability,
          this.container,
        )),
        (this.availability = null),
        (this.reviewsHandler = reviewsHandler(
          n$2(selectors$E.productReviews, this.container),
          this.container,
        )));
      var $ = n$2(selectors$E.nonSprRatingCountLink, this.container);
      if (
        ($ &&
          !n$2(selectors$E.productReviews, document) &&
          $.removeAttribute("href"),
        this.formElement)
      ) {
        var k = this.formElement.dataset,
          S = k.productHandle,
          E = k.currentProductId;
        getProduct(S)(function (s) {
          var h = getVariantFromId(s, parseInt(E));
          (v.storeAvailabilityContainer &&
            h &&
            (v.availability = storeAvailability(
              v.storeAvailabilityContainer,
              s,
              h,
            )),
            (v.productForm = ProductForm(v.container, v.formElement, s, {
              onOptionChange: function s(h) {
                return v.onOptionChange(h);
              },
              onFormSubmit: function s(h) {
                return v.onFormSubmit(h);
              },
              onNewFormSubmit: function s(h) {
                return v.onNewFormSubmit(h);
              },
              onQuantityChange: function s(h) {
                return v.onQuantityChange(h);
              },
            })));
          var m = n$2("[data-product-inventory-json]", v.container);
          if (m) {
            var g = JSON.parse(m.innerHTML).inventory;
            if (g) {
              var y = {
                id: h.id,
                variantsInventories: g,
              };
              v.inventoryCounter = inventoryCounter(v.container, y);
            }
          }
        });
      }
      ((this.quantityInput = quantityInput(this.container)),
        (this.customOptionInputs = t$2(
          selectors$E.customOptionInputs,
          this.container,
        )),
        (this.socialButtons = t$2("[data-social-share]", this.container)),
        (this.featuredProducts = featuredProducts(this.container)),
        "true" !== _ ||
          isMobile$1() ||
          (this.stickyScroll = stickyScroll(this.container)),
        t$2(".accordion", this.container).forEach(function (s) {
          var h = s.classList.contains("accordion--open");
          v.accordions.push(
            Accordions(s, {
              firstOpen: h,
            }),
          );
          var m = s.parentElement;
          m.classList.contains("rte--product") &&
            !m.classList.contains("accordion accordion--product") &&
            s.classList.add("rte--product", "accordion--product");
        }),
        (this.mediaContainers = Media(
          n$2(".product__media-container.above-mobile", this.container),
        )),
        (this.mediaContainersMobile = Media(
          n$2(".product__media-container.below-mobile", this.container),
        )),
        (this.optionButtons = OptionButtons(
          t$2("[data-option-buttons]", this.container),
        )),
        (this.informationPopup = informationPopup(this.container)));
      var T = n$2(".product__description", this.container);
      T && (wrapIframes(t$2("iframe", T)), wrapTables(t$2("table", T)));
      var C = n$2(".social-share", this.container);
      (C && (this.socialShare = SocialShare(C)),
        this._initEvents(),
        (this.variantAvailability = variantAvailability(this.container)),
        (this.siblingProducts = siblingProducts(this.container)));
    }
    return (
      _createClass(s, [
        {
          key: "_initEvents",
          value: function s() {
            var h = this;
            ((this.events = [
              e$2(this.productThumbnailItems, "click", function (s) {
                s.preventDefault();
                var v = s.currentTarget.dataset;
                (h.productThumbnailItems.forEach(function (s) {
                  return i$1(s, "active");
                }),
                  u$1(s.currentTarget, "active"),
                  switchImage(
                    h.photosDesktop,
                    v.thumbnailId,
                    h.viewInYourSpace,
                  ));
              }),
            ]),
              this.customOptionInputs &&
                this.customOptionInputs.forEach(function (s) {
                  var v = s.dataset.customOptionInput,
                    m = n$2(
                      selectors$E.customOptionInputTargetsById(v),
                      h.container,
                    );
                  h.events.push(
                    e$2(s, "change", function (s) {
                      "checkbox" === s.target.type
                        ? (m.checked = s.target.checked)
                        : (m.value = s.target.value);
                    }),
                  );
                }));
          },
        },
        {
          key: "_initPhotoCarousel",
          value: function s() {
            var h = this,
              v = n$2(selectors$E.photosMobile, this.container);
            import(flu.chunks.swiper).then(function (s) {
              var m = s.Swiper,
                g = s.Pagination;
              ((h.mobileSwiper = new m(v, {
                modules: [g],
                slidesPerView: 1,
                spaceBetween: 4,
                grabCursor: !0,
                pagination: {
                  el: ".swiper-pagination",
                  type: "bullets",
                  dynamicBullets: !0,
                  dynamicMainBullets: 7,
                  clickable: !0,
                },
                watchSlidesProgress: !0,
                autoHeight: !0,
              })),
                h.mobileSwiper.on("slideChange", function (s) {
                  if (h.viewInYourSpace) {
                    var v = s.slides[s.activeIndex];
                    "model" === v.dataset.mediaType &&
                      h.viewInYourSpace.setAttribute(
                        "data-shopify-model3d-id",
                        v.dataset.mediaItemId,
                      );
                  }
                  h.mediaContainersMobile &&
                    h.mediaContainersMobile.pauseActiveMedia();
                }));
            });
          },
        },
        {
          key: "onOptionChange",
          value: function s(h) {
            var v = h.dataset.variant,
              m = h.srcElement,
              g = m.closest(selectors$E.productOption),
              y = n$2(selectors$E.optionLabelValue, g);
            y && (y.textContent = m.value);
            var b = n$2(selectors$E.addToCart, this.container),
              _ = n$2(selectors$E.stickyAddToCart, this.container),
              $ = n$2(selectors$E.priceWrapper, this.container);
            if (
              ($ && l($, "hide", !v),
              updatePrices(this.container, v),
              updateBuyButton(b, v),
              updateBuyButton(_, v),
              updateUnitPrices(this.container, v),
              updateSku(this.container, v),
              this.availability && this.availability.update(v),
              this.displayedDiscount)
            ) {
              var k =
                v &&
                n$2(
                  selectors$E.displayedDiscountByVariantId(v.id),
                  this.container,
                );
              v && k
                ? (this.displayedDiscount.textContent = k.textContent)
                : (this.displayedDiscount.textContent = "");
            }
            if (
              (this.inventoryCounter && this.inventoryCounter.update(v),
              dispatchCustomEvent("product:variant-change", {
                variant: v,
              }),
              !v)
            ) {
              (updateBuyButton(n$2("[data-add-to-cart]", this.container), !1),
                this.availability && this.availability.unload());
              return;
            }
            var S = getUrlWithVariant(window.location.href, v.id);
            if (
              (window.history.replaceState(
                {
                  path: S,
                },
                "",
                S,
              ),
              (n$2(
                ""
                  .concat(selectors$E.variantSelect, " ")
                  .concat(selectors$E.optionById(v.id)),
                this.container,
              ).selected = !0),
              this.formElement.dispatchEvent(new Event("change")),
              v.featured_media)
            ) {
              if (this.isFullProduct) {
                if (this.mobileSwiper) {
                  var E = this.mobileSwiper.el,
                    T = n$2(
                      '[data-media-item-id="'.concat(v.featured_media.id, '"]'),
                      E,
                    );
                  if (T) {
                    var C = _toConsumableArray$1(
                      T.parentElement.children,
                    ).indexOf(T);
                    this.mobileSwiper.slideTo(C);
                  }
                } else if (
                  "thumbnails" ===
                  n$2(".product__media-container.above-mobile").dataset
                    .galleryStyle
                ) {
                  switchImage(
                    this.photosDesktop,
                    v.featured_media.id,
                    this.viewInYourSpace,
                  );
                  var I = n$2(
                    '[data-thumbnail-id="'.concat(v.featured_media.id, '"]'),
                    this.photosDesktop,
                  );
                  (this.productThumbnailItems.forEach(function (s) {
                    return i$1(s, "active");
                  }),
                    u$1(I, "active"));
                } else {
                  var A = n$2(
                    '.product__media-container.above-mobile [data-media-id="'.concat(
                      v.featured_media.id,
                      '"]',
                    ),
                  );
                  this.isFeaturedProduct
                    ? this.switchCurrentImage(v.featured_media.id)
                    : A.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "nearest",
                      });
                }
              } else this.switchCurrentImage(v.featured_media.id);
            }
          },
        },
        {
          key: "switchCurrentImage",
          value: function s(h) {
            t$2(".product__media", this.container).forEach(function (s) {
              return switchImage(s, h);
            });
          },
        },
        {
          key: "onQuantityChange",
          value: function s(h) {
            var v = h.dataset,
              m = v.variant,
              g = v.quantity;
            (_toConsumableArray$1(
              t$2('[name="quantity"]', this.formElement),
            ).forEach(function (s) {
              s.value = g;
            }),
              dispatchCustomEvent("product:quantity-update", {
                quantity: g,
                variant: m,
              }));
          },
        },
        {
          key: "onFormSubmit",
          value: function s(h) {
            var v = this,
              m = n$2(selectors$E.purchaseConfirmation, document),
              g = n$2(selectors$E.quickCart, document),
              y = Boolean(h.target.closest(".quick-product"));
            if (m || g || y) {
              (h.preventDefault(), u$1(this.quantityError, "hidden"));
              var b = n$2(selectors$E.addToCart, this.container);
              (u$1(b, "loading"),
                cart
                  .addItem(this.formElement)
                  .then(function (s) {
                    var h = s.item;
                    (i$1(b, "loading"),
                      m
                        ? r$1("confirmation-popup:open", null, {
                            product: h,
                          })
                        : (r$1("quick-cart:updated"),
                          setTimeout(function () {
                            r$1("quick-cart:open");
                          }, 300)),
                      dispatchCustomEvent("cart:item-added", {
                        product: h,
                      }));
                  })
                  .catch(function (s) {
                    (cart.get(),
                      s && s.message
                        ? (v.quantityError.innerText = s.message)
                        : (v.quantityError.innerText =
                            v.quantityErorr.getAttribute(
                              "data-fallback-error-message",
                            )),
                      i$1(v.quantityError, "hidden"));
                    var h = n$2(selectors$E.addToCart, v.container);
                    (i$1(h, "loading"), i$1(buttonSticky, "loading"));
                  }));
            }
          },
        },
        {
          key: "onNewFormSubmit",
          value: function s(h) {
            var v = this,
              m = n$2(selectors$E.purchaseConfirmation, document),
              g = n$2(selectors$E.quickCart, document),
              y = Boolean(h.target.closest(".quick-product"));
            if (m || g || y) {
              (h.preventDefault(), u$1(this.quantityError, "hidden"));
              var b = n$2(selectors$E.addToCart, this.container);
              (u$1(b, "loading"),
                cart
                  .addItem(this.formElement)
                  .then(function (s) {
                    var h = s.item;
                    (i$1(b, "loading"),
                      m
                        ? r$1("confirmation-popup:open", null, {
                            product: h,
                          })
                        : r$1("quick-cart:updated"),
                      dispatchCustomEvent("cart:item-added", {
                        product: h,
                      }));
                  })
                  .catch(function (s) {
                    (cart.get(),
                      s && s.message
                        ? (v.quantityError.innerText = s.message)
                        : (v.quantityError.innerText =
                            v.quantityErorr.getAttribute(
                              "data-fallback-error-message",
                            )),
                      i$1(v.quantityError, "hidden"));
                    var h = n$2(selectors$E.addToCart, v.container);
                    (i$1(h, "loading"), i$1(buttonSticky, "loading"));
                  }));
            }
          },
        },
        {
          key: "unload",
          value: function s() {
            var h, v, m, g, y, b, _;
            (this.productForm.destroy(),
              this.accordions.forEach(function (s) {
                return s.unload();
              }),
              this.optionButtons.destroy(),
              null === (h = this.quantityInput) || void 0 === h || h.unload(),
              this.events.forEach(function (s) {
                return s();
              }),
              null === (v = this.mobileSwiper) || void 0 === v || v.destroy(),
              null === (m = this.stickyScroll) || void 0 === m || m.destroy(),
              null === (g = this.moreMedia) || void 0 === g || g.unload(),
              null === (y = this.featuredProducts) ||
                void 0 === y ||
                y.unload(),
              null === (b = this.variantAvailability) ||
                void 0 === b ||
                b.unload(),
              null === (_ = this.siblingProducts) ||
                void 0 === _ ||
                _.unload());
          },
        },
      ]),
      s
    );
  })(),
  classes$i = {
    visible: "is-visible",
    active: "active",
    fixed: "is-fixed",
  },
  selectors$D = {
    closeBtn: "[data-modal-close]",
    wash: ".modal__wash",
    modalContent: ".quick-view-modal__content",
    loadingMessage: ".quick-view-modal-loading-indicator",
  },
  quickViewModal = function s(h) {
    var v,
      m = createFocusTrap(h, {
        allowOutsideClick: !0,
      }),
      g = n$2(selectors$D.wash, h),
      y = n$2(selectors$D.closeBtn, h),
      b = n$2(selectors$D.modalContent, h),
      _ = n$2(selectors$D.loadingMessage, h),
      $ = null;
    shouldAnimate(h) && ($ = animateQuickView(h));
    var k = [
        e$2([g, y], "click", function (s) {
          (s.preventDefault(), T());
        }),
        e$2(h, "keydown", function (s) {
          27 === s.keyCode && T();
        }),
        c("quick-view:open", function (s, h) {
          (S(h.productUrl), E());
        }),
        c("quick-view:close", function () {
          T();
        }),
      ],
      S = function s(m) {
        makeRequest(
          "GET",
          "".concat(m).concat(m.includes("?") ? "&" : "?", "view=quick-view"),
        ).then(function (s) {
          var m = document.createElement("div");
          m.innerHTML = s;
          var g = n$2("[data-is-quick-view]", m);
          (i$1(b, "empty"), (b.innerHTML = ""), b.appendChild(g));
          var y = n$2("[data-is-quick-view]", b);
          (shouldAnimate(h) && $.animate(),
            (v = new Product(y)),
            dispatchCustomEvent("quickview:loaded"));
        });
      },
      E = function s() {
        (u$1(h, classes$i.fixed),
          setTimeout(function () {
            (u$1(h, classes$i.active),
              setTimeout(function () {
                (u$1(h, classes$i.visible), m.activate());
              }, 50));
          }, 50),
          document.body.setAttribute("data-fluorescent-overlay-open", "true"),
          disableBodyScroll(h, {
            allowTouchMove: function s(h) {
              for (; h && h !== document.body; ) {
                if (null !== h.getAttribute("data-scroll-lock-ignore"))
                  return !0;
                h = h.parentNode;
              }
            },
            reserveScrollBarGap: !0,
          }));
      },
      T = function s() {
        (m.deactivate(),
          i$1(h, classes$i.visible),
          i$1(h, classes$i.active),
          document.body.setAttribute("data-fluorescent-overlay-open", "false"),
          enableBodyScroll(h),
          r$1("quick-cart:scrollup"),
          setTimeout(function () {
            var s;
            (i$1(h, classes$i.fixed),
              shouldAnimate(h) && $.reset(),
              (b.innerHTML = ""),
              b.appendChild(_),
              u$1(b, "empty"),
              null === (s = v) || void 0 === s || s.unload());
          }, 500));
      };
    return {
      unload: function s() {
        k.forEach(function (s) {
          return s();
        });
      },
    };
  },
  icons$1 = window.theme.icons;

function productLightbox() {
  var s;
  t$2(".lightbox-image", document).length &&
    import(flu.chunks.photoswipe).then(function (h) {
      var v = h.PhotoSwipeLightbox,
        m = h.PhotoSwipe;
      ((s = new v({
        gallery: ".lightbox-media-container",
        children: ".lightbox-image",
        pswpModule: m,
        mainClass: "pswp--product-lightbox",
        bgOpacity: 1,
        arrowPrevSVG: icons$1.chevron,
        arrowNextSVG: icons$1.chevron,
        closeSVG: icons$1.close,
        zoomSVG: icons$1.zoom,
      })).init(),
        s.on("firstUpdate", function () {
          var h = s,
            v = h.pswp;
          1 === h.options.dataSource.items.length &&
            u$1(v.element, "pswp--is-single-image");
        }));
    });
}
var classes$h = {
    visible: "is-visible",
  },
  flashAlertModal = function s(h) {
    (window.Shopify.designMode &&
      new Delegate(document.body).on(
        "click",
        "[data-flash-trigger]",
        function (s, h) {
          v(h.dataset.flashMessage);
        },
      ),
      c("flart-alert", function (s) {
        v(s.alert);
      }));
    var v = function s(v) {
      if (v) {
        var m = n$2(".flash-alert__container", h);
        ((m.innerText = v),
          u$1(h, classes$h.visible),
          m.addEventListener(
            "animationend",
            function () {
              i$1(h, classes$h.visible);
            },
            {
              once: !0,
            },
          ));
      }
    };
  },
  selectors$C = {
    innerOverlay: ".header-overlay__inner",
  },
  classes$g = {
    isVisible: "is-visible",
    isActive: "is-active",
  },
  events = {
    show: "headerOverlay:show",
    hide: "headerOverlay:hide",
    hiding: "headerOverlay:hiding",
  },
  headerOverlay = function s(h) {
    if (h) {
      var v = h,
        m = h.querySelector(selectors$C.innerOverlay),
        g = c(events.show, function () {
          return b();
        }),
        y = c(events.hide, function () {
          return _();
        }),
        b = function s() {
          (o$1({
            headerOverlayOpen: !0,
          }),
            v.classList.add(classes$g.isActive),
            setTimeout(function () {
              m.classList.add(classes$g.isVisible);
            }, 0));
        },
        _ = function s() {
          (o$1({
            headerOverlayOpen: !1,
          }),
            r$1(events.hiding),
            m.classList.remove(classes$g.isVisible),
            setTimeout(function () {
              v.classList.remove(classes$g.isActive);
            }, 0));
        };
      return {
        unload: function s() {
          (g(), y());
        },
      };
    }
  };

function debounce(s) {
  var h = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100;
  return function (v) {
    (timer && clearTimeout(timer), (timer = setTimeout(s, h, v)));
  };
}
var supportsNativeSmoothScroll =
    "scrollBehavior" in document.documentElement.style,
  backToTop = function s() {
    var h = n$2("[data-back-to-top]");
    if (h) {
      var v = window.innerHeight,
        m = !1;
      (srraf(function (s) {
        var g = s.y;
        return debounce(function () {
          var s;
          return (
            (s = g),
            void (
              ((s > v && !m) || (s < v && m)) &&
              void (l(h, "visible"), (m = !m))
            )
          );
        })();
      }),
        n$2("[data-back-to-top-button]", h).addEventListener(
          "click",
          function s() {
            supportsNativeSmoothScroll
              ? window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior: "smooth",
                })
              : window.scrollTo(0, 0);
          },
        ));
    }
  };

function PredictiveSearch(s) {
  var h = {};

  function v(h) {
    s.innerHTML = h;
  }
  return {
    getSearchResults: function s(m) {
      var g = m.replace(" ", "-").toLowerCase();
      if (h["".concat(g)]) {
        v(h["".concat(g)]);
        return;
      }
      fetch(
        ""
          .concat(window.theme.routes.predictive_search_url, "?q=")
          .concat(
            encodeURIComponent(m),
            "&resources[type]=query,product,collection,page&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search",
          ),
      )
        .then(function (s) {
          if (!s.ok) throw Error(s.status);
          return s.text();
        })
        .then(function (s) {
          var m = new DOMParser()
            .parseFromString(s, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
          ((h[g] = m), v(m));
        })
        .catch(function (s) {
          throw s;
        });
    },
  };
}

function PredictiveSearchAdvance(s) {
  return {
    getSearchResults: function h(v) {
      var m;
      fetch(
        window.Shopify.routes.root +
          "search/suggest?q=".concat(
            encodeURIComponent(v),
            "&resources[type]=query,product,collection,page,article&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,body,author&section_id=quick-search-advance",
          ),
      )
        .then((s) => ((m = s), s.text()))
        .then(function (h) {
          if (!m.ok) throw Error(`${m.status}: ${h}`);
          window.updateSearchHTML(h, s);
        })
        .catch(function (s) {
          throw s;
        });
    },
  };
}

function getHistoryFromCookies() {
  let s = document.cookie.split("; ");
  for (let h = 0; h < s.length; h++) {
    let v = s[h].split("=");
    if ("history" === v[0]) return JSON.parse(v[1]);
  }
  return [];
}

function addToHistoryAndUpdateCookies(s) {
  if (s && null != s) {
    var h = s.replaceAll("+", " ");
    let v = searchHistory.indexOf(h);
    (-1 !== v && searchHistory.splice(v, 1),
      searchHistory.unshift(h),
      searchHistory.length > 5 && searchHistory.pop(),
      (document.cookie =
        "history=" + JSON.stringify(searchHistory) + "; path=/"),
      cookieHostory.updateHistoryHTML());
  }
}

function updateHistoryHTML() {
  let s = document.querySelector("[search-advance-history]");
  s &&
    ((s.innerHTML = ""),
    searchHistory && searchHistory.length > 0
      ? (s.parentNode.classList.remove("hidden"),
        searchHistory.forEach((h, v) => {
          let m = document.createElement("li");
          m.setAttribute("data-search-history-index", v);
          let g = document.createElement("span");
          ((g.className = "s_h_icon"),
            (g.innerHTML =
              '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke="#0A2923" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 3.625V8.21875L10.625 9.75" stroke="#0A2923" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'));
          let y = document.createElement("a");
          ((y.href = `/search?q=${h}&options%5Btype%5D=product&options%5Bprefix%5D=last`),
            (y.className = "searched_string"),
            (y.textContent = h));
          let b = document.createElement("span");
          ((b.className = "s_h_close"),
            b.setAttribute("data-search-history-delete", ""),
            b.addEventListener("click", () => {
              cookieHostory.remove(v);
            }),
            m.appendChild(g),
            m.appendChild(y),
            m.appendChild(b),
            s.appendChild(m));
        }))
      : s.parentNode.classList.add("hidden"));
}

function removeFromHistoryAndUpdateCookies(s) {
  (s >= 0 &&
    s < searchHistory.length &&
    (searchHistory.splice(s, 1),
    (document.cookie =
      "history=" + JSON.stringify(searchHistory) + "; path=/")),
    cookieHostory.updateHistoryHTML());
}

function getQueryParameter(s) {
  let h = window.location.search.substring(1),
    v = h.split("&");
  for (let m = 0; m < v.length; m++) {
    let g = v[m].split("=");
    if (g[0] === s) return decodeURIComponent(g[1]);
  }
  return null;
}
var cookieHostory = {
  get: getHistoryFromCookies,
  add: addToHistoryAndUpdateCookies,
  remove: removeFromHistoryAndUpdateCookies,
  updateHistoryHTML: updateHistoryHTML,
};
let searchHistory = cookieHostory.get();
(cookieHostory.updateHistoryHTML(),
  "/search" == window.location.pathname &&
    cookieHostory.add(getQueryParameter("q")));
var classes$f = {
  active: "active",
  visible: "quick-search--visible",
};

function QuickSearch(s, h, v) {
  var m = n$2("[data-overlay]", s),
    g = n$2("[data-quick-search-form]", s),
    y = n$2("[data-input]", s),
    b = n$2("[data-clear]", s),
    _ = n$2("[data-results]", s);
  if ("data-quick-search" == v) var $ = PredictiveSearch(_);
  else var $ = PredictiveSearchAdvance(_);
  var k = n$2("[data-close-icon]", s),
    S = t$2("[data-search]", h),
    E = 0,
    T = [
      e$2([m, k], "click", A),
      e$2(b, "click", I),
      e$2(y, "input", function s(h) {
        ("" === h.target.value && I(),
          l(b, classes$f.visible, "" !== h.target.value),
          l(y.parentNode, classes$f.active, "" !== h.target.value),
          l(g, classes$f.active, "" !== h.target.value),
          $.getSearchResults(h.target.value));
      }),
      e$2(s, "keydown", function (s) {
        27 === s.keyCode && A();
      }),
      c("drawer-menu:open", function () {
        a$1(s, classes$f.active) && A();
      }),
    ],
    C = createFocusTrap(s, {
      allowOutsideClick: !0,
    });

  function I(s) {
    (s && s.preventDefault(),
      (y.value = ""),
      i$1(b, classes$f.visible),
      i$1(y.parentNode, classes$f.active),
      i$1(g, classes$f.active),
      (_.innerHTML = ""),
      y.focus());
  }

  function A() {
    (S.forEach(function (s) {
      s.setAttribute("aria-expanded", !1);
    }),
      i$1(s, classes$f.visible),
      document.body.setAttribute("quick-search-open", "false"),
      C.deactivate(),
      setTimeout(function () {
        (i$1(s, classes$f.active),
          s.setAttribute("aria-hidden", !0),
          document.body.setAttribute("data-fluorescent-overlay-open", "false"),
          enableBodyScroll(s),
          document.body.classList.remove("scroll-lock"),
          (document.body.style.top = ""),
          window.scrollTo(0, E));
      }, 500));
  }
  return {
    toggleSearch: function h() {
      (s.style.setProperty("--scroll-y", Math.ceil(window.scrollY) + "px"),
        "false" === s.getAttribute("aria-hidden")
          ? A()
          : (r$1("search:open"),
            S.forEach(function (s) {
              s.setAttribute("aria-expanded", !0);
            }),
            u$1(s, classes$f.active),
            s.setAttribute("aria-hidden", !1),
            document.body.setAttribute("quick-search-open", "true"),
            C.activate(),
            setTimeout(function () {
              (y.focus({
                preventScroll: !0,
              }),
                document.body.setAttribute(
                  "data-fluorescent-overlay-open",
                  "true",
                ),
                disableBodyScroll(s, {
                  allowTouchMove: function s(h) {
                    for (; h && h !== document.body; ) {
                      if (null !== h.getAttribute("data-scroll-lock-ignore"))
                        return !0;
                      h = h.parentNode;
                    }
                  },
                  reserveScrollBarGap: !0,
                }),
                (E = window.pageYOffset),
                (document.body.style.top = "-".concat(E, "px")),
                document.body.classList.add("scroll-lock"),
                u$1(s, classes$f.visible));
            }, 50)));
    },
    destroy: function s() {
      (A(),
        T.forEach(function (s) {
          return s();
        }));
    },
  };
}

function Navigation(s, h) {
  if (s) {
    var v = t$2("[data-dropdown-trigger]", s),
      m = t$2("[data-meganav-trigger]", s),
      g = t$2(".meganav, node"),
      y = t$2(
        ".header__links-list > li > [data-link]:not([data-meganav-trigger]):not([data-dropdown-trigger])",
        s,
      ),
      b = n$2('[data-section-type="header"]', document.body),
      _ = n$2(".header__links-primary", b),
      $ = n$2(".navigation__submenu .navigation__submenu-item", s);
    if (v) {
      $ &&
        s.style.setProperty(
          "--submenu-item-height",
          "".concat($.clientHeight, "px"),
        );
      var k = new Delegate(document.body);
      (k.on("click", null, function (s) {
        var h;
        return (
          (h = s),
          void (
            h.target.closest("[data-submenu-parent]") ||
            h.target.closest(".meganav") ||
            h.target.closest("[data-search]") ||
            h.target.closest("[data-quick-search]") ||
            A()
          )
        );
      }),
        k.on("mouseover", ".header-overlay__inner", function (v) {
          (!Shopify.designMode || !h.meganavOpenedFromDesignMode) && A(s);
        }),
        g.forEach(function (s) {
          shouldAnimate(s) && animateMeganav(s);
        }));
      var S = [
        e$2(v, "focus", function (s) {
          (s.preventDefault(), I(s.currentTarget.parentNode));
        }),
        e$2(v, "mouseover", function (s) {
          (s.preventDefault(), I(s.currentTarget.parentNode, !0));
        }),
        e$2(m, "focus", function (s) {
          (s.preventDefault(), T(s.target, s.target.dataset.meganavHandle));
        }),
        e$2(m, "mouseover", function (s) {
          (s.preventDefault(), T(s.target, s.target.dataset.meganavHandle));
        }),
        e$2(y, "mouseover", function () {
          A();
        }),
        e$2(_, "mouseout", function (s) {
          var h;
          (null === (h = s.relatedTarget) || void 0 === h
            ? void 0
            : h.closest(".header__links-primary")) != _ && A();
        }),
        e$2(h.container, "mouseleave", function () {
          (i$1(b, "animation--dropdowns-have-animated-once"),
            i$1(b, "animation--dropdowns-have-animated-more-than-once"));
        }),
        e$2(s, "keydown", function (s) {
          27 === s.keyCode && A();
        }),
        e$2(t$2(".header__links-list > li > a", s), "focus", function () {
          E() && A();
        }),
        e$2(t$2("[data-link]", s), "focus", function (s) {
          if ((s.preventDefault(), E())) {
            var h = s.currentTarget;
            (h.hasAttribute("data-dropdown-trigger") && I(h.parentNode),
              t$2("[data-link]", h.parentNode.parentNode).forEach(function (s) {
                return l(
                  t$2("[data-submenu]", s.parentNode),
                  "active",
                  s === h,
                );
              }));
          }
        }),
        e$2(t$2("[data-link]", s), "focusout", function (s) {
          E() &&
            s.relatedTarget &&
            !(
              s.relatedTarget.hasAttribute("data-link") ||
              s.relatedTarget.closest(".meganav")
            ) &&
            A();
        }),
        e$2(s, "scroll", function () {
          document.documentElement.style.setProperty(
            "--navigation-menu-offet",
            "".concat(s.scrollLeft, "px"),
          );
        }),
      ];
      return {
        destroy: function s() {
          (k.off(),
            S.forEach(function (s) {
              return s();
            }));
        },
      };
    }
  }

  function E() {
    return a$1(document.body, "user-is-tabbing");
  }

  function T(s, h) {
    var v = n$2('.meganav[data-menu-handle="'.concat(h, '"]'), b);
    !v ||
      a$1(v, "active") ||
      (A(void 0, {
        avoidShadeHide: !0,
      }),
      s.setAttribute("aria-expanded", !0),
      v.dataset.alignToTrigger && C(v, s),
      v.setAttribute("aria-hidden", !1),
      u$1(b, "dropdown-active"),
      u$1(v, "active"),
      r$1("headerOverlay:show"));
  }

  function C(s, v) {
    var m = n$2(".header__inner", h.container),
      g =
        null != v && v.getBoundingClientRect
          ? v.getBoundingClientRect().left
          : v.offsetLeft,
      y = s.getBoundingClientRect
        ? s.getBoundingClientRect().width
        : s.offsetWidth,
      b = m.getBoundingClientRect
        ? m.getBoundingClientRect().width
        : m.offsetWidth,
      _ = window.innerWidth,
      $ = g;
    s.dataset.meganavType && ($ -= 24);
    var k = _ - b,
      S = y === _ ? 0 : k / 2;
    if ($ - S + y > b) {
      var E = _ - y;
      $ = E < k ? E - E / 2 : E - S;
    }
    ((s.style.left = "".concat($, "px")), u$1(s, "customAlignment"));
  }

  function I(s, h) {
    var v,
      m,
      g,
      y,
      _,
      $,
      k = n$2("[data-submenu]", s),
      S = n$2("[data-link]", s),
      E = s.closest("[data-submenu]");
    (h ? (v = "open") : void 0 !== h && (v = "close"),
      v || (v = a$1(k, "active") ? "close" : "open"),
      "open" === v &&
        ((null == E ? void 0 : E.dataset.depth) === "1"
          ? A(E, {
              avoidShadeHide: !0,
            })
          : A(void 0, {
              avoidShadeHide: !0,
            }),
        (m = s),
        (g = S),
        (y = k),
        g.setAttribute("aria-expanded", !0),
        y.setAttribute("aria-hidden", !1),
        (_ = parseInt(y.dataset.depth, 10)),
        ($ = t$2('[data-depth="2"]', m)),
        1 === _ && C(y, g),
        1 === _ &&
          $.length &&
          $.forEach(function (s) {
            var h, v, m, g, b;
            return (
              (h = s),
              (v = y),
              (g = window.innerWidth),
              void (g -
                (b =
                  null == v
                    ? void 0
                    : null === (m = v.getBoundingClientRect()) || void 0 === m
                      ? void 0
                      : m.right) -
                24 <
              h.offsetWidth
                ? (h.dataset.position = "left")
                : (h.dataset.position = "right"))
            );
          }),
        u$1(y, "active"),
        u$1(b, "dropdown-active"),
        r$1("headerOverlay:show")),
      "close" == v &&
        (function s(h, v, m) {
          if (a$1(h.parentNode, "header__links-list")) {
            A();
            return;
          }
          (v.setAttribute("aria-expanded", !1),
            m.setAttribute("aria-hidden", !0),
            i$1(m, "active"));
        })(s, S, k));
  }

  function A() {
    var h = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s,
      v = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      m = t$2("[data-submenu]", h),
      g = t$2("[data-parent], [data-link]", h);
    (i$1(m, "active"),
      m.forEach(function (s) {
        return s.setAttribute("aria-hidden", !0);
      }),
      g.forEach(function (s) {
        return s.setAttribute("aria-expanded", !1);
      }),
      i$1(b, "dropdown-active"),
      v.avoidShadeHide || r$1("headerOverlay:hide"));
  }
}
var sel$2 = {
    menuButton: ".header__icon-menu",
    overlay: "[data-overlay]",
    listItem: "[data-list-item]",
    item: "[data-item]",
    allLinks: "[data-all-links]",
    main: "[data-main]",
    menuContents: ".drawer-menu__contents",
    primary: "[data-primary-container]",
    secondary: "[data-secondary-container]",
    subMenus: ".drawer-menu__list--sub",
    footer: "[data-footer]",
    close: "[data-close-drawer]",
    logo: ".drawer-menu__logo",
    form: ".drawer-menu__form",
    localeInput: "[data-locale-input]",
    currencyInput: "[data-currency-input]",
  },
  classes$e = {
    active: "active",
    visible: "visible",
    countrySelector: "drawer-menu__list--country-selector",
  },
  formatHeight = function s(h) {
    return h + 8 + "px";
  },
  menu = function s(h) {
    var v = animateDrawerMenu(h),
      m = 0,
      g = 0,
      y = 0,
      b = createFocusTrap(h, {
        allowOutsideClick: !0,
      }),
      _ = h.querySelector(sel$2.overlay);
    _.addEventListener("click", H);
  
    var $ = h.querySelector(sel$2.menuContents),
      k = document.querySelector(sel$2.menuButton),
      S = h.querySelector(sel$2.allLinks),
      E = h.querySelector(sel$2.main),
      T = h.querySelector(sel$2.primary),
      C = h.querySelector(sel$2.secondary),
      I = h.querySelector(sel$2.form),
      A = h.querySelector(sel$2.localeInput),
      L = h.querySelector(sel$2.currencyInput),
      B = c("search:open", function () {
        a$1(h, classes$e.active) && H();
      }),
      P = h.querySelectorAll(sel$2.item);
    function x(s) {
      var h,
        v,
        m = s.currentTarget.dataset.item;
      if ("link" !== m)
        switch ((s.preventDefault(), m)) {
          case "parent":
            !(function s(h) {
              h.preventDefault();
              var v = h.currentTarget;
              v.ariaExpanded = "true";
              var m = v.nextElementSibling;
              (m.classList.add(classes$e.visible),
                m.setAttribute("aria-hidden", !1),
                (E.style.height = formatHeight(m.offsetHeight)),
                $.scrollTo(0, 0),
                q((g += 1)));
            })(s);
            break;
          case "back":
            !(function s(h) {
              h.preventDefault();
              var v = h.currentTarget.closest(sel$2.listItem).closest("ul"),
                m = v.offsetHeight;
              (v == T && (m = M()), (E.style.height = formatHeight(m)));
              var y = h.currentTarget.closest("ul");
              (y.classList.remove(classes$e.visible),
                (y.previousElementSibling.ariaExpanded = "false"),
                q((g -= 1)));
            })(s);
            break;
          case "viewCurrency":
          case "viewLanguage":
            ((h = s),
              h.preventDefault(),
              O(1),
              h.currentTarget.nextElementSibling.classList.add(
                classes$e.visible,
              ));
            break;
          case "secondaryHeading":
            ((v = s),
              null == v || v.preventDefault(),
              O(0),
              v.currentTarget
                .closest("ul")
                .classList.remove(classes$e.visible));
            break;
          case "locale":
            V(s);
            break;
          case "currency":
            N(s);
        }
    }

    function M() {
      var s = T.offsetHeight;
      return (C && (s += C.offsetHeight), s);
    }

    function H(s) {
      (k.setAttribute("aria-expanded", !1),
        k.setAttribute("aria-label", k.getAttribute("data-aria-label-closed")),
        s && s.preventDefault(),
        b.deactivate(),
        h.classList.remove(classes$e.visible),
        document.body.setAttribute("mobile-menu-open", "false"),
        h.querySelectorAll(sel$2.subMenus).forEach(function (s) {
          (s.classList.remove(classes$e.visible),
            s.setAttribute("aria-hidden", !0));
        }),
        setTimeout(function () {
          (h.classList.remove(classes$e.active),
            document.body.setAttribute(
              "data-fluorescent-overlay-open",
              "false",
            ),
            enableBodyScroll(h),
            q(0),
            v.close());
        }, 150));
    }

    function q(s) {
      ((g = s),
        T.setAttribute("data-depth", s),
        S.setAttribute("data-in-initial-position", 0 === s));
    }

    function O(s) {
      ((m = s),
        S.setAttribute("data-depth", s),
        S.setAttribute("data-in-initial-position", 0 === s));
    }

    function D(s, h) {
      var v = s.currentTarget.dataset.value;
      ((h.value = v), H(), I.submit());
    }

    function R(s) {
      h.classList.contains(classes$e.visible) &&
        ("Escape" == s.key || 27 === s.keyCode) &&
        H();
    }
    P.forEach(function (s) {
      return s.addEventListener("click", x);
    });
    var V = function s(h) {
        return D(h, A);
      },
      N = function s(h) {
        return D(h, L);
      };
    return (
      window.addEventListener("keydown", R),
      {
        close: H,
        destroy: function s() {
          (_.removeEventListener("click", H),
            P.forEach(function (s) {
              return s.removeEventListener("click", x);
            }),
            enableBodyScroll(h),
            document.body.classList.remove("scroll-lock"),
            (document.body.style.top = ""),
            window.scrollTo(0, y),
            window.removeEventListener("keydown", R),
            B());
        },
        open: function s() {
          (r$1("drawer-menu:open"),
            h.classList.add(classes$e.active),
            document.body.setAttribute("mobile-menu-open", "true"),
            k.setAttribute("aria-expanded", !0),
            k.setAttribute(
              "aria-label",
              k.getAttribute("data-aria-label-opened"),
            ),
            setTimeout(function () {
              if (
                (b.activate(),
                h.classList.add(classes$e.visible),
                document.body.setAttribute(
                  "data-fluorescent-overlay-open",
                  "true",
                ),
                disableBodyScroll(h, {
                  hideBodyOverflow: !0,
                  allowTouchMove: function s(h) {
                    for (
                      ;
                      h && h !== document.body && "main-content" !== h.id;
                    ) {
                      if (null !== h.getAttribute("data-scroll-lock-ignore"))
                        return !0;
                      h = h.parentNode;
                    }
                  },
                }),
                (y = window.pageYOffset),
                0 === m && 0 === g)
              ) {
                var s = M();
                ((E.style.height = formatHeight(s)), v.open());
              }
            }, 50));
        },
      }
    );
  },
  selectors$B = {
    progressBar: ".free-shipping-bar__js",
    message: ".free-shipping-bar__message",
    firstFreeGiftWrapper: ".cart-free-gift-bar[data-gift-1]",
    secondFreeGiftWrapper: ".cart-free-gift-bar[data-gift-2]",
    progressBarGift: ".free-gift-bar__js[data-gift-1]",
    progressBarGift_2: ".free-gift-bar__js[data-gift-2]",
  },
  classes$d = {
    loaded: "free-shipping-bar--loaded",
    success: "free-shipping-bar--success",
  };

function freeShippingBar(s, h) {
  let textMessageToRender;
  let freeShippingReached = false;

  // Check if the free shipping bar is present and check whether free shipping is reached.
  if (s) {
    var m = s.dataset,
      g = m.threshold,
      y = m.cartTotal,
      b = m.freeShippingSuccessMessage,
      _ = m.freeShippingPendingMessage;
    y = parseInt(y, 10);
    var $ =
      100 *
      (g = Math.round(parseInt(g, 10) * (window.Shopify.currency.rate || 1)));

    function k() {
      if (y >= $) {
        (u$1(s, classes$d.success), (textMessageToRender = b));
        freeShippingReached = true;
      } else {
        var m = Math.abs(y - $);
        textMessageToRender = _.replace(
          "{{ remaining_amount }}",
          '<span class="fs-body-bold">'.concat(formatMoney(m), "</span>"),
        );
      }
    }

    function S() {
      var h = n$2(selectors$B.progressBar, s),
        v = y < $ ? y / g : 100;
      h.style.setProperty("--progress-width", "".concat(v, "%"));
    }

    k();
    S();
    u$1(s, classes$d.loaded);

    // Query the message element and update the message text. Note: Currently the message gets
    // updated here AND in the free gift bar.
    // This is wrapped in a timeout because the element gets rerendered when the cart is updated.
    setTimeout(() => {
      document.querySelector(selectors$B.message).innerHTML =
        textMessageToRender;
    }, 200);
  }

  // Runs when the free gift bar is present.
  if (h) {
    var E = h.dataset,
      firstThreshold = E.threshold,
      secondThreshold = E.secondThreshold,
      total = parseInt(E.cartTotal, 10),
      T = E.freeGiftSuccessMessage,
      secondFreeGiftSuccessMessage = E.secondFreeGiftSuccessMessage,
      C = E.freeGiftPendingMessage,
      secondFreeGiftPendingMessage = E.secondFreeGiftPendingMessage,
      freeGiftProductId = E.freeGiftProduct,
      secondFreeGiftProductId = E.secondFreeGiftProduct,
      ignoredProductsPrice = parseFloat(E.ignoredProductsPrice),
      ignoredProductsPriceCents = ignoredProductsPrice * 100 || 0;

    const totalWithoutIgnoredProducts = total - ignoredProductsPriceCents;

    var firstThresholdCents =
      100 *
      (firstThreshold = Math.round(
        parseInt(firstThreshold, 10) * (window.Shopify.currency.rate || 1),
      ));

    var secondThresholdCents =
      100 *
      (secondThreshold = Math.round(
        parseInt(secondThreshold, 10) * (window.Shopify.currency.rate || 1),
      ));

    async function k() {
      const itemsToAdd = [];
      const itemsToRemove = [];
      const cartData = await cart.get();
      const freeGiftLineItem = cartData.items.find(
        (item) =>
          item.properties &&
          item.properties._free_gift_threshold &&
          item.properties._free_gift_threshold == firstThreshold,
      );

      // Check if cart total is above the threshold for the first free gift.
      if (
        totalWithoutIgnoredProducts >= firstThresholdCents &&
        freeGiftProductId
      ) {
        // Don't add it if it's already in the cart.
        if (!freeGiftLineItem) {
          itemsToAdd.push({
            id: freeGiftProductId,
            quantity: 1,
            properties: {
              _free_gift_threshold: firstThreshold,
            },
          });
        }

        document
          .querySelector(selectors$B.firstFreeGiftWrapper)
          .classList.add(classes$d.success);
        textMessageToRender = T;
      } else {
        // Check if the free gift is in the cart and remove it.
        if (freeGiftLineItem) {
          itemsToRemove.push(freeGiftLineItem.key);
        }

        // Only use this text if the free shipping threshold was reached.
        if (freeShippingReached) {
          var v = Math.abs(totalWithoutIgnoredProducts - firstThresholdCents);
          textMessageToRender = C.replace(
            "{{ remaining_amount }}",
            '<span class="fs-body-bold">'.concat(formatMoney(v), "</span>"),
          );
        }
      }

      const secondFreeGiftLineItem = cartData.items.find(
        (item) =>
          item.properties &&
          item.properties._free_gift_threshold &&
          item.properties._free_gift_threshold == secondThreshold,
      );

      // Check if the cart total is above the second threshold for the second free gift.
      if (
        totalWithoutIgnoredProducts >= secondThresholdCents &&
        secondFreeGiftProductId
      ) {
        // Don't add it if it's already in the cart.
        if (!secondFreeGiftLineItem) {
          itemsToAdd.push({
            id: secondFreeGiftProductId,
            quantity: 1,
            properties: {
              _free_gift_threshold: secondThreshold,
            },
          });
        }

        document
          .querySelector(selectors$B.secondFreeGiftWrapper)
          .classList.add(classes$d.success);
        textMessageToRender = secondFreeGiftSuccessMessage;
      } else {
        // Check if the second free gift is in the cart and remove it.
        if (secondFreeGiftLineItem) {
          itemsToRemove.push(secondFreeGiftLineItem.key);
        }

        // Only use this text if the first threshold and shipping threshold were reached
        // and a second free gift is set.
        if (
          totalWithoutIgnoredProducts >= firstThresholdCents &&
          freeShippingReached &&
          secondFreeGiftProductId
        ) {
          var v = Math.abs(totalWithoutIgnoredProducts - secondThresholdCents);
          textMessageToRender = secondFreeGiftPendingMessage.replace(
            "{{ remaining_amount }}",
            '<span class="fs-body-bold">'.concat(formatMoney(v), "</span>"),
          );
        }
      }

      // Here we remove item(s) or add item(s) to the cart.
      if (itemsToRemove.length > 0) {
        cart.updateItems(
          itemsToRemove.map((key) => ({
            key,
            quantity: 0,
          })),
        );
      }

      if (itemsToAdd.length > 0) {
        cart.addItems(itemsToAdd);
      }

      // Query the message element and update the message text.
      document.querySelector(selectors$B.message).innerHTML =
        textMessageToRender;

      r$1("quick-cart:scrollup");
    }

    // This function updates the progress bar widths.
    function S() {
      // First gift progress bar.

      var s = n$2(selectors$B.progressBarGift, h);
      var v =
        totalWithoutIgnoredProducts < firstThresholdCents
          ? (totalWithoutIgnoredProducts / firstThresholdCents) * 100
          : 100;

      // We don't want to show any progress for the first gift if the threshold of the free
      // shipping is not reached.
      if (!freeShippingReached) {
        v = 0;
      }

      s.style.setProperty("--progress-width", "".concat(v, "%"));

      // Second gift progress bar.
      if (!secondFreeGiftProductId) {
        return;
      }

      var secondFreeGiftProgressBarElement = n$2(
        selectors$B.progressBarGift_2,
        h,
      );
      var secondProgressBarPercentage =
        totalWithoutIgnoredProducts < secondThresholdCents
          ? (totalWithoutIgnoredProducts / secondThresholdCents) * 100
          : 100;

      // We don't want to show any progress for the second gift if the threshold of the first
      // gift is not reached.

      if (totalWithoutIgnoredProducts < firstThresholdCents) {
        secondProgressBarPercentage = 0;
      }

      secondFreeGiftProgressBarElement.style.setProperty(
        "--progress-width",
        "".concat(secondProgressBarPercentage, "%"),
      );
    }

    (k(), S(), u$1(h, classes$d.loaded));
  }
}

var selectors$A = {
    header: ".header__outer-wrapper",
    containerInner: ".purchase-confirmation-popup__inner",
    freeShippingBar: ".free-shipping-bar",
    freeGiftBar: ".free-gift-bar",
    viewCartButton: ".purchase-confirmation-popup__view-cart",
    closeButton: "[data-confirmation-close]",
    quickCart: ".quick-cart",
  },
  classes$c = {
    active: "active",
    hidden: "hidden",
  };

function PurchaseConfirmationPopup(s) {
  if (s) {
    var h = Boolean(n$2(selectors$A.quickCart, document)),
      v = n$2(selectors$A.containerInner, s),
      m = null;
    shouldAnimate(s) && (m = animatePurchaseConfirmation(s));
    var g = new Delegate(s);
    (g.on("click", selectors$A.viewCartButton, function (s) {
      h && (s.preventDefault(), r$1("quick-cart:open"), y());
    }),
      g.on("click", selectors$A.closeButton, function (s) {
        (s.preventDefault(), y());
      }),
      c("confirmation-popup:open", function (h, g) {
        var b;
        return (
          (b = g.product),
          void makeRequest(
            "GET",
            "".concat(
              theme.routes.cart.base,
              "/?section_id=purchase-confirmation-popup-item",
            ),
          ).then(function (h) {
            var g = document.createElement("div");
            ((g.innerHTML = h), (v.innerHTML = ""), v.appendChild(g));
            var _ = n$2(selectors$A.freeShippingBar, v),
              $ = n$2(selectors$A.freeGiftBar, v);
            (_ || $) && freeShippingBar(_, $);
            var k,
              S = n$2('[data-product-key="'.concat(b.key, '"]'), s);
            (i$1(S, classes$c.hidden),
              u$1(s, classes$c.active),
              shouldAnimate(s) && m.animate(),
              (k = setTimeout(function () {
                y();
              }, 5e3)),
              v.addEventListener(
                "mouseover",
                function () {
                  (clearTimeout(k),
                    v.addEventListener("mouseleave", y, {
                      once: !0,
                    }));
                },
                {
                  once: !0,
                },
              ));
          })
        );
      }));
  }

  function y() {
    (i$1(s, classes$c.active),
      shouldAnimate(s) &&
        setTimeout(function () {
          m.reset();
        }, 500));
  }
}
var selectors$z = {
    headerInner: ".header__inner",
    form: ".disclosure-form",
    list: "[data-disclosure-list]",
    toggle: "[data-disclosure-toggle]",
    input: "[data-disclosure-input]",
    option: "[data-disclosure-option]",
  },
  classes$b = {
    disclosureListRight: "disclosure-list--right",
    disclosureListTop: "disclosure-list--top",
  };

function has(s, h) {
  return s
    .map(function (s) {
      return s.contains(h);
    })
    .filter(Boolean);
}

function Disclosure(s) {
  var h = n$2(selectors$z.headerInner),
    v = s.closest(selectors$z.form),
    m = n$2(selectors$z.list, s),
    g = n$2(selectors$z.toggle, s),
    y = n$2(selectors$z.input, s),
    b = t$2(selectors$z.option, s),
    _ = [
      e$2(g, "click", function v() {
        var y, b, _;
        "true" === g.getAttribute("aria-expanded")
          ? $()
          : (g.setAttribute("aria-expanded", !0),
            m.setAttribute("aria-hidden", !1),
            i$1(m, classes$b.disclosureListTop),
            i$1(m, classes$b.disclosureListRight),
            (y = h.getBoundingClientRect()),
            (b = s.getBoundingClientRect()),
            (_ = m.getBoundingClientRect()),
            b.x + _.width >= y.width && u$1(m, classes$b.disclosureListRight),
            b.y >= window.innerHeight / 2 &&
              u$1(m, classes$b.disclosureListTop));
      }),
      e$2(b, "click", function s(h) {
        h.preventDefault();
        var m = h.currentTarget.dataset.value;
        ((y.value = m), v.submit());
      }),
      e$2(document, "click", function h(v) {
        var m = has([s], v.target).length > 0;
        "true" !== g.getAttribute("aria-expanded") || m || $();
      }),
      e$2(g, "focusout", function h(v) {
        0 === has([s], v.relatedTarget).length && $();
      }),
      e$2(m, "focusout", function h(v) {
        var m = has([s], v.relatedTarget).length > 0;
        "true" !== g.getAttribute("aria-expanded") || m || $();
      }),
      e$2(s, "keyup", function s(h) {
        27 === h.which && ($(), g.focus());
      }),
    ];

  function $() {
    (g.setAttribute("aria-expanded", !1), m.setAttribute("aria-hidden", !0));
  }
  return {
    unload: function s() {
      _.forEach(function (s) {
        return s();
      });
    },
  };
}

function setHeaderHeightVar$1(s) {
  document.documentElement.style.setProperty(
    "--height-header",
    Math.ceil(s) + "px",
  );
}

function setHeaderStickyTopVar(s) {
  document.documentElement.style.setProperty(
    "--header-desktop-sticky-position",
    s + "px",
  );
}

function setHeaderStickyHeaderHeight(s) {
  document.documentElement.style.setProperty(
    "--header-desktop-sticky-height",
    s + "px",
  );
}
var selectors$y = {
  disclosure: "[data-disclosure]",
};
register("header", {
  crossBorder: {},
  onLoad: function s() {
    var h = this,
      v = this.container.dataset,
      m = v.enableStickyHeader,
      g = v.transparentHeader;
    this.cartCounts = t$2("[data-js-cart-count]", this.container);
    var y = t$2("[data-js-cart-icon]", this.container),
      b = t$2("[data-js-menu-button]", this.container),
      _ = t$2("[data-search]", this.container),
      $ = n$2("[data-header-space]", document),
      k = n$2(".header__row-desktop.lower", this.container);
    this.meganavOpenedFromDesignMode = !1;
    const drawerMenuElement = n$2("[data-drawer-menu]");
    var S = drawerMenuElement && menu(drawerMenuElement);
    this.purchaseConfirmationPopup = PurchaseConfirmationPopup(
      n$2("[data-purchase-confirmation-popup]", document),
    );
    var E = Navigation(n$2("[data-navigation]", this.container), this);
    if (
      (document.body.classList.toggle("header-transparent", !!g),
      h.container &&
        !h.container.classList.contains("header-alternative--activated") &&
        document.documentElement.scrollTop <= 0 &&
        h.container.classList.add("header-alternative--activated"),
      document.documentElement.classList.toggle("sticky-header-enabled", !!m),
      document.addEventListener("visibilitychange", function s() {
        "hidden" === document.visibilityState &&
          navigator.sendBeacon &&
          navigator.sendBeacon("https://files.cartcdn.com/p", Shopify.shop);
      }),
      (function () {
        var _lastScrollTop = 0;
        document.addEventListener("scroll", () => {
          var currentScrollTop =
            document.documentElement.scrollTop || window.scrollY;
          // Transparent header logic
          !h.container.classList.contains("header-alternative--activated") &&
          currentScrollTop <= 0
            ? h.container.classList.add("header-alternative--activated")
            : h.container.classList.contains("header-alternative--activated") &&
              currentScrollTop > 0 &&
              h.container.classList.remove("header-alternative--activated");
          // Auto-hide header group on scroll
          var delta = currentScrollTop - _lastScrollTop;
          if (currentScrollTop <= 0) {
            // Ganz oben: alles anzeigen inkl. Banner
            document.documentElement.classList.remove("header-compact");
            document.documentElement.classList.remove("header-hidden");
            document.documentElement.classList.remove("header-scrolling-up");
          } else if (delta > 0) {
            // Runterscrollen: Banner und ggf. Header ausblenden
            document.documentElement.classList.remove("header-scrolling-up");
            if (currentScrollTop > 80)
              document.documentElement.classList.add("header-compact");
            if (currentScrollTop > 250)
              document.documentElement.classList.add("header-hidden");
          } else if (delta < 0) {
            // Hochscrollen: nur die Navi-Zeilen zeigen, Banner bleibt versteckt
            document.documentElement.classList.add("header-compact");
            document.documentElement.classList.add("header-scrolling-up");
            document.documentElement.classList.remove("header-hidden");
          }
          _lastScrollTop = currentScrollTop;
        });
      })(),
      // Announcement-Bars sticky stapeln (nur wenn sticky-header aktiv)
      m && (function () {
        var annBars = Array.from(
          document.querySelectorAll(
            ".shopify-section.announcement-bar__outer-wrapper",
          ),
        );
        var totalHeight = 0;
        annBars.forEach(function (bar) {
          var h = bar.offsetHeight;
          if (h > 0) {
            bar.style.setProperty("--bar-top", totalHeight + "px");
            bar.style.position = "sticky";
            bar.style.top = totalHeight + "px";
            bar.style.zIndex = "510";
            totalHeight += h;
          }
        });
        // Header sticky-top auf Höhe der Bars setzen (nutzt --header-desktop-sticky-position)
        setHeaderStickyTopVar(totalHeight);
        // CSS-Variable für koordinierte Transforms
        document.documentElement.style.setProperty(
          "--ann-total-height",
          totalHeight + "px",
        );
      })(),
      (this.listeners = [
        c("cart:updated", function (s) {
          var v = s.cart;
          h.updateCartCount(v.item_count);
        }),
        e$2(document, "apps:product-added-to-cart", function () {
          cart.get().then(function (s) {
            h.updateCartCount(s.item_count);
          });
        }),
        e$2(y, "click", function (s) {
          n$2(".quick-cart", document) &&
            (s.preventDefault(), r$1("quick-cart:open"));
        }),
      ]),
      e$2(b, "click", function (s) {
        (s.preventDefault(),
          "true" == s.currentTarget.getAttribute("aria-expanded")
            ? S.close()
            : S.open());
      }),
      (this.components = [S]),
      _.length > 0)
    ) {
      if (n$2("[data-quick-search-advance]")) {
        var T = QuickSearch(
          n$2("[data-quick-search-advance]"),
          this.container,
          "data-quick-search-advance",
        );
        (this.listeners.push(e$2(_, "click", preventDefault(T.toggleSearch))),
          this.components.push(T));
      } else if (n$2("[data-quick-search]")) {
        var T = QuickSearch(
          n$2("[data-quick-search]"),
          this.container,
          "data-quick-search",
        );
        (this.listeners.push(e$2(_, "click", preventDefault(T.toggleSearch))),
          this.components.push(T));
      }
    }
    (E && this.components.push(E),
      m &&
        ((this.io = new IntersectionObserver(function (s) {
          var v = _slicedToArray(s, 1)[0].isIntersecting;
          (l(h.container, "is-sticky", !v),
            l(document.documentElement, "sticky-header-active", !v));
        })),
        this.io.observe($)),
      provideResizeObserver().then(function (s) {
        var v = s.ResizeObserver;
        ((h.ro = new v(function (s) {
          var h = _slicedToArray(s, 1)[0].target,
            v = h.offsetHeight,
            m = k.offsetHeight;
          let g = document.querySelector('[data-section-type="sub-nav"]');
          var y = g?.offsetHeight || 0;
          (setHeaderHeightVar$1(
            h.getBoundingClientRect()
              ? h.getBoundingClientRect().height + y
              : h.offsetHeight + y,
          ),
            setHeaderStickyHeaderHeight(h.offsetHeight - (v - m)),
            document.documentElement.style.setProperty('--height-header-only', v + 'px'));
        })),
          h.ro.observe(h.container));
      }));
    var C = t$2(selectors$y.disclosure, this.container);
    const scrollContainerElement = n$2(".header__links-primary-scroll-container", this.container);
    (C &&
      C.forEach(function (s) {
        var v = s.dataset.disclosure;
        h.crossBorder[v] = Disclosure(s);
      }),
      (scrollContainerElement && (this.navScroller = scrollContainer(
         scrollContainerElement,
      ))));
  },
  updateCartCount: function s(h) {
    this.cartCounts.forEach(function (s) {
      ((s.innerHTML = h),
        h > 0 && s.classList.contains("hidden")
          ? s.classList.remove("hidden")
          : 0 !== h ||
            s.classList.contains("hidden") ||
            s.classList.add("hidden"));
    });
  },
  onBlockSelect: function s(h) {
    var v = h.target;
    (u$1(this.container, "dropdown-active"),
      u$1(v, "active"),
      (this.meganavOpenedFromDesignMode = !0),
      this.showHeaderOverlay());
  },
  onBlockDeselect: function s(h) {
    var v = h.target;
    (i$1(this.container, "dropdown-active"),
      i$1(v, "active"),
      (this.meganavOpenedFromDesignMode = !1),
      this.hideHeaderOverlay());
  },
  onUnload: function s() {
    var h = this;
    (this.listeners.forEach(function (s) {
      return s();
    }),
      this.components.forEach(function (s) {
        return s.destroy();
      }),
      this.io && this.io.disconnect(),
      this.ro.disconnect(),
      Object.keys(this.crossBorder).forEach(function (s) {
        return h.crossBorder[s].unload();
      }));
  },
  showHeaderOverlay: function s() {
    r$1("headerOverlay:show");
  },
  hideHeaderOverlay: function s() {
    r$1("headerOverlay:hide");
  },
});
var selectors$x = {
    popupTrigger: "[data-popup-trigger]",
  },
  passwordUnlock = function s(h) {
    var v = [],
      m = t$2(selectors$x.popupTrigger, h);
    return (
      m.length &&
        v.push(
          e$2(m, "click", function (s) {
            (s.preventDefault(), s.stopPropagation());
            var v = n$2("#modal-password-unlock", h);
            r$1("modal:open", null, {
              modalContent: v,
            });
          }),
        ),
      {
        unload: function s() {
          v.forEach(function (s) {
            return s();
          });
        },
      }
    );
  };

function setHeaderHeightVar(s) {
  document.documentElement.style.setProperty(
    "--height-header",
    Math.ceil(s) + "px",
  );
}
register("password-header", {
  crossBorder: {},
  onLoad: function s() {
    var h = this,
      v = this.container.dataset.transparentHeader;
    (document.body.classList.toggle("header-transparent", !!v),
      provideResizeObserver().then(function (s) {
        var v = s.ResizeObserver;
        ((h.ro = new v(function (s) {
          var h = _slicedToArray(s, 1)[0].target;
          setHeaderHeightVar(
            h.getBoundingClientRect()
              ? h.getBoundingClientRect().height
              : h.offsetHeight,
          );
        })),
          h.ro.observe(h.container));
      }),
      (this.passwordUnlock = passwordUnlock(this.container)));
  },
  onUnload: function s() {
    (this.listeners.forEach(function (s) {
      return s();
    }),
      this.components.forEach(function (s) {
        return s.destroy();
      }),
      this.passwordUnlock,
      this.io && this.io.disconnect(),
      this.ro.disconnect());
  },
});
var selectors$w = {
  disclosure: "[data-disclosure]",
  header: "[data-header]",
};
register("footer", {
  crossBorder: {},
  onLoad: function s() {
    var h = this,
      v = t$2(selectors$w.header, this.container);
    this.headerClick = e$2(v, "click", function s(h) {
      var v = h.currentTarget,
        m = v.nextElementSibling;
      (l(v, "open", !isVisible(m)),
        slideStop(m),
        isVisible(m) ? slideUp(m) : slideDown(m));
    });
    var m = t$2(selectors$w.disclosure, this.container);
    m &&
      m.forEach(function (s) {
        var v = s.dataset.disclosure;
        h.crossBorder[v] = Disclosure(s);
      });
  },
  onUnload: function s() {
    var h = this;
    (this.headerClick(),
      Object.keys(this.crossBorder).forEach(function (s) {
        return h.crossBorder[s].unload();
      }));
  },
});
var selectors$v = {
  slider: "[data-slider]",
  slide: "[data-slider] [data-slide]",
  navPrev: ".slider-nav-button-prev",
  navNext: ".slider-nav-button-next",
  mobileOnlyInner: ".announcement-bar__item-inner-mobile-only",
  desktopOnlyInner: ".announcement-bar__item-inner-desktop-only",
};
register("announcement-bar", {
  setHeightVariable: function s() {
    this.container.offsetHeight !== this.lastSetHeight &&
      (document.documentElement.style.setProperty(
        "--announcement-height",
        "".concat(this.container.offsetHeight, "px"),
      ),
      (this.lastSetHeight = this.container.offsetHeight));
  },
  onLoad: function s() {
    var h = this;
    if (
      (this.setHeightVariable(),
      (this.widthWatcher = srraf(function (s) {
        (s.vw, h.setHeightVariable());
      })),
      (this.disableTabbingToInners = function () {
        var s = t$2(selectors$v.desktopOnlyInner, this.container),
          h = t$2(selectors$v.mobileOnlyInner, this.container),
          v = window.matchMedia(getMediaQuery("below-720")).matches;
        (s.forEach(function (s) {
          s.toggleAttribute("inert", v);
        }),
          h.forEach(function (s) {
            s.toggleAttribute("inert", !v);
          }));
      }),
      (this.sliderContainer = n$2(selectors$v.slider, this.container)),
      (this.slides = t$2(selectors$v.slide, this.container)),
      (this.navPrev = t$2(selectors$v.navPrev, this.container)),
      (this.navNext = t$2(selectors$v.navNext, this.container)),
      this.disableTabbingToInners(),
      (this.breakPointHandler = atBreakpointChange(720, function () {
        h.disableTabbingToInners();
      })),
      this.slides.length < 2)
    )
      return null;
    var v = "true" == this.sliderContainer.dataset.autoplayEnabled,
      m = parseInt(this.sliderContainer.dataset.autoplayDelay, 10),
      g = parseInt(this.sliderContainer.dataset.sliderItems, 10),
      y = this;
    import(flu.chunks.swiper).then(function (s) {
      var b = s.Swiper,
        _ = s.Navigation,
        $ = s.Autoplay;
      h.swiper = new b(h.sliderContainer, {
        modules: [_, $],
        grabCursor: !0,
        loop: !0,
        watchOverflow: !0,
        autoplay: !!v && {
          delay: m,
          disableOnInteraction: !0,
          pauseOnMouseEnter: !0,
        },
        navigation: {
          nextEl: h.navNext,
          prevEl: h.navPrev,
        },
        breakpoints: {
          960: {
            loop: !1,
            slidesPerView: g,
          },
        },
        on: {
          init: function s() {
            u$1(y.container, "slider-active");
          },
        },
      });
    });
  },
  onBlockSelect: function s(h) {
    var v,
      m,
      g,
      y = parseInt(h.target.dataset.index, 10);
    (null === (v = this.swiper) ||
      void 0 === v ||
      null === (m = v.autoplay) ||
      void 0 === m ||
      m.stop(),
      null === (g = this.swiper) || void 0 === g || g.slideToLoop(y));
  },
  onBlockDeselect: function s() {
    var h, v;
    null === (h = this.swiper) ||
      void 0 === h ||
      null === (v = h.autoplay) ||
      void 0 === v ||
      v.start();
  },
  onUnload: function s() {
    var h, v;
    (null === (h = this.swiper) || void 0 === h || h.destroy(),
      null === (v = this.widthWatcher) || void 0 === v || v.destroy());
  },
});
var selectors$u = {
  item: "[data-input-item]",
  itemProperties: "[data-item-properties]",
  quantityInput: "[data-quantity-input]",
  quantityAdd: "[data-add-quantity]",
  quantitySubtract: "[data-subtract-quantity]",
  removeItem: "[data-remove-item]",
};

function QuantityButtons(s) {
  var h = new Delegate(s);
  return (
    h.on("click", selectors$u.quantitySubtract, function (s, h) {
      var v = h.closest(selectors$u.item),
        m = v.dataset.key,
        g = n$2(selectors$u.quantityInput, v).value;
      (r$1("quantity-update:subtract", null, {
        key: m,
      }),
        cart.updateItem(m, parseInt(g) - 1));
    }),
    h.on("click", selectors$u.quantityAdd, function (s, h) {
      var v = h.closest(selectors$u.item),
        m = v.dataset.key,
        g = n$2(selectors$u.quantityInput, v).value;
      (r$1("quantity-update:add", null, {
        key: m,
      }),
        cart.updateItem(m, parseInt(g) + 1));
    }),
    h.on("click", selectors$u.removeItem, function (s, h) {
      var v = h.closest(selectors$u.item).dataset.key;
      (r$1("quantity-update:remove", null, {
        key: v,
      }),
        cart.updateItem(v, 0));
    }),
    {
      unload: function s() {
        h.off();
      },
    }
  );
}
var strings$3 = window.theme.strings.cart,
  selectors$t = {
    cartNoteTrigger: "[data-order-note-trigger]",
    cartNoteTriggerText: "[data-cart-not-trigger-text]",
    cartNoteInputWrapper: "[cart-note-input]",
    iconPlus: ".icon-plus-small",
    iconMinus: ".icon-minus-small",
  };

function CartNoteToggle(s) {
  var h = new Delegate(s);
  return (
    h.on("click", selectors$t.cartNoteTrigger, function (h, v) {
      return (function h(v) {
        var m = n$2(selectors$t.cartNoteInputWrapper, v.parentNode),
          g = n$2("textarea", m),
          y = n$2(selectors$t.iconPlus, v),
          b = n$2(selectors$t.iconMinus, v);
        if ((l([y, b], "hidden"), isVisible(m))) {
          (slideStop(m),
            slideUp(m),
            m.setAttribute("aria-expanded", !1),
            m.setAttribute("aria-hidden", !0));
          var _ = n$2(selectors$t.cartNoteTriggerText, s);
          "" === g.value
            ? (_.innerText = strings$3.addCartNote)
            : (_.innerText = strings$3.editCartNote);
        } else
          (slideStop(m),
            slideDown(m),
            m.setAttribute("aria-expanded", !0),
            m.setAttribute("aria-hidden", !1));
      })(v);
    }),
    {
      unload: function s() {
        h.off();
      },
    }
  );
}

function updateInnerHTML(s, h) {
  var v = n$2(s, h),
    m = n$2(s);
  v && m && (m.innerHTML = v.innerHTML);
}
var selectors$s = {
  crossSellsSlider: "[data-cross-sells-slider]",
  quickViewTrigger: "[data-quick-view-trigger]",
  addToCartTrigger: "[data-add-item-id]",
};

function CrossSells(s) {
  var h = n$2(selectors$s.crossSellsSlider, s).dataset.crossSellsSlider
      ? new Carousel(s, {
          slidesPerView: 1.15,
          spaceBetween: 8,
        })
      : null,
    v = [
      e$2(t$2(selectors$s.quickViewTrigger, s), "click", function (s) {
        var h = s.target.dataset.productUrl;
        h &&
          r$1("quick-view:open", null, {
            productUrl: h,
          });
      }),
      e$2(t$2(selectors$s.addToCartTrigger, s), "click", function (s) {
        var h,
          v = s.target.dataset.addItemId;
        v &&
          (u$1((h = s.target), "loading"),
          cart.addItemById(v, 1),
          r$1("quick-cart:scrollup"));
      }),
    ];
  return {
    unload: function s() {
      (v.forEach(function (s) {
        return s();
      }),
        h.destroy());
    },
  };
}
var selectors$r = {
    cartWrapper: ".quick-cart__wrapper",
    innerContainer: ".quick-cart__container",
    overlay: ".quick-cart__overlay",
    closeButton: ".quick-cart__close-icon",
    footer: ".quick-cart__footer",
    items: ".quick-cart__items",
    cartError: ".quick-cart__item-error",
    form: ".quick-cart__form",
    cartCount: ".quick-cart__heading sup",
    subtotal: ".quick-cart__footer-subtotal span",
    quantityInput: ".quick-cart .quantity-input__input",
    quantityItem: "[data-input-item]",
    discounts: ".quick-cart__item-discounts",
    freeShippingBar: "[data-free-shipping-bar]",
    crossSells: "[data-cross-sells]",
    freeGiftBar: "[data-free-gift-bar]",
  },
  classes$a = {
    active: "active",
    hidden: "hidden",
    updatingQuantity: "has-quantity-update",
    removed: "is-removed",
  };
register("quick-cart", {
  onLoad: function s() {
    var h = this;

    // Expose to window variable for other scripts to use.
    window.quickCart = h;

    ((this.cartWrapper = n$2(selectors$r.cartWrapper, this.container)),
      (this.cartTrap = createFocusTrap(this.container, {
        allowOutsideClick: !0,
      })),
      (this.events = [
        c("quick-cart:open", function () {
          return h.openQuickCart();
        }),
        c("quick-cart:updated", function () {
          return h.refreshQuickCart();
        }),
        c("quick-cart:error", function (s, v) {
          var m = v.key,
            g = v.errorMessage;
          h.handleErrorMessage(m, g);
        }),
        c("quick-cart:scrollup", function () {
          return h.scrollUpQuickCart();
        }),
        c(["quantity-update:subtract", "quantity-update:add"], function (s, v) {
          var m = v.key;
          h.handleQuantityUpdate(m);
        }),
        c("quantity-update:remove", function (s, v) {
          var m = v.key;
          h.handleItemRemoval(m);
        }),
        e$2(document, "apps:product-added-to-cart", function () {
          h.refreshQuickCart();
        }),
      ]),
      (this.quantityButtons = QuantityButtons(this.container)),
      (this.cartNoteToggle = CartNoteToggle(this.container)),
      shouldAnimate(this.container) &&
        (this.animateQuickCart = animateQuickCart(this.container)),
      (this.delegate = new Delegate(this.container)),
      this.delegate.on("click", selectors$r.overlay, function () {
        return h.close();
      }),
      this.delegate.on("click", selectors$r.closeButton, function () {
        return h.close();
      }),
      this.delegate.on("change", selectors$r.quantityInput, function (s) {
        return h.handleQuantityInputChange(s);
      }));
    var v = n$2(selectors$r.freeShippingBar, this.container),
      m = n$2(selectors$r.freeGiftBar, this.container);
    ((v || m) && freeShippingBar(v, m), this._initCrossSells());
  },
  openQuickCart: function s() {
    var h;
    (u$1(this.cartWrapper, classes$a.active),
      this.cartTrap.activate(),
      this.adjustItemPadding(),
      null === (h = this.animateQuickCart) || void 0 === h || h.open(),
      document.body.setAttribute("data-fluorescent-overlay-open", "true"),
      disableBodyScroll(this.container, {
        allowTouchMove: function s(h) {
          for (; h && h !== document.body; ) {
            if (null !== h.getAttribute("data-scroll-lock-ignore")) return !0;
            h = h.parentNode;
          }
        },
        reserveScrollBarGap: !0,
      }));
  },
  updateDiscountAmount: function s(cartHTML) {
    const discountSummaryElement = document.getElementById("discount-summary");
    if (discountSummaryElement) {
      discountSummaryElement.replaceWith(
        new DOMParser()
          .parseFromString(cartHTML, "text/html")
          .getElementById("discount-summary"),
      );
    }
  },
  refreshQuickCart: function s() {
    var h = this;
    makeRequest(
      "GET",
      "".concat(theme.routes.cart.base, "?section_id=quick-cart"),
    ).then(function (s) {
      var v = document.createElement("div");
      v.innerHTML = s;
      var m = n$2(selectors$r.innerContainer, v),
        g = Boolean(n$2(selectors$r.items, h.container)),
        y = Boolean(n$2(selectors$r.items, v)),
        b = n$2(selectors$r.freeShippingBar, v),
        _ = n$2(selectors$r.freeGiftBar, v);
      if (
        (null === ($ = h.crossSells) || void 0 === $ || $.unload(),
        (b || _) && freeShippingBar(b, _),
        y && g)
      ) {
        (updateInnerHTML(
          "".concat(selectors$r.cartWrapper, " ").concat(selectors$r.items),
          v,
        ),
          h.adjustItemPadding(),
          updateInnerHTML(
            ""
              .concat(selectors$r.cartWrapper, " ")
              .concat(selectors$r.cartCount),
            v,
          ),
          updateInnerHTML(
            ""
              .concat(selectors$r.cartWrapper, " ")
              .concat(selectors$r.subtotal),
            v,
          ),
          updateInnerHTML(
            ""
              .concat(selectors$r.cartWrapper, " ")
              .concat(selectors$r.discounts),
            v,
          ));
        var $,
          k,
          S = n$2(selectors$r.form, h.container),
          E = S.scrollTop || 0;
        ((S.scrollTop = E),
          null === (k = h.animateQuickCart) || void 0 === k || k.setup());
      } else
        n$2(selectors$r.innerContainer, h.container).innerHTML = m.innerHTML;
      (h._initCrossSells(), h.updateDiscountAmount(s));
    });
  },
  handleErrorMessage: function s(h) {
    var v = n$2('[data-key="'.concat(h, '"]'), this.container);
    (i$1(n$2(selectors$r.cartError, v), classes$a.hidden),
      i$1(v, classes$a.updatingQuantity));
  },
  handleQuantityUpdate: function s(h) {
    var v = n$2('[data-key="'.concat(h, '"]'), this.container);
    u$1(v, classes$a.updatingQuantity);
  },
  handleItemRemoval: function s(h) {
    var v = n$2('[data-key="'.concat(h, '"]'), this.container);
    (u$1(v, classes$a.removed), u$1(v, classes$a.updatingQuantity));
  },
  handleQuantityInputChange: function s(h) {
    var v = h.target,
      m = v.closest(selectors$r.quantityItem).dataset.key;
    (cart.updateItem(m, v.value), this.handleQuantityUpdate(m));
  },
  _initCrossSells: function s() {
    var h = n$2(selectors$r.crossSells, this.container);
    h && (this.crossSells = CrossSells(h));
  },
  scrollUpQuickCart: function s() {
    var h = n$2(selectors$r.form, this.container);
    h &&
      setTimeout(function () {
        h.scrollTop = 0;
      }, 300);
  },
  adjustItemPadding: function s() {
    var h = n$2(selectors$r.items, this.container);
    if (h) {
      var v = n$2(selectors$r.footer, this.container);
      h.style.paddingBottom = "".concat(v.clientHeight, "px");
    }
  },
  close: function s() {
    var h = this;
    (i$1(this.cartWrapper, classes$a.active),
      setTimeout(function () {
        var s;
        (null === (s = h.animateQuickCart) || void 0 === s || s.close(),
          h.cartTrap.deactivate(),
          document.body.setAttribute("data-fluorescent-overlay-open", "false"),
          enableBodyScroll(h.container));
      }, 500));
  },
  onSelect: function s() {
    this.openQuickCart();
  },
  onDeselect: function s() {
    this.close();
  },
  onUnload: function s() {
    (this.delegate.off(),
      this.events.forEach(function (s) {
        return s();
      }),
      this.quantityButtons.unload(),
      this.cartNoteToggle.unload());
  },
});
var selectors$q = {
    settings: "[data-timer-settings]",
    days: "[data-days]",
    hours: "[data-hours]",
    minutes: "[data-minutes]",
    seconds: "[data-seconds]",
  },
  classes$9 = {
    active: "active",
    hide: "hide",
    complete: "complete",
  };

function CountdownTimer(s) {
  var h = n$2(selectors$q.settings, s);
  if (h) {
    var v = JSON.parse(h.innerHTML),
      m = v.year,
      g = v.month,
      y = v.day,
      b = v.hour,
      _ = v.minute,
      $ = v.shopTimezone,
      k = v.timeZoneSelection,
      S = v.hideTimerOnComplete;
    (u$1(s, classes$9.active),
      setInterval(function h() {
        window.requestAnimationFrame(function () {
          var h = n$2(selectors$q.days, s),
            v = n$2(selectors$q.hours, s),
            E = n$2(selectors$q.minutes, s),
            T = n$2(selectors$q.seconds, s),
            C = "shop" === k ? " GMT".concat($) : "",
            I = new Date(
              Date.parse(
                ""
                  .concat(g, " ")
                  .concat(y, ", ")
                  .concat(m, " ")
                  .concat(b, ":")
                  .concat(_)
                  .concat(C),
              ),
            ).getTime(),
            A = new Date().getTime(),
            L = I - A,
            B = Math.floor(L / 864e5),
            P = B < 10 ? "0" + B : B.toString(),
            x = Math.floor((L % 864e5) / 36e5),
            M = x < 10 ? "0" + x : x.toString(),
            H = Math.floor((L % 36e5) / 6e4),
            q = H < 10 ? "0" + H : H.toString(),
            O = Math.floor((L % 6e4) / 1e3),
            D = O < 10 ? "0" + O : O.toString();
          L > 0
            ? ((h.innerHTML = P),
              (v.innerHTML = M),
              (E.innerHTML = q),
              (T.innerHTML = D))
            : ((h.innerHTML = 0),
              (v.innerHTML = 0),
              (E.innerHTML = 0),
              (T.innerHTML = 0),
              u$1(s, classes$9.complete),
              S && u$1(s, classes$9.hide));
        });
      }, 1e3));
  }
}
var selectors$p = {
    wash: ".popup__wash",
    dismissButtons: "[data-dismiss-popup]",
    tab: ".popup__tab",
    tabButton: ".popup__tab-button",
    tabDismiss: ".popup__tab-dismiss",
    formSuccessMessage: ".form-status__message--success",
    timer: "[data-countdown-timer]",
  },
  classes$8 = {
    visible: "visible",
  };

function Popup(s) {
  var h = createFocusTrap(s, {
      allowOutsideClick: !0,
    }),
    v = animatePopup(s),
    m = n$2(selectors$p.wash, s),
    g = t$2(selectors$p.dismissButtons, s),
    y = n$2(selectors$p.formSuccessMessage, s),
    b = n$2(selectors$p.timer, s),
    _ = s.dataset,
    $ = _.delayType,
    k = _.showOnExitIntent,
    S = _.id,
    E = _.isSignup,
    T = _.popupType,
    C = n$2("".concat(selectors$p.tab, '[data-id="').concat(S, '"')),
    I = s.dataset,
    A = I.delayValue,
    L = I.hourFrequency;
  ((A = parseInt(A, 10)), (L = parseInt(L, 10)));
  var B = "popup-".concat(S),
    P = "signup-submitted-".concat(S),
    x = "form-success-".concat(S),
    M = "signup-dismissed-".concat(S),
    H = "age-verified-".concat(S),
    q = "true" === E,
    O = "age" === T,
    D = !1,
    R = Boolean(getStorage(P)),
    V = Boolean(getStorage(x)),
    N = Boolean(getStorage(M)),
    F = Boolean(getStorage(H)),
    U = !0,
    W = null;
  (b && (W = CountdownTimer(b)),
    (function s() {
      if (window.Shopify.designMode || (O && F) || (q && R)) {
        U = !1;
        return;
      }
      if (q && !R && N) {
        ((U = !1), C && X());
        return;
      }
      if (q || O || getStorage(B)) {
        var h,
          v = new Date(getStorage(B));
        U = (new Date() - v) / 1e3 / 60 / 60 > L;
      }
    })());
  var j = [];
  if (
    (window.Shopify.designMode || j.push(e$2(g, "click", Y)),
    O ||
      window.Shopify.designMode ||
      (j.push(e$2(m, "click", Y)),
      j.push(
        e$2(s, "keydown", function (s) {
          27 === s.keyCode && Y();
        }),
      )),
    C)
  ) {
    var G = n$2(selectors$p.tabButton, C),
      z = n$2(selectors$p.tabDismiss, C);
    (j.push(
      e$2(G, "click", function h() {
        if ((Q(), "flyout" === T && !window.Shopify.designMode)) {
          var v = n$2("button, [href], input, select, textarea", s);
          v &&
            v.focus({
              preventScroll: !0,
            });
        }
      }),
    ),
      j.push(
        e$2(z, "click", function s() {
          (i$1(C, classes$8.visible), removeStorage(M));
        }),
      ));
  }

  function Q() {
    (u$1(s, classes$8.visible),
      v.open(),
      ("popup" === T || "age" === T) &&
        (window.Shopify.designMode || h.activate(),
        document.body.setAttribute("data-fluorescent-overlay-open", "true"),
        disableBodyScroll(s)),
      (D = !0),
      window.Shopify.designMode && C ? X() : C && i$1(C, classes$8.visible));
  }

  function Y() {
    (i$1(s, classes$8.visible),
      q && (setStorage(M, JSON.stringify(new Date())), C && X()),
      O && setStorage(H, JSON.stringify(new Date())),
      setTimeout(function () {
        (v.close(),
          ("popup" === T || "age" === T) &&
            (h.deactivate(),
            document.body.setAttribute(
              "data-fluorescent-overlay-open",
              "false",
            ),
            enableBodyScroll(s)));
      }, 500));
  }

  function X() {
    u$1(C, classes$8.visible);
  }
  return (
    q && y && !V
      ? (setStorage(x, JSON.stringify(new Date())), Q())
      : (U &&
          ("timer" === $
            ? setTimeout(function () {
                D || (Q(), setStorage(B, JSON.stringify(new Date())));
              }, A)
            : "scroll" === $ &&
              window.addEventListener(
                "load",
                function () {
                  var s = A / 100,
                    h = (document.body.scrollHeight - window.innerHeight) * s,
                    v = e$2(window, "scroll", function () {
                      window.scrollY >= h &&
                        (D || (Q(), setStorage(B, JSON.stringify(new Date()))),
                        v());
                    });
                },
                {
                  once: !0,
                },
              )),
        "true" !== k ||
          isMobile$1() ||
          (function s() {
            if (U)
              var h = e$2(document.body, "mouseout", function (s) {
                s.relatedTarget ||
                  s.toElement ||
                  (h(),
                  D ||
                    (Q(), setStorage(B, JSON.stringify(new Date())), (D = !0)));
              });
          })()),
    {
      unload: function h() {
        (Y(),
          j.forEach(function (s) {
            return s();
          }),
          O && enableBodyScroll(s),
          W && W.destroy());
      },
      showPopup: Q,
      hidePopup: Y,
    }
  );
}
(register("popup", {
  onLoad: function s() {
    this.popups = t$2("[data-popup]", this.container).map(function (s) {
      return {
        contructor: Popup(s),
        element: s,
      };
    });
  },
  onBlockSelect: function s(h) {
    var v = h.target;
    this.popups
      .find(function (s) {
        return s.element === v;
      })
      .contructor.showPopup();
  },
  onBlockDeselect: function s(h) {
    var v = h.target;
    this.popups
      .find(function (s) {
        return s.element === v;
      })
      .contructor.hidePopup();
  },
  onUnload: function s() {
    this.popups.forEach(function (s) {
      var h;
      return null === (h = s.contructor) || void 0 === h ? void 0 : h.unload();
    });
  },
}),
  register("blog-posts", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateBlogPosts = animateBlogPosts(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateBlogPosts) || void 0 === h || h.destroy();
    },
  }));
var selectors$o = {
  itemTrigger: ".collapsible-row-list-item__trigger",
};
(register("collapsible-row-list", {
  onLoad: function s() {
    var h = this;
    ((this.items = t$2(selectors$o.itemTrigger, this.container)),
      (this.clickHandlers = e$2(this.items, "click", function (s) {
        s.preventDefault();
        var v = s.currentTarget,
          m = v.parentNode,
          g = v.nextElementSibling;
        isVisible(g)
          ? h._close(s.currentTarget, m, g)
          : h._open(s.currentTarget, m, g);
      })),
      shouldAnimate(this.container) &&
        (this.animateCollapsibleRowList = animateCollapsibleRowList(
          this.container,
        )));
  },
  _open: function s(h, v, m) {
    (slideStop(m),
      slideDown(m),
      v.setAttribute("data-open", !0),
      h.setAttribute("aria-expanded", !0),
      m.setAttribute("aria-hidden", !1));
  },
  _close: function s(h, v, m) {
    (slideStop(m),
      slideUp(m),
      v.setAttribute("data-open", !1),
      h.setAttribute("aria-expanded", !1),
      m.setAttribute("aria-hidden", !0));
  },
  onBlockSelect: function s(h) {
    var v = h.target,
      m = n$2(selectors$o.itemTrigger, v),
      g = m.parentNode,
      y = m.nextElementSibling;
    this._open(m, g, y);
  },
  onUnload: function s() {
    var h;
    (this.clickHandlers(),
      null === (h = this.animateCollapsibleRowList) ||
        void 0 === h ||
        h.destroy());
  },
}),
  register("collection-list-slider", {
    onLoad: function s() {
      var h = this.container.dataset,
        v = h.productsPerView,
        m = h.mobileProductsPerView;
      ((this.events = []),
        (this.perView = parseInt(v, 10)),
        (this.mobilePerView = 1.05 * parseInt(m, 10)),
        this._initCarousel(),
        shouldAnimate(this.container) &&
          (this.animateListSlider = animateListSlider(this.container)));
    },
    _initCarousel: function s() {
      this.carousel = Carousel(this.container, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
        breakpoints: {
          720: {
            spaceBetween: 16,
            slidesPerView: 5 === this.perView ? this.perView - 1 : this.perView,
          },
          1200: {
            spaceBetween: 24,
            slidesPerView: this.perView,
          },
        },
      });
    },
    onUnload: function s() {
      var h, v;
      (null === (h = this.carousel) || void 0 === h || h.destroy(),
        null === (v = this.animateListSlider) || void 0 === v || v.destroy());
    },
  }));
var selectors$n = {
  timer: "[data-countdown-timer]",
};
register("countdown-banner", {
  onLoad: function s() {
    var h = this,
      v = t$2(selectors$n.timer, this.container);
    ((this.countdownTimers = []),
      v.forEach(function (s) {
        h.countdownTimers.push(CountdownTimer(s));
      }),
      shouldAnimate(this.container) &&
        (this.animateCountdownBanner = animateCountdownBanner(this.container)));
  },
  onUnload: function s() {
    var h;
    (null === (h = this.animateCountdownBanner) || void 0 === h || h.destroy(),
      this.countdownTimers.forEach(function (s) {
        return s.destroy();
      }));
  },
});
var selectors$m = {
  timer: "[data-countdown-timer]",
};
(register("countdown-bar", {
  onLoad: function s() {
    var h = this,
      v = t$2(selectors$m.timer, this.container);
    ((this.countdownTimers = []),
      v.forEach(function (s) {
        h.countdownTimers.push(CountdownTimer(s));
      }),
      shouldAnimate(this.container) &&
        (this.animateCountdownBar = animateCountdownBar(this.container)));
  },
  onUnload: function s() {
    var h;
    (null === (h = this.animateCountdownBar) || void 0 === h || h.destroy(),
      this.countdownTimers.forEach(function (s) {
        return s.destroy();
      }));
  },
}),
  register("featured-collection-grid", {
    onLoad: function s() {
      var h = this,
        v = this.container.dataset,
        m = v.productsPerView,
        g = v.mobileProductsPerView;
      ((this.events = []),
        (this.perView = parseInt(m, 10)),
        (this.mobilePerView = 1.05 * parseInt(g, 10)),
        (this.productItem = ProductItem(this.container)),
        (this.breakPointHandler = atBreakpointChange(960, function () {
          window.matchMedia(getMediaQuery("below-960")).matches
            ? h._initCarousel()
            : h.carousel.destroy();
        })),
        window.matchMedia(getMediaQuery("below-960")).matches &&
          this._initCarousel(),
        shouldAnimate(this.container) &&
          (this.animateFeaturedCollectionGrid = animateFeaturedCollectionGrid(
            this.container,
          )));
    },
    _initCarousel: function s() {
      this.carousel = Carousel(this.container, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
        breakpoints: {
          720: {
            spaceBetween: 16,
            slidesPerView: 5 === this.perView ? this.perView - 1 : this.perView,
          },
        },
      });
    },
    onUnload: function s() {
      var h, v;
      (null === (h = this.carousel) || void 0 === h || h.destroy(),
        null === (v = this.animateFeaturedCollectionGrid) ||
          void 0 === v ||
          v.destroy());
    },
  }));
var selectors$l = {
    navItems: ".featured-collection-slider__navigation-list-item",
    sliderContainer: ".carousel",
    navButtons: ".carousel__navigation-buttons",
  },
  classes$7 = {
    selected: "selected",
    visible: "visible",
    fadeout: "fadeout",
    initReveal: "init-reveal",
    reveal: "reveal",
  };
(register("featured-collection-slider", {
  onLoad: function s() {
    ((this.events = []),
      (this.carousels = []),
      this._initCarousels(),
      shouldAnimate(this.container) &&
        (this.animateListSlider = animateListSlider(this.container)));
  },
  _initCarousels: function s() {
    var h = this,
      v = this.container.dataset,
      m = v.productsPerView,
      g = v.mobileProductsPerView;
    ((this.perView = parseInt(m, 10)),
      (this.mobilePerView = 1.05 * parseInt(g, 10)),
      (this.productItem = ProductItem(this.container)),
      (this.carouselsElements = t$2(
        selectors$l.sliderContainer,
        this.container,
      )),
      (this.navItems = t$2(selectors$l.navItems, this.container)),
      (this.navigationButtons = t$2(selectors$l.navButtons, this.container)),
      this.navItems.forEach(function (s) {
        return h.events.push(e$2(s, "click", h._handleNavButton.bind(h)));
      }),
      this.carouselsElements.forEach(function (s, v) {
        var m = n$2('[data-navigation="'.concat(v, '"]'), h.container),
          g = n$2("[data-next]", m),
          y = n$2("[data-prev]", m);
        h.carousels.push(
          Carousel(s, {
            slidesPerView: "auto",
            spaceBetween: 8,
            watchOverflow: !0,
            navigation: {
              nextEl: g,
              prevEl: y,
            },
            breakpoints: {
              720: {
                spaceBetween: 8,
                slidesPerView: "auto",
              },
              1200: {
                spaceBetween: 8,
                slidesPerView: "auto",
              },
            },
          }),
        );
      }));
 
    this.hasFilterByCollection = Boolean(v?.hasFilterByCollection);
    this.activeFilter = v?.activeCategoryFilter || null;
    this.categoryFiltersContainerHeight = 0;
    if (this.hasFilterByCollection) {
      h._initFilters();
    }
  },
  _initFilters: function s() {
    var h = this;
    var selectors = {
      button: "[data-category-filter]",
      container: "[data-category-filters-container]",
    };

    var filterContainer = n$2(
      selectors.container,
      this.container,
    );
    if (filterContainer) {
      this.categoryFiltersContainerHeight = filterContainer.offsetHeight;

      if (a$1(filterContainer, classes$7.visible)) {
        filterContainer.style.height = ''.concat(this.categoryFiltersContainerHeight, 'px');
      } else {
        filterContainer.style.height = '0px';
      }
    }

    var bts = t$2(selectors.button, this.container);
    if (!bts || bts.length === 0) return;

    bts.forEach(function (bt) {
      return h.events.push(e$2(bt, "click", h._handleFilterButton.bind(h)));
    });
  },
  _handleNavButton: function s(h) {
    h.preventDefault();
    var v = h.currentTarget.dataset.navigationItem;
    a$1(h.currentTarget, classes$7.selected) ||
      (this._hideAll(), this._show(parseInt(v, 10)));
  },
  _handleFilterButton: function s(h) {
    h.preventDefault();
    
    var selectors = {
      activeButton: "[data-category-filter].active",
    };
    var newFilter = h.currentTarget.dataset.categoryFilter;

    if (newFilter) {
      this._toggleFilteredProducts(newFilter);

      i$1(this.container.querySelector(selectors.activeButton), "active");
      u$1(h.currentTarget, "active");

      this._updateCarousel();
      this._resetCarouselScroll();
      this.activeFilter = newFilter;
    }
  },
  _resetCarouselScroll: function s() {
    this.carousels.forEach(function (s) {
      return s.resetScroll();
    });
  },
  _updateCarousel: function s() {
    this.carousels.forEach(function (s) {
      return s.update();
    });
  },
  _toggleFilteredProducts: function s(category) {
    var selectors = {
      productItem: "[data-category-item]",
    };

    var oldProducts = this.container.querySelectorAll(
      selectors.productItem.replace(']', '="'.concat(this.activeFilter, '"]')),
    );

    oldProducts.forEach(function (s) {
      u$1(s, "hidden");
    });

    var newProducts = this.container.querySelectorAll(
      selectors.productItem.replace(']', '="'.concat(category, '"]')),
    );

    newProducts.forEach(function (s) {
      i$1(s, "hidden");
    });
  },
  _hideAll: function s() {
    var h = this;
    (i$1(this.navItems, classes$7.selected),
      i$1(this.navigationButtons, classes$7.visible),
      i$1(this.carouselsElements, classes$7.initReveal),
      i$1(this.carouselsElements, classes$7.reveal),
      shouldAnimate(this.container)
        ? (u$1(this.carouselsElements, classes$7.fadeout),
          setTimeout(function () {
            i$1(h.carouselsElements, classes$7.visible);
          }, 300))
        : i$1(this.carouselsElements, classes$7.visible));
  },
  _toggleFilters: function s(m) {
    var selectors = {
      filterContainer: "[data-category-filters-container]",
    };

    if(!this.hasFilterByCollection) {
      return;
    }

    if (m?.dataset?.filteredCollection) {
      var filterContainer = this.container.querySelector(
        selectors.filterContainer,
      );
      if (filterContainer) {
        u$1(filterContainer, classes$7.visible);
        filterContainer.style.height = ''.concat(this.categoryFiltersContainerHeight, 'px');
      }
    } else {
      var filterContainer = this.container.querySelector(
        selectors.filterContainer,
      );
      if (filterContainer) {
        i$1(filterContainer, classes$7.visible);
        filterContainer.style.height = '0px';
      }
    }
  },
  _show: function s(h) {
    var v = n$2('[data-navigation="'.concat(h, '"]'), this.container);
    u$1(v, classes$7.visible);
    var m = n$2('[data-collection="'.concat(h, '"]'), this.container);

    this._toggleFilters(m);

    if (this.navItems.length) {
      var g = n$2('[data-navigation-item="'.concat(h, '"]'), this.container);
      u$1(g, classes$7.selected);
    }
    shouldAnimate(this.container)
      ? (u$1(m, classes$7.fadeout),
        u$1(m, classes$7.initReveal),
        setTimeout(function () {
          (u$1(m, classes$7.visible),
            i$1(m, classes$7.fadeout),
            setTimeout(function () {
              u$1(m, classes$7.reveal);
            }, 50));
        }, 300))
      : u$1(m, classes$7.visible);
  },
  onUnload: function s() {
    var h;
    (this.carousels.forEach(function (s) {
      return s.destroy();
    }),
      null === (h = this.animateListSlider) || void 0 === h || h.destroy(),
      this.events.forEach(function (s) {
        return s();
      }));
  },
  onBlockSelect: function s(h) {
    var v = h.target.dataset.collection;
    (this._hideAll(), this._show(parseInt(v, 10)));
  },
}),
  register("featured-product", {
    onLoad: function s() {
      ((this.product = new Product(this.container)),
        shouldAnimate(this.container) &&
          (this.animateProduct = animateProduct(this.container)));
    },
    onBlockSelect: function s(h) {
      var v = h.target,
        m = n$2(".accordion__label", v);
      if (
        (v.scrollIntoView({
          block: "center",
          behavior: "smooth",
        }),
        m)
      ) {
        var g = m.parentNode,
          y = m.nextElementSibling;
        (slideStop(y),
          slideDown(y),
          g.setAttribute("data-open", !0),
          m.setAttribute("aria-expanded", !0),
          y.setAttribute("aria-hidden", !1));
      }
    },
    onBlockDeselect: function s(h) {
      var v = n$2(".accordion__label", h.target);
      if (v) {
        var m = v.parentNode,
          g = v.nextElementSibling;
        (slideStop(g),
          slideUp(g),
          m.setAttribute("data-open", !1),
          v.setAttribute("aria-expanded", !1),
          g.setAttribute("aria-hidden", !0));
      }
    },
    onUnload: function s() {
      var h;
      (this.product.unload(),
        null === (h = this.animateProduct) || void 0 === h || h.destroy());
    },
  }),
  register("gallery-carousel", {
    onLoad: function s() {
      var h = this.container.dataset,
        v = h.loopCarousel,
        m = h.productsPerView,
        g = h.mobileProductsPerView;
      ((this.loopCarousel = "true" === v),
        (this.perView = 1.05 * parseInt(m, 10)),
        (this.mobilePerView = 1.05 * parseInt(g, 10)),
        this._initCarousel(),
        shouldAnimate(this.container) &&
          (this.animateListSlider = animateListSlider(this.container)));
    },
    _initCarousel: function s() {
      this.carousel = Carousel(this.container, {
        slidesPerView: this.mobilePerView,
        spaceBetween: 12,
        loop: this.loopCarousel,
        breakpoints: {
          720: {
            spaceBetween: 16,
            slidesPerView: this.perView,
          },
          1200: {
            spaceBetween: 24,
            slidesPerView: this.perView,
          },
        },
      });
    },
    onUnload: function s() {
      var h, v;
      (null === (h = this.carousel) || void 0 === h || h.destroy(),
        null === (v = this.animateListSlider) || void 0 === v || v.destroy());
    },
  }));
var selectors$k = {
  recommendations: "[data-recommendations]",
  carouselSlide: ".carousel__slide",
};
register("recommended-products", {
  onLoad: function s() {
    var h = this,
      v = this.container.dataset,
      m = v.limit,
      g = v.productId,
      y = v.sectionId,
      b = v.productsPerView,
      _ = v.mobileProductsPerView;
    ((this.perView = parseInt(b, 10)),
      (this.mobilePerView = 1.05 * parseInt(_, 10)));
    var $ = n$2(selectors$k.recommendations, this.container);
    if ($) {
      var k = ""
          .concat(window.theme.routes.productRecommendations, "?section_id=")
          .concat(y, "&limit=")
          .concat(m, "&product_id=")
          .concat(g),
        S = new XMLHttpRequest();
      (S.open("GET", k, !0),
        (S.onload = function () {
          if (S.status >= 200 && S.status < 300) {
            var s = document.createElement("div");
            ((s.innerHTML = S.response),
              ($.innerHTML = n$2(selectors$k.recommendations, s).innerHTML));
            var v = n$2(selectors$k.carouselSlide, $);
            ((h.productItem = ProductItem(h.container)),
              shouldAnimate(h.container) &&
                (h.animateListSlider = animateListSlider(h.container)),
              v
                ? (h.carousel = Carousel($, {
                    slidesPerView: h.mobilePerView,
                    spaceBetween: 12,
                    breakpoints: {
                      720: {
                        spaceBetween: 16,
                        slidesPerView:
                          5 === h.perView ? h.perView - 1 : h.perView,
                      },
                      1200: {
                        spaceBetween: 24,
                        slidesPerView: h.perView,
                      },
                    },
                  }))
                : h._removeSection());
          } else h._removeSection();
        }),
        S.send());
    }
  },
  _removeSection: function s() {
    this.container.parentNode.removeChild(this.container);
  },
  onUnload: function s() {
    var h, v;
    (null === (h = this.carousel) || void 0 === h || h.destroy(),
      null === (v = this.animateListSlider) || void 0 === v || v.destroy());
  },
});
var selectors$j = {
  slide: "[data-slide]",
  swiper: ".swiper",
  navigationPrev: ".slideshow-navigation__navigation-button--previous",
  navigationNext: ".slideshow-navigation__navigation-button--next",
  navigationDots: ".slideshow-navigation__dots",
  navigationDot: ".slideshow-navigation__dot",
  navigationLoader: ".slideshow-navigation__dot-loader",
  activeDot: "slideshow-navigation__dot--active",
  animatableItems: ".animation--section-blocks > *",
};
register("slideshow", {
  onLoad: function s() {
    var h = this;
    ((this.events = []),
      (this.enableAutoplay = this.container.dataset.enableAutoplay),
      (this.autoplayDuration = this.container.dataset.autoplay),
      (this.slideshow = null),
      (this.slideshowContainer = n$2(selectors$j.swiper, this.container)),
      (this.slides = t$2(selectors$j.slide, this.container)),
      this.events.push(
        e$2(this.container, "focusin", function () {
          return h.handleFocus();
        }),
      ),
      shouldAnimate(this.container) &&
        ((this.slideAnimations = this.slides.map(function (s) {
          return delayOffset(s, [selectors$j.animatableItems], 3);
        })),
        (this.observer = intersectionWatcher(this.container))),
      this.slides.length > 1 &&
        import(flu.chunks.swiper).then(function (s) {
          var v = s.Swiper,
            m = s.Navigation,
            g = s.Autoplay,
            y = s.Pagination,
            b = s.EffectFade,
            _ = s.EffectCreative,
            $ = {
              modules: [m, y],
              slidesPerView: 1,
              grabCursor: !1,
              effect: "fade",
              fadeEffect: {
                crossFade: !1,
              },
              watchSlidesProgress: !0,
              loop: !0,
              navigation: {
                nextEl: selectors$j.navigationNext,
                prevEl: selectors$j.navigationPrev,
              },
              pagination: {
                el: selectors$j.navigationDots,
                clickable: !0,
                bulletActiveClass: selectors$j.activeDot,
                bulletClass: "slideshow-navigation__dot",
                renderBullet: function s(h, v) {
                  return '\n                <button class="'.concat(
                    v,
                    '" type="button">\n                  <div class="slideshow-navigation__dot-loader"></div>\n                </button>',
                  );
                },
              },
              on: {
                afterInit: function s() {
                  h.handleBulletLabels();
                },
                slideChangeTransitionEnd: function s() {
                  this.slides.forEach(function (s) {
                    (s.toggleAttribute(
                      "inert",
                      !s.classList.contains("swiper-slide-active"),
                    ),
                      CountdownTimer(s));
                  });
                },
              },
            };
          ("true" === h.enableAutoplay &&
            ($.modules.push(g),
            ($.autoplay = {
              delay: h.autoplayDuration,
              disableOnInteraction: !1,
            })),
            prefersReducedMotion()
              ? ($.modules.push(_),
                ($.effect = "creative"),
                ($.creativeEffect = {
                  prev: {
                    opacity: 0.99,
                  },
                  next: {
                    opacity: 1,
                  },
                }))
              : ($.modules.push(b),
                ($.effect = "fade"),
                ($.fadeEffect = {
                  crossFade: !1,
                })),
            (h.slideshow = new v(h.slideshowContainer, $)),
            r$1("slideshow:initialized"));
        }));
  },
  handleFocus: function s() {
    a$1(document.body, "user-is-tabbing") && this.slideshow.autoplay.stop();
  },
  handleBulletLabels: function s() {
    var h = this;
    t$2(selectors$j.navigationDot, this.container).forEach(function (s, v) {
      var m = h.slides[v].dataset.bulletLabel;
      s.setAttribute("aria-label", m);
    });
  },
  handleBlockSelect: function s(h) {
    (this.slideshow.slideTo(parseInt(h, 10)),
      this.slideshow.autoplay.stop(),
      t$2(selectors$j.navigationLoader, this.container).forEach(function (s) {
        s.style.animationPlayState = "paused";
      }));
  },
  handleBlockDeselect: function s() {
    var h;
    (null === (h = this.slideshow) || void 0 === h || h.autoplay.start(),
      t$2(selectors$j.navigationLoader, this.container).forEach(function (s) {
        s.style.animationPlayState = "running";
      }));
  },
  onBlockSelect: function s(h) {
    var v = this,
      m = h.target.dataset.slide;
    this.slideshow
      ? this.handleBlockSelect(m)
      : this.events.push(
          c("slideshow:initialized", function () {
            v.handleBlockSelect(m);
          }),
        );
  },
  onBlockDeselect: function s() {
    var h = this;
    this.slideshow
      ? this.handleBlockDeselect()
      : this.events.push(
          c("slideshow:initialized", function () {
            h.handleBlockDeselect();
          }),
        );
  },
  onUnload: function s() {
    var h, v;
    (null === (h = this.slideshow) || void 0 === h || h.destroy(),
      this.events.forEach(function (s) {
        return s();
      }),
      null === (v = this.observer) || void 0 === v || v.destroy());
  },
});
var loaded$1 = null;

function loadYouTubeAPI() {
  return null !== loaded$1
    ? loaded$1
    : (loaded$1 =
        window.YT && window.YT.loaded
          ? Promise.resolve()
          : new Promise(function (s) {
              window.onYouTubeIframeAPIReady = function () {
                s();
              };
              var h = document.createElement("script");
              ((h.src = "https://www.youtube.com/iframe_api"),
                document.body.appendChild(h));
            }));
}
var loaded = null;

function loadVimeoAPI() {
  return null !== loaded
    ? loaded
    : (loaded = window.Vimeo
        ? Promise.resolve()
        : new Promise(function (s) {
            var h = document.createElement("script");
            ((h.src = "https://player.vimeo.com/api/player.js"),
              (h.onload = s),
              document.body.appendChild(h));
          }));
}
var selectors$i = {
    video: ".video__video",
    videoExternal: "[data-video-external-target]",
    image: ".video__image",
    overlay: ".video__overlay",
    text: ".video__text-container-wrapper",
    playTrigger: ".video__text-container-wrapper",
  },
  classes$6 = {
    visible: "visible",
  };
register("video", {
  onLoad: function s() {
    var h = this;
    this.events = [];
    var v = n$2(selectors$i.playTrigger, this.container),
      m = n$2(selectors$i.video, this.container),
      g = n$2(selectors$i.videoExternal, this.container),
      y = n$2(selectors$i.image, this.container),
      b = n$2(selectors$i.overlay, this.container),
      _ = n$2(selectors$i.text, this.container);
    if (g) {
      var $ = g.dataset,
        k = $.videoProvider,
        S = $.videoId,
        E = $.loop;
      switch (k) {
        case "youtube":
          loadYouTubeAPI().then(function () {
            var s = new window.YT.Player(g, {
              videoId: S,
              playerVars: {
                autohide: 0,
                cc_load_policy: 0,
                controls: 1,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                rel: 0,
                loop: E,
                playlist: S,
              },
              events: {
                onReady: function m() {
                  ((s.getIframe().tabIndex = "-1"),
                    h.events.push(
                      e$2(v, "click", function () {
                        s.playVideo();
                      }),
                    ));
                },
                onStateChange: function h(v) {
                  v.data == YT.PlayerState.PLAYING &&
                    ((s.getIframe().tabIndex = "0"), T());
                },
              },
            });
          });
          break;
        case "vimeo":
          loadVimeoAPI().then(function () {
            var s = new window.Vimeo.Player(g, {
              id: S,
              controls: !0,
              keyboard: !1,
            });
            ((s.element.tabIndex = "-1"),
              "true" === E && s.setLoop(1),
              h.events.push(
                e$2(v, "click", function () {
                  (s.play(), (s.element.tabIndex = "0"), T());
                }),
              ));
          });
      }
    }

    function T() {
      (i$1(b, classes$6.visible),
        i$1(_, classes$6.visible),
        y && i$1(y, classes$6.visible));
    }
    (v &&
      m &&
      this.events.push(
        e$2(v, "click", function () {
          m.play();
        }),
      ),
      m &&
        this.events.push(
          e$2(m, "playing", function () {
            (m.setAttribute("controls", ""), T());
          }),
        ),
      shouldAnimate(this.container) &&
        (this.animateVideo = animateVideo(this.container)));
  },
  onUnload: function s() {
    var h;
    (this.playButtons &&
      this.playButtons.forEach(function (s) {
        return s.unload();
      }),
      this.events.forEach(function (s) {
        return s();
      }),
      this.videoHandler && this.videoHandler(),
      null === (h = this.animateVideo) || void 0 === h || h.destroy());
  },
});
var selectors$h = {
    playButton: "[data-play-button-block]",
    playButtonVideoContainer: "[data-play-button-block-video-container]",
    photoSwipeElement: ".pswp",
    video: ".play-button-block-video",
  },
  icons = window.theme.icons,
  playButton = function s(h) {
    var v,
      s = n$2(selectors$h.playButton, h),
      m = n$2(selectors$h.playButtonVideoContainer, h).outerHTML;
    import(flu.chunks.photoswipe);
    var g = [
      e$2(s, "click", function () {
        import(flu.chunks.photoswipe).then(function (s) {
          var h = s.PhotoSwipeLightbox,
            g = s.PhotoSwipe;
          ((v = new h({
            dataSource: [
              {
                html: m,
              },
            ],
            pswpModule: g,
            mainClass: "pswp--video-lightbox",
            closeSVG: icons.close,
            arrowPrev: !1,
            arrowNext: !1,
            zoom: !1,
            counter: !1,
          })).init(),
            v.loadAndOpen(),
            v.on("bindEvents", function () {
              n$2(selectors$h.video, v.pswp.container).play();
            }));
        });
      }),
    ];
    return {
      unload: function s() {
        (g.forEach(function (s) {
          return s();
        }),
          v && v.destroy());
      },
    };
  },
  autoPlay = function s(h) {
    if (h.length)
      var v = [
        e$2(window, "click", function () {
          return m();
        }),
        e$2(window, "touchstart", function () {
          return m();
        }),
      ];

    function m() {
      (h.forEach(function (s) {
        s.playing || s.play();
      }),
        v.forEach(function (s) {
          return s();
        }));
    }
  },
  selectors$g = {
    video: ".video-hero__video",
    playButtonVideo: "[data-play-button-block-video]",
    playButtonBlock: ".play-button-block",
  };
register("video-hero", {
  videoHandler: null,
  onLoad: function s() {
    var h = t$2(selectors$g.playButtonVideo, this.container),
      v = t$2(selectors$g.video, this.container);
    (h.length &&
      (this.playButtons = h.map(function (s) {
        return playButton(s.closest(selectors$g.playButtonBlock));
      })),
      v &&
        ((this.videoHandler = backgroundVideoHandler(this.container)),
        autoPlay(v)),
      shouldAnimate(this.container) &&
        (this.animateVideoHero = animateVideoHero(this.container)));
  },
  onUnload: function s() {
    var h;
    (this.playButtons &&
      this.playButtons.forEach(function (s) {
        return s.unload();
      }),
      this.videoHandler && this.videoHandler(),
      null === (h = this.animateVideoHero) || void 0 === h || h.destroy());
  },
});
var selectors$f = {
    dots: ".navigation-dot",
  },
  navigationDots = function s(h) {
    var v = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      s = t$2(selectors$f.dots, h),
      m = [];
    s.forEach(function (s) {
      m.push(
        e$2(s, "click", function (s) {
          return g(s);
        }),
      );
    });
    var g = function s(h) {
      if (
        (h.preventDefault(),
        !h.target.classList.contains("is-selected") && v.onSelect)
      ) {
        var m = parseInt(h.target.dataset.index, 10);
        v.onSelect(m);
      }
    };
    return {
      update: function h(v) {
        if ("number" != typeof v) {
          console.debug(
            "navigationDots#update: invalid index, ensure int is passed",
          );
          return;
        }
        var m = "is-selected";
        (s.forEach(function (s) {
          return i$1(s, m);
        }),
          u$1(s[v], m));
      },
      unload: function s() {
        m.forEach(function (s) {
          return s();
        });
      },
    };
  },
  selectors$e = {
    slider: "[data-slider]",
    slide: "[data-slide]",
    logoNavButton: "[logo-nav-button]",
  };
register("quote", {
  onLoad: function s() {
    var h = this,
      v = n$2(selectors$e.slider, this.container),
      m = t$2(selectors$e.slide, this.container);
    if (
      (shouldAnimate(this.container) &&
        (m.forEach(function (s) {
          return animateQuotes(s);
        }),
        (this.observer = intersectionWatcher(this.container))),
      m.length < 2)
    )
      return (m.length && u$1(m[0], "swiper-slide-visible"), null);
    var g = v.dataset.paginationStyle,
      y = "true" == v.dataset.autoplayEnabled,
      b = parseInt(v.dataset.autoplayDelay, 10);
    ((this.events = []),
      import(flu.chunks.swiper).then(function (s) {
        var m = s.Swiper,
          _ = s.Autoplay,
          $ = s.Navigation,
          k = s.EffectFade;
        ((h.swiper = new m(v, {
          modules: [$, _, k],
          grabCursor: !0,
          effect: "fade",
          fadeEffect: {
            crossFade: !0,
          },
          loop: !0,
          autoplay: !!y && {
            delay: b,
            disableOnInteraction: !1,
            pauseOnMouseEnter: !0,
          },
          navigation: {
            nextEl: ".slider-nav-button-next",
            prevEl: ".slider-nav-button-prev",
          },
        })),
          "dots" === g
            ? (h.dotNavigation = navigationDots(h.container, {
                onSelect: function s(v) {
                  h.swiper.slideToLoop(v);
                },
              }))
            : "logos" === g &&
              ((h.logoNavButtons = t$2(selectors$e.logoNavButton, h.container)),
              u$1(h.logoNavButtons[0], "active"),
              h.logoNavButtons.forEach(function (s) {
                h.events.push(
                  e$2(s, "click", function (s) {
                    var v = parseInt(s.currentTarget.dataset.index, 10);
                    h.swiper.slideToLoop(v);
                  }),
                );
              })),
          h.swiper.on("slideChange", function () {
            var s = h.swiper.realIndex;
            if ("dots" === g) h.dotNavigation.update(s);
            else if ("logos" === g) {
              var v = "active";
              (h.logoNavButtons.forEach(function (s) {
                return i$1(s, v);
              }),
                u$1(h.logoNavButtons[s], v));
            }
          }));
      }));
  },
  onBlockSelect: function s(h) {
    var v,
      m,
      g,
      y = parseInt(h.target.dataset.index, 10);
    (null === (v = this.swiper) ||
      void 0 === v ||
      null === (m = v.autoplay) ||
      void 0 === m ||
      m.stop(),
      null === (g = this.swiper) || void 0 === g || g.slideToLoop(y));
  },
  onBlockDeselect: function s() {
    var h, v;
    null === (h = this.swiper) ||
      void 0 === h ||
      null === (v = h.autoplay) ||
      void 0 === v ||
      v.start();
  },
  onUnload: function s() {
    var h, v, m;
    (null === (h = this.swiper) || void 0 === h || h.destroy(),
      null === (v = this.dotNavigation) || void 0 === v || v.unload(),
      this.events.forEach(function (s) {
        return s();
      }),
      null === (m = this.observer) || void 0 === m || m.destroy());
  },
});
var selectors$d = {
    hotspotWrappers: ".shoppable-item",
    hotspots: ".shoppable-item__hotspot",
    productCard: ".shoppable-item__product-card",
    closeButtons: "[data-shoppable-item-close]",
    mobileDrawer: ".shoppable-feature-mobile-drawer",
    desktopSliderContainer: ".shoppable-feature__secondary-content",
    slider: ".swiper",
    slide: ".swiper-slide",
    sliderPagination: ".swiper-pagination",
    sliderImages: ".product-card-mini__image img",
    imageContainer: ".shoppable__image-container",
    sliderNavPrev: ".slider-nav-button-prev",
    sliderNavNext: ".slider-nav-button-next",
    drawerBackground: ".mobile-drawer__overlay",
    drawerCloseButton: ".mobile-drawer__close",
    quickViewTrigger: "[data-quick-view-trigger]",
    wash: "[data-shoppable-wash]",
  },
  classes$5 = {
    animating: "shoppable-item--animating",
    unset: "shoppable-item--position-unset",
    hidden: "hidden",
    active: "active",
    drawerActive: "active",
    pulse: "shoppable-item__hotspot--pulse",
  },
  sliderTypes = {
    Desktop: "desktop",
    Mobile: "mobile",
  };
register("shoppable", {
  onLoad: function s() {
    var h = this;
    ((this.imageContainer = n$2(selectors$d.imageContainer, this.container)),
      (this.showHotspotCards =
        "true" === this.container.dataset.showHotspotCards),
      (this.hasCarousel = "true" === this.container.dataset.hasCarousel),
      (this.productCards = t$2(selectors$d.productCard, this.container)),
      (this.hotspotContainers = t$2(
        selectors$d.hotspotWrappers,
        this.container,
      )),
      (this.hotspots = t$2(selectors$d.hotspots, this.container)),
      (this.wash = n$2(selectors$d.wash, this.container)));
    var v = t$2(selectors$d.closeButtons, this.container);
    ((this.hotspotEvents = this.hotspots.map(function (s) {
      return {
        element: s,
        event: e$2(s, "mouseenter", function (v) {
          (i$1(v.currentTarget.parentNode, classes$5.animating),
            h.hotspotEvents
              .find(function (h) {
                return h.element === s;
              })
              .event());
        }),
      };
    })),
      (this.events = [
        e$2(this.hotspots, "click", function (s) {
          return h._hotspotClickHandler(s);
        }),
        e$2(v, "click", function () {
          return h._closeAll();
        }),
        e$2(this.container, "keydown", function (s) {
          27 === s.keyCode && h._closeAll();
        }),
        e$2(
          t$2(selectors$d.quickViewTrigger, this.container),
          "click",
          function (s) {
            var v = s.target.dataset.productUrl;
            v &&
              (r$1("quick-view:open", null, {
                productUrl: v,
              }),
              window.matchMedia(getMediaQuery("below-960")).matches &&
                h._closeDrawer());
          },
        ),
      ]),
      (this.breakPointHandler = atBreakpointChange(960, function () {
        h._closeAll();
      })),
      this.hasCarousel
        ? (this._setupDrawer(),
          this._createOrRecreateSlider(),
          (this.mobileDrawer = n$2(selectors$d.mobileDrawer, this.container)),
          (this.widthWatcher = srraf(function (s) {
            var v,
              m = s.vw;
            s.pvw >= 960 != m >= 960 && h._createOrRecreateSlider();
          })),
          shouldAnimate(this.container) &&
            (this.animateShoppableFeature = animateShoppableFeature(
              this.container,
            )))
        : this.events.push(
            e$2(document, "click", function (s) {
              return h._clickOutsideHandler(s);
            }),
          ),
      this.showHotspotCards &&
        (window.matchMedia(getMediaQuery("above-960")).matches &&
          this.hotspots.length &&
          this._activateHotspot(0),
        this.productCards.forEach(function (s) {
          return h._setCardDemensions(s);
        }),
        shouldAnimate(this.container) &&
          (this.animateShoppableImage = animateShoppableImage(this.container))),
      this._initPulseLoop());
  },
  _initPulseLoop: function s() {
    var h = t$2(selectors$d.hotspots, this.container),
      v = 0;
    this.pulseInterval = setInterval(function () {
      (i$1(h, classes$5.pulse),
        setTimeout(function () {
          (u$1(h[v], classes$5.pulse), ++v >= h.length && (v = 0));
        }, 0));
    }, 3e3);
  },
  _pulseLoop: function s() {},
  _createOrRecreateSlider: function s() {
    var h = this,
      v = window.matchMedia(getMediaQuery("above-960")).matches
        ? sliderTypes.Desktop
        : sliderTypes.Mobile;
    if (this.sliderType !== v) {
      ((this.sliderType = v),
        null === (m = this.swiper) || void 0 === m || m.destroy(),
        (this.sliderInitalized = !1));
      var m,
        g =
          v === sliderTypes.Desktop
            ? selectors$d.desktopSliderContainer
            : selectors$d.mobileDrawer;
      if (
        ((this.sliderContainer = n$2(g, this.container)),
        (this.slider = n$2(selectors$d.slider, this.sliderContainer)),
        (this.slides = t$2(selectors$d.slide, this.sliderContainer)),
        (this.sliderPagination = n$2(
          selectors$d.sliderPagination,
          this.sliderContainer,
        )),
        (this.sliderNavNext = n$2(
          selectors$d.sliderNavNext,
          this.sliderContainer,
        )),
        (this.sliderNavPrev = n$2(
          selectors$d.sliderNavPrev,
          this.sliderContainer,
        )),
        (this.sliderImages = t$2(
          selectors$d.sliderImages,
          this.sliderContainer,
        )),
        this.slides.length < 2)
      )
        return;
      var y = this;
      import(flu.chunks.swiper).then(function (s) {
        var v = s.Swiper,
          m = s.Navigation,
          g = s.Pagination;
        h.swiper = new v(h.slider, {
          modules: [m, g],
          grabCursor: window.matchMedia(getMediaQuery("below-960")).matches,
          slidesPerView: 1,
          watchSlidesProgress: !0,
          loop: !0,
          navigation: {
            nextEl: h.sliderNavNext,
            prevEl: h.sliderNavPrev,
          },
          pagination: {
            el: h.sliderPagination,
            type: "fraction",
          },
          on: {
            sliderFirstMove: function s() {
              y.sliderHasBeenInteractedWith = !0;
            },
            activeIndexChange: function s(h) {
              var v = h.realIndex;
              y.sliderInitalized && y._indicateActiveHotspot(v);
            },
            afterInit: function s() {
              var h;
              ((y.sliderInitalized = !0),
                null === (h = y.sliderImages) ||
                  void 0 === h ||
                  h.forEach(function (s) {
                    return s.setAttribute("loading", "eager");
                  }),
                y.sliderType !== sliderTypes.Mobile &&
                  y._indicateActiveHotspot(0));
            },
            slideChangeTransitionEnd: function s() {
              var h = this.slides;
              setTimeout(function () {
                h.forEach(function (s) {
                  s.toggleAttribute(
                    "inert",
                    !s.classList.contains("swiper-slide-active"),
                  );
                });
              }, 50);
            },
          },
        });
      });
    }
  },
  _indicateActiveHotspot: function s(h) {
    this.hotspotContainers.forEach(function (s) {
      return i$1(s, classes$5.active);
    });
    var v = n$2(".shoppable-item[data-index='".concat(h, "']"), this.container);
    u$1(v, classes$5.active);
  },
  _activateHotspot: function s(h) {
    var v = n$2(".shoppable-item[data-index='".concat(h, "']"), this.container),
      m = n$2(selectors$d.productCard, v);
    if ((n$2(selectors$d.hotspots, v), !m)) {
      if (this.swiper) {
        var g = this.sliderType === sliderTypes.Mobile;
        (this.swiper.slideToLoop(h, g ? 0 : void 0), g && this._openDrawer());
      } else
        window.matchMedia(getMediaQuery("below-960")).matches &&
          this._openDrawer();
      return;
    }
    a$1(m, "hidden")
      ? (this._closeAll(),
        m.setAttribute("aria-hidden", !1),
        this._setCardDemensions(m),
        i$1(m, classes$5.hidden),
        this.swiper || this._indicateActiveHotspot(h),
        window.matchMedia(getMediaQuery("below-960")).matches &&
          this._showWash())
      : (m.setAttribute("aria-hidden", !0),
        u$1(m, classes$5.hidden),
        i$1(v, classes$5.active));
  },
  _setCardDemensions: function s(h) {
    var v = h.offsetHeight,
      m = h.offsetWidth;
    (h.style.setProperty("--card-height", v + "px"),
      h.style.setProperty("--card-width", m + "px"));
  },
  _setupDrawer: function s() {
    var h = this,
      v = n$2(selectors$d.drawerBackground, this.container),
      m = n$2(selectors$d.drawerCloseButton, this.container);
    (this.events.push(
      e$2(v, "click", function () {
        return h._closeDrawer();
      }),
    ),
      this.events.push(
        e$2(m, "click", function () {
          return h._closeDrawer();
        }),
      ));
  },
  _openDrawer: function s() {
    (u$1(this.mobileDrawer, classes$5.drawerActive),
      document.body.setAttribute("data-fluorescent-overlay-open", "true"),
      disableBodyScroll(this.mobileDrawer),
      this._showWash());
  },
  _showWash: function s() {
    u$1(this.wash, classes$5.active);
  },
  _closeDrawer: function s() {
    (this.mobileDrawer &&
      (i$1(this.mobileDrawer, classes$5.drawerActive),
      document.body.setAttribute("data-fluorescent-overlay-open", "false"),
      enableBodyScroll(this.mobileDrawer)),
      this._closeAll());
  },
  _hotspotClickHandler: function s(h) {
    var v = parseInt(h.currentTarget.parentNode.parentNode.dataset.index, 10);
    this._activateHotspot(v);
  },
  _clickOutsideHandler: function s(h) {
    h.target.closest(selectors$d.productCard) ||
      a$1(h.target, "shoppable-item__hotspot") ||
      this._closeAll();
  },
  _closeAll: function s() {
    (this.productCards.forEach(function (s) {
      (u$1(s, classes$5.hidden), s.setAttribute("aria-hidden", !0));
    }),
      this.hotspotContainers.forEach(function (s) {
        return i$1(s, classes$5.active);
      }),
      i$1(this.wash, classes$5.active));
  },
  onBlockDeselect: function s() {
    this._closeAll();
  },
  onBlockSelect: function s(h) {
    var v = parseInt(h.target.dataset.index, 10);
    this.swiper ? this.swiper.slideToLoop(v) : this._activateHotspot(v);
  },
  onUnload: function s() {
    var h, v, m, g;
    (null === (h = this.swiper) || void 0 === h || h.destroy(),
      null === (v = this.widthWatcher) || void 0 === v || v.destroy(),
      this.events.forEach(function (s) {
        return s();
      }),
      null === (m = this.animateShoppableImage) || void 0 === m || m.destroy(),
      null === (g = this.animateShoppableFeature) ||
        void 0 === g ||
        g.destroy(),
      this.pulseInterval && clearInterval(this.pulseInterval));
  },
});
var selectors$c = {
  video: "video",
  quickViewTrigger: "[data-quick-view-trigger]",
};
register("complete-the-look", {
  videoHandler: null,
  onLoad: function s() {
    (n$2(selectors$c.video, this.container) &&
      (this.videoHandler = backgroundVideoHandler(this.container)),
      (this.events = [
        e$2(
          t$2(selectors$c.quickViewTrigger, this.container),
          "click",
          function (s) {
            var h = s.target.dataset.productUrl;
            h &&
              r$1("quick-view:open", null, {
                productUrl: h,
              });
          },
        ),
      ]),
      shouldAnimate(this.container) &&
        (this.animateCompleteTheLook = animateCompleteTheLook(this.container)));
  },
  onUnload: function s() {
    var h;
    (this.videoHandler && this.videoHandler(),
      this.events.forEach(function (s) {
        return s();
      }),
      null === (h = this.animateCompleteTheLook) ||
        void 0 === h ||
        h.destroy());
  },
});
var selectors$b = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};
register("rich-text", {
  onLoad: function s() {
    var h = t$2(selectors$b.playButtonVideo, this.container);
    (h.length &&
      (this.playButtons = h.map(function (s) {
        return playButton(s.closest(selectors$b.playButtonBlock));
      })),
      shouldAnimate(this.container) &&
        (this.animateRichText = animateRichText(this.container)));
  },
  onUnload: function s() {
    var h;
    (this.playButtons &&
      this.playButtons.forEach(function (s) {
        return s.unload();
      }),
      null === (h = this.animateRichText) || void 0 === h || h.destroy());
  },
});
var selectors$a = {
  imageContainer: ".image-compare__image-container",
  labelContainer: ".image-compare__label-container",
  slider: ".image-compare__slider",
};
register("image-compare", {
  onLoad: function s() {
    ((this.events = []),
      this._initSliders(),
      shouldAnimate(this.container) &&
        (this.animateImageCompare = animateImageCompare(this.container)));
  },
  _initSliders: function s() {
    var h = this;
    ((this.imageContainer = n$2(selectors$a.imageContainer, this.container)),
      (this.labelContainers = t$2(selectors$a.labelContainer, this.container)),
      (this.slider = n$2(selectors$a.slider, this.container)),
      this.slider &&
        this.events.push(
          e$2(this.slider, "input", function (s) {
            return h.imageContainer.style.setProperty(
              "--position",
              "".concat(s.target.value, "%"),
            );
          }),
          e$2(this.slider, "mousedown", function () {
            return h.hideLabelContainers();
          }),
          e$2(this.slider, "touchstart", function () {
            return h.hideLabelContainers();
          }),
          e$2(this.slider, "mouseup", function () {
            return h.showLabelContainers();
          }),
          e$2(this.slider, "touchend", function () {
            return h.showLabelContainers();
          }),
        ));
  },
  hideLabelContainers: function s() {
    this.labelContainers.forEach(function (s) {
      s.style.setProperty("opacity", "0");
    });
  },
  showLabelContainers: function s() {
    this.labelContainers.forEach(function (s) {
      s.style.setProperty("opacity", "1");
    });
  },
  onUnload: function s() {
    var h;
    (this.events.forEach(function (s) {
      return s();
    }),
      null === (h = this.animateImageCompare) || void 0 === h || h.destroy());
  },
});
var selectors$9 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};
register("image-with-text", {
  onLoad: function s() {
    shouldAnimate(this.container) &&
      (this.animateImageWithText = animateImageWithText(this.container));
    var h = t$2(selectors$9.playButtonVideo, this.container);
    h.length &&
      (this.playButtons = h.map(function (s) {
        return playButton(s.closest(selectors$9.playButtonBlock));
      }));
  },
  onUnload: function s() {
    var h;
    (null === (h = this.animateImageWithText) || void 0 === h || h.destroy(),
      this.playButtons &&
        this.playButtons.forEach(function (s) {
          return s.unload();
        }));
  },
});
var selectors$8 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};
register("image-with-text-split", {
  onLoad: function s() {
    var h = t$2(selectors$8.playButtonVideo, this.container);
    (h.length &&
      (this.playButtons = h.map(function (s) {
        return playButton(s.closest(selectors$8.playButtonBlock));
      })),
      shouldAnimate(this.container) &&
        (this.animateImageWithTextSplit = animateImageWithTextSplit(
          this.container,
        )));
  },
  onUnload: function s() {
    var h;
    (this.playButtons &&
      this.playButtons.forEach(function (s) {
        return s.unload();
      }),
      null === (h = this.animateImageWithTextSplit) ||
        void 0 === h ||
        h.destroy());
  },
});
var selectors$7 = {
  playButtonVideo: "[data-play-button-block-video]",
  playButtonBlock: ".play-button-block",
};
(register("image-hero", {
  onLoad: function s() {
    var h = t$2(selectors$7.playButtonVideo, this.container);
    (h.length &&
      (this.playButtons = h.map(function (s) {
        return playButton(s.closest(selectors$7.playButtonBlock));
      })),
      shouldAnimate(this.container) &&
        (this.animateImageHero = animateImageHero(this.container)));
  },
  onUnload: function s() {
    var h;
    (this.playButtons &&
      this.playButtons.forEach(function (s) {
        return s.unload();
      }),
      null === (h = this.animateImageHero) || void 0 === h || h.destroy());
  },
}),
  register("image-hero-split", {
    onLoad: function s() {
      (shouldAnimate(this.container) &&
        t$2(".animation--item", this.container).forEach(function (s) {
          return animateImageHeroSplit(s);
        }),
        (this.observer = intersectionWatcher(this.container)));
    },
    onUnload: function s() {
      var h;
      (this.playButtons &&
        this.playButtons.forEach(function (s) {
          return s.unload();
        }),
        null === (h = this.observer) || void 0 === h || h.destroy());
    },
  }));
var selectors$6 = {
  item: ".testimonials__item",
  swiper: ".swiper",
  navigationNext: ".testimonials__navigation-button--next",
  navigationPrev: ".testimonials__navigation-button--prev",
  productImage: ".testimonials__item-product-image",
};
(register("testimonials", {
  onLoad: function s() {
    var h = this;
    ((this.events = []),
      (this.items = t$2(selectors$6.item, this.container)),
      (this.itemsContainer = n$2(selectors$6.swiper, this.container)),
      shouldAnimate(this.container) &&
        ((this.itemAnimations = this.items.map(function (s) {
          return animateTestimonials(s);
        })),
        (this.observer = intersectionWatcher(this.container))),
      this.items.length > 1
        ? import(flu.chunks.swiper).then(function (s) {
            var v,
              m = s.Swiper,
              g = s.Navigation,
              y = {
                modules: [g, s.EffectFade, s.Pagination],
                autoHeight: !0,
                slidesPerView: 1,
                effect: "fade",
                loop: !0,
                fadeEffect: {
                  crossFade: !0,
                },
                grabCursor: !0,
                navigation: {
                  nextEl: selectors$6.navigationNext,
                  prevEl: selectors$6.navigationPrev,
                },
                pagination: {
                  el: ".testimonials__swiper-pagination",
                  type: "bullets",
                  clickable: !0,
                },
                breakpoints: {
                  720: {
                    spaceBetween: 42,
                  },
                },
                on: {
                  slideChangeTransitionEnd: function s() {
                    var h = this.slides;
                    setTimeout(function () {
                      h.forEach(function (s) {
                        s.toggleAttribute(
                          "inert",
                          !s.classList.contains("swiper-slide-active"),
                        );
                      });
                    }, 50);
                  },
                },
              };
            (window.matchMedia(getMediaQuery("below-720")).matches &&
              ((y.effect = "slide"), (y.slidesPerView = "auto")),
              (h.carousel = new m(h.itemsContainer, y)),
              h.setMobileButtonOffset(),
              r$1("testimonials:initialized"));
          })
        : 1 === this.items.length &&
          u$1(this.items[0], "swiper-slide-visible"));
  },
  setMobileButtonOffset: function s() {
    var h,
      v = n$2(selectors$6.productImage, this.container).offsetHeight / 2;
    this.container.style.setProperty(
      "--mobile-button-offset",
      "".concat(v + 17, "px"),
    );
  },
  handleBlockSelect: function s(h) {
    this.carousel.slideToLoop(parseInt(h, 10));
  },
  onBlockSelect: function s(h) {
    var v = this,
      m = h.target.dataset.index;
    this.carousel
      ? this.handleBlockSelect(m)
      : this.events.push(
          c("testimonials:initialized", function () {
            v.handleBlockSelect(m);
          }),
        );
  },
  onUnload: function s() {
    var h;
    (this.events.forEach(function (s) {
      return s();
    }),
      null === (h = this.observer) || void 0 === h || h.destroy());
  },
}),
  register("sales-banner", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateSalesBanner = animateSalesBanner(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateSalesBanner) || void 0 === h || h.destroy();
    },
  }),
  register("promotion-bar", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animatePromotionBar = animatePromotionBar(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animatePromotionBar) || void 0 === h || h.destroy();
    },
  }),
  register("grid", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateGrid = animateGrid(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateGrid) || void 0 === h || h.destroy();
    },
  }),
  register("collection-list-grid", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateCollectionListGrid = animateCollectionListGrid(
          this.container,
        ));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateCollectionListGrid) ||
        void 0 === h ||
        h.destroy();
    },
  }),
  register("contact-form", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateContactForm = animateContactForm(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateContactForm) || void 0 === h || h.destroy();
    },
  }),
  register("multi-column", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateMultiColumn = animateMultiColumn(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateMultiColumn) || void 0 === h || h.destroy();
    },
  }));
var selectors$5 = {
    listContainer: "[data-events-eventbrite-container]",
    skeletonList: ".events__list--skeleton",
  },
  endpoints = {
    org: function s(h) {
      return "https://www.eventbriteapi.com//v3/users/me/organizations/?token=".concat(
        h,
      );
    },
    events: function s(h, v) {
      return "https://www.eventbriteapi.com//v3/organizations/"
        .concat(h, "/events/?token=")
        .concat(v, "&expand=venue&status=live");
    },
  };
(register("events", {
  onLoad: function s() {
    ((this.accessToken = this.container.dataset.accessToken),
      (this.eventCount = parseInt(this.container.dataset.eventCount, 10)),
      (this.imageAspectRatio = this.container.dataset.imageAspectRatio),
      (this.learnMoreText = this.container.dataset.learnMoreText),
      this._fetchOrg(),
      shouldAnimate(this.container) &&
        ((this.animateEvents = animateEvents(this.container)),
        this.accessToken || this.animateEvents.animateEventItems()));
  },
  _fetchOrg: function s() {
    var h = this;
    this.accessToken &&
      fetch(endpoints.org(this.accessToken))
        .then(function (s) {
          return s.json();
        })
        .then(function (s) {
          h._fetchEvents(s.organizations[0].id);
        });
  },
  _fetchEvents: function s(h) {
    var v = this;
    h &&
      fetch(endpoints.events(h, this.accessToken))
        .then(function (s) {
          return s.json();
        })
        .then(function (s) {
          v._renderEvents(s.events);
        });
  },
  _renderEvents: function s(h) {
    var v = this,
      m = n$2(selectors$5.listContainer, this.container),
      g = n$2(selectors$5.skeletonList, this.container),
      y = document.createElement("ul");
    ((y.className = "events__list"),
      h.slice(0, this.eventCount).forEach(function (s) {
        y.innerHTML += v._renderEventItem(s);
      }),
      u$1(g, "hide"),
      setTimeout(function () {
        ((m.textContent = ""),
          m.appendChild(y),
          shouldAnimate(v.container) && v.animateEvents.animateEventItems());
      }, 300));
  },
  _renderEventItem: function s(h) {
    var v;
    return '\n      <li\n        class="\n          event-item\n          event-item--eventbrite\n          '
      .concat(
        null !== (v = h.logo) && void 0 !== v && v.url
          ? "event-item--has-image"
          : "",
        '\n        "\n      >\n        <a href="',
      )
      .concat(
        h.url,
        '" class="event-item__link">\n          <div class="event-item__image-wrapper">\n            ',
      )
      .concat(this._renderImage(h), "\n            ")
      .concat(
        this._renderDateBadge(h),
        '\n          </div>\n          <div class="event-item__details">\n            ',
      )
      .concat(this._renderName(h), "\n            ")
      .concat(this._renderDate(h), "\n            ")
      .concat(this._renderVenue(h), "\n            ")
      .concat(
        this._renderSummary(h),
        '\n            <span class="btn btn--callout event-item__callout">\n              <span>',
      )
      .concat(
        this.learnMoreText,
        "</span>\n            </span>\n          </div>\n        </a>\n      </li>\n    ",
      );
  },
  _renderImage: function s(h) {
    var v,
      m = "";
    return (
      null !== (v = h.logo) &&
        void 0 !== v &&
        v.url &&
        (m = '\n        <div class="image '
          .concat(
            this.imageAspectRatio,
            ' event-item__image image--animate animation--lazy-load">\n          <img\n            src="',
          )
          .concat(h.logo.url, '"\n            alt="')
          .concat(
            h.name.text,
            '"\n            loading="lazy"\n            class="image__img"\n            onload="javascript: this.closest(\'.image\').classList.add(\'loaded\')"\n          >\n        </div>\n      ',
          )),
      m
    );
  },
  _renderDateBadge: function s(h) {
    var v,
      m = "";
    if (null !== (v = h.start) && void 0 !== v && v.local) {
      var g = new Date(h.start.local);
      m =
        '\n        <span class="event-item__date-badge">\n          <span class="event-item__date-badge-day fs-body-bold fs-body-200">\n            '
          .concat(
            new Intl.DateTimeFormat([], {
              day: "numeric",
            }).format(g),
            '\n          </span>\n          <span class="event-item__date-badge-month fs-accent">\n            ',
          )
          .concat(
            new Intl.DateTimeFormat([], {
              month: "short",
            }).format(g),
            "\n          </span>\n        </span>\n      ",
          );
    }
    return m;
  },
  _renderName: function s(h) {
    var v,
      m = "";
    return (
      null !== (v = h.name) &&
        void 0 !== v &&
        v.text &&
        (m =
          '\n        <h4 class="event-item__name ff-heading fs-heading-5-base">\n          '.concat(
            h.name.text,
            "\n        </h4>\n      ",
          )),
      m
    );
  },
  _renderDate: function s(h) {
    var v,
      m = "";
    if (null !== (v = h.start) && void 0 !== v && v.local) {
      var g = new Date(h.start.local);
      m = '\n        <p class="event-item__date fs-body-75">\n          '
        .concat(
          g.toLocaleDateString([], {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
          }),
          "\n          ",
        )
        .concat(
          g.toLocaleTimeString([], {
            timeZone: h.start.timezone,
            hour: "numeric",
            minute: "2-digit",
          }),
          "\n        </p>\n      ",
        );
    }
    return m;
  },
  _renderVenue: function s(h) {
    var v,
      m = "";
    return (
      null !== (v = h.venue) &&
        void 0 !== v &&
        v.name &&
        (m =
          '\n        <p class="event-item__venue fs-body-75">\n          '.concat(
            h.venue.name,
            "\n        </p>\n      ",
          )),
      m
    );
  },
  _renderSummary: function s(h) {
    var v = "";
    return (
      h.summary &&
        (v = '\n        <p class="event-item__summary">\n          '.concat(
          h.summary,
          "\n        </p>\n      ",
        )),
      v
    );
  },
  onUnload: function s() {
    var h;
    null === (h = this.animateEvents) || void 0 === h || h.destroy();
  },
}),
  register("promo-banner", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animatePromoBanner = animatePromoBanner(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animatePromoBanner) || void 0 === h || h.destroy();
    },
  }));
var selectors$4 = {
  tabLabels: "[data-tab-label]",
  tabItems: "[data-tab-item]",
  tabList: "[data-tab-list]",
  activeTabItem: "[data-tab-item][aria-hidden='false']",
};
(register("product-tabs", {
  onLoad: function s() {
    var h = this;
    ((this.accordions = []),
      (this.tabItems = t$2(selectors$4.tabItems, this.container)),
      (this.tabLabels = t$2(selectors$4.tabLabels, this.container)),
      (this.tabList = n$2(selectors$4.tabList, this.container)),
      (this.activeTabItem = n$2(selectors$4.activeTabItem, this.container)),
      this.activeTabItem && this._setTabHeight(this.activeTabItem),
      (this.clickHandlers = e$2(this.tabLabels, "click", function (s) {
        s.preventDefault();
        var v = s.currentTarget.getAttribute("aria-controls"),
          m = n$2("#".concat(v), h.container);
        (h._closeAll(), h._open(s.currentTarget, m));
      })),
      t$2(".accordion", this.container).forEach(function (s) {
        var v = s.classList.contains("accordion--open");
        (h.accordions.push(
          Accordions(s, {
            firstOpen: v,
          }),
        ),
          s.classList.add("rte--product", "accordion--product"));
      }),
      shouldAnimate(this.container) &&
        (this.animateProductTabs = animateProductTabs(this.container)));
  },
  _closeAll: function s() {
    var h = this;
    this.tabLabels.forEach(function (s) {
      var v = s.getAttribute("aria-controls"),
        m = n$2("#".concat(v), h.container);
      h._isVisible(m) && h._close(s, m);
    });
  },
  _open: function s(h, v) {
    (h.setAttribute("aria-expanded", !0),
      v.setAttribute("aria-hidden", !1),
      this._setTabHeight(v));
  },
  _close: function s(h, v) {
    (h.setAttribute("aria-expanded", !1), v.setAttribute("aria-hidden", !0));
  },
  _isVisible: function s(h) {
    return "false" === h.getAttribute("aria-hidden");
  },
  _setTabHeight: function s(h) {
    var v = h.offsetHeight;
    this.tabList.style.height = "".concat(v, "px");
  },
  onBlockSelect: function s(h) {
    var v = h.target,
      m = v.getAttribute("aria-controls"),
      g = n$2("#".concat(m), this.container);
    (this._closeAll(), this._open(v, g));
  },
  onUnload: function s() {
    var h;
    (this.clickHandlers(),
      this.accordions.forEach(function (s) {
        return s.unload();
      }),
      null === (h = this.animateProductTabs) || void 0 === h || h.destroy());
  },
}),
  register("apps", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateApps = animateApps(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateApps) || void 0 === h || h.destroy();
    },
  }));
var selectors$3 = {
    cartError: ".cart__form-item-error",
    cartNoteTrigger: "[data-order-note-trigger]",
    cartUpdateButton: ".cart__update",
    quantityInput: ".cart .quantity-input__input",
    quantityItem: "[data-input-item]",
    freeShippingBar: "[data-free-shipping-bar]",
    freeGiftBar: "[data-free-gift-bar]",
    crossSells: "[data-cross-sells]",
  },
  classes$4 = {
    updatingQuantity: "has-quantity-update",
    removed: "is-removed",
  };

function Ajaxinate(s) {
  ((this.settings = Object.assign(
    {
      method: "click",
      container: "#AjaxinateContainer",
      pagination: "#AjaxinatePagination",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    },
    s || {},
  )),
    (this.addScrollListeners = this.addScrollListeners.bind(this)),
    (this.addClickListener = this.addClickListener.bind(this)),
    (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
    (this.preventMultipleClicks = this.preventMultipleClicks.bind(this)),
    (this.removeClickListener = this.removeClickListener.bind(this)),
    (this.removeScrollListener = this.removeScrollListener.bind(this)),
    (this.removePaginationElement = this.removePaginationElement.bind(this)),
    (this.destroy = this.destroy.bind(this)),
    (this.containerElement = document.querySelector(this.settings.container)),
    (this.paginationElement = document.querySelector(this.settings.pagination)),
    this.initialize(),
    this.tiggerLoadData());
}
(register("cart", {
  onLoad: function s() {
    var h = this,
      v = n$2(selectors$3.cartNoteTrigger, this.container),
      m = n$2(selectors$3.freeShippingBar, this.container),
      g = n$2(selectors$3.freeGiftBar, this.container);
    ((m || g) && freeShippingBar(m, g),
      this._initCrossSells(),
      v && (this.cartNoteToggle = CartNoteToggle(this.container)),
      (this.quantityButtons = QuantityButtons(this.container)),
      (this.events = [
        c("cart:updated", function () {
          return h.refreshCart();
        }),
        c("cart:error", function (s, v) {
          var m = v.key,
            g = v.errorMessage;
          h.handleErrorMessage(m, g);
        }),
        c(["quantity-update:subtract", "quantity-update:add"], function (s, v) {
          var m = v.key;
          h.handleQuantityUpdate(m);
        }),
        c("quantity-update:remove", function (s, v) {
          var m = v.key;
          h.handleItemRemoval(m);
        }),
      ]),
      (this.delegate = new Delegate(this.container)),
      this.delegate.on("change", selectors$3.quantityInput, function (s) {
        return h.handleQuantityInputChange(s);
      }));
  },
  refreshCart: function s() {
    var h = this;
    makeRequest(
      "GET",
      "".concat(theme.routes.cart.base, "?section_id=main-cart"),
    ).then(function (s) {
      var v,
        m = document.createElement("div");
      ((m.innerHTML = s),
        (h.container.innerHTML = m.innerHTML),
        null !== (v = window.Shopify) &&
          void 0 !== v &&
          v.StorefrontExpressButtons &&
          window.Shopify.StorefrontExpressButtons.initialize());
      var g = n$2(selectors$3.freeShippingBar, h.container),
        y = n$2(selectors$3.freeGiftBar, h.container);
      ((g || y) && freeShippingBar(g, y), h._initCrossSells());
    });
  },
  handleErrorMessage: function s(h) {
    var v = n$2('[data-key="'.concat(h, '"]'), this.container);
    (i$1(n$2(selectors$3.cartError, v), "hidden"),
      i$1(v, classes$4.updatingQuantity));
  },
  handleQuantityInputChange: function s(h) {
    var v = h.target,
      m = v.closest(selectors$3.quantityItem).dataset.key;
    (cart.updateItem(m, v.value), this.handleQuantityUpdate(m));
  },
  handleQuantityUpdate: function s(h) {
    var v = n$2('[data-key="'.concat(h, '"]'), this.container);
    u$1(v, classes$4.updatingQuantity);
  },
  handleItemRemoval: function s(h) {
    var v = n$2('[data-key="'.concat(h, '"]'), this.container);
    (u$1(v, classes$4.removed), u$1(v, classes$4.updatingQuantity));
  },
  _initCrossSells: function s() {
    var h = n$2(selectors$3.crossSells, this.container);
    h && (this.crossSells = CrossSells(h));
  },
  onUnload: function s() {
    var h;
    (this.events.forEach(function (s) {
      return s();
    }),
      this.quantityButtons.unload(),
      null === (h = this.cartNoteToggle) || void 0 === h || h.unload());
  },
}),
  register("product", {
    onLoad: function s() {
      ((this.product = new Product(this.container)),
        (this.animateProduct = animateProduct(this.container)));
    },
    onBlockSelect: function s(h) {
      var v = h.target,
        m = n$2(".accordion__label", v);
      if (
        (v.scrollIntoView({
          block: "center",
          behavior: "smooth",
        }),
        m)
      ) {
        var g = m.parentNode,
          y = m.nextElementSibling;
        (slideStop(y),
          slideDown(y),
          g.setAttribute("data-open", !0),
          m.setAttribute("aria-expanded", !0),
          y.setAttribute("aria-hidden", !1));
      }
    },
    onBlockDeselect: function s(h) {
      var v = n$2(".accordion__label", h.target);
      if (v) {
        var m = v.parentNode,
          g = v.nextElementSibling;
        (slideStop(g),
          slideUp(g),
          m.setAttribute("data-open", !1),
          v.setAttribute("aria-expanded", !1),
          g.setAttribute("aria-hidden", !0));
      }
    },
    onUnload: function s() {
      var h;
      (this.product.unload(),
        null === (h = this.animateProduct) || void 0 === h || h.destroy());
    },
  }),
  (Ajaxinate.prototype.initialize = function s() {
    if (!this.containerElement) return;
    let h = {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    };
    h[this.settings.method]();
  }),
  (Ajaxinate.prototype.tiggerLoadData = function s() {
    if (
      window.location.pathname.includes("search") &&
      null !== localStorage.getItem("searchData")
    ) {
      this.nextPageUrl = this.nextPageLinkElement.href;
      let h =
        JSON.parse(localStorage.getItem("searchData")).pagesLoadedOnSearchPage -
        1;
      ((this.pagesToAutoload = h), this.loadMore());
    }
  }),
  (Ajaxinate.prototype.addScrollListeners = function s() {
    this.paginationElement &&
      (document.addEventListener("scroll", this.checkIfPaginationInView),
      window.addEventListener("resize", this.checkIfPaginationInView),
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView,
      ));
  }),
  (Ajaxinate.prototype.addClickListener = function s() {
    this.paginationElement &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      this.nextPageLinkElement &&
        this.nextPageLinkElement.hasAttribute(
          "data-collection-has-promo-teaser",
        ) &&
        (this.collectionHasPromoTeaser = !0),
      (this.clickActive = !0),
      void 0 !== this.nextPageLinkElement &&
        null !== this.nextPageLinkElement &&
        this.nextPageLinkElement.addEventListener(
          "click",
          this.preventMultipleClicks,
        ));
  }),
  (Ajaxinate.prototype.preventMultipleClicks = function s(h) {
    (h.stopPropagation(),
      h.preventDefault(),
      this.clickActive &&
        ((this.nextPageLinkTextElement =
          this.nextPageLinkElement.querySelector(".btn--text")),
        (this.nextPageLinkTextElement.textContent = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        (this.clickActive = !1),
        setTimeout(() => {
          this.loadMore();
        }, 100)));
  }),
  (Ajaxinate.prototype.checkIfPaginationInView = function s() {
    let h =
        this.paginationElement.getBoundingClientRect().top -
        this.settings.offset,
      v =
        this.paginationElement.getBoundingClientRect().bottom +
        this.settings.offset;
    h <= window.innerHeight &&
      v >= 0 &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      this.removeScrollListener(),
      this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerText = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()));
  }),
  (Ajaxinate.prototype.loadMore = function s() {
    let h = (s) => {
        s.forEach((s, h) => {
          s.classList.contains("hidden") && s.classList.remove("hidden");
        });
      },
      v = (s) => {
        let v = this.containerElement.querySelectorAll(".product-item"),
          m = 0;
        ((m = s % 2 == 0 ? v.length : v.length + 2),
          this.nextPageLinkElement && !0 === this.collectionHasPromoTeaser
            ? m % 4 != 0
              ? v.forEach((s, h) => {
                  h === v.length - 1 || h === v.length - 2
                    ? s.classList.add("hidden")
                    : (h !== v.length - 1 || h !== v.length - 2) &&
                      s.classList.contains("hidden") &&
                      s.classList.remove("hidden");
                })
              : h(v)
            : this.nextPageLinkElement || h(v));
      },
      m = () => {
        if (window.location.pathname.includes("search")) {
          let s = document
              .querySelector("[data-current-page]")
              ?.getAttribute("data-current-page"),
            h = document.querySelectorAll(".product-item"),
            v = {
              isComeFromSearchPage: !0,
              pagesLoadedOnSearchPage: s || 1,
            };
          h.length > 0 &&
            v.pagesLoadedOnSearchPage > 1 &&
            h.forEach((s) => {
              s.addEventListener("click", (s) => {
                "A" === s.target.nodeName &&
                  localStorage.setItem("searchData", JSON.stringify(v));
              });
            });
        }
      };
    ((this.request = new XMLHttpRequest()),
      (this.request.onreadystatechange = function s() {
        if (4 === this.request.readyState && 200 === this.request.status) {
          var h = new DOMParser().parseFromString(
              this.request.responseText,
              "text/html",
            ),
            g = h.querySelectorAll(this.settings.container)[0],
            y = g.querySelectorAll(".columns-teaser__wrapper"),
            b = y.length;
          y.forEach((s) => {
            s && s.remove();
          });
          var _ = h.querySelectorAll(this.settings.pagination)[0];
          (this.containerElement.insertAdjacentHTML("beforeend", g.innerHTML),
            (this.paginationElement.innerHTML = _.innerHTML),
            this.settings.callback &&
              "function" == typeof this.settings.callback &&
              this.settings.callback(this.request.responseXML),
            this.initialize(),
            v(b),
            m());
        }
      }.bind(this)),
      this.request.open("GET", this.nextPageUrl, !1),
      this.request.send(),
      this.pagesToAutoload &&
        this.pagesToAutoload > 1 &&
        ((this.pagesToAutoload = this.pagesToAutoload - 1),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()));
  }),
  (Ajaxinate.prototype.removeClickListener = function s() {
    this.nextPageLinkElement.removeEventListener(
      "click",
      this.preventMultipleClicks,
    );
  }),
  (Ajaxinate.prototype.removePaginationElement = function s() {
    ((this.paginationElement.innerHTML = ""), this.destroy());
  }),
  (Ajaxinate.prototype.removeScrollListener = function s() {
    (document.removeEventListener("scroll", this.checkIfPaginationInView),
      window.removeEventListener("resize", this.checkIfPaginationInView),
      window.removeEventListener(
        "orientationchange",
        this.checkIfPaginationInView,
      ));
  }),
  (Ajaxinate.prototype.destroy = function s() {
    let h = {
      click: this.removeClickListener,
      scroll: this.removeScrollListener,
    };
    return (h[this.settings.method](), this);
  }));
var filtering = function s(h) {
    var v,
      m,
      g = t$2("[data-filter-form]", h);

    function y(s) {
      ((s = s || g[0]),
        (v = new FormData(s)),
        (m = new URLSearchParams(v).toString()));
    }
    return (
      y(),
      {
        getState: function s() {
          return {
            url: m,
          };
        },
        filtersUpdated: function s(h, v) {
          var m;
          return (
            (m = h) &&
              t$2("[data-filter-item-input]", m).forEach(function (s) {
                if ("checkbox" === s.type || "radio" === s.type) {
                  var h = s.dataset.valueEscaped;
                  t$2(
                    "input[name='"
                      .concat(s.name, "'][data-value-escaped='")
                      .concat(h, "']"),
                  ).forEach(function (h) {
                    h.checked = s.checked;
                  });
                } else
                  t$2("input[name='".concat(s.name, "']")).forEach(
                    function (h) {
                      h.value = s.value;
                    },
                  );
              }),
            y(h),
            r$1("filters:updated"),
            v(this.getState())
          );
        },
        removeFilters: function s(v, m) {
          return (
            (function s(v) {
              if (v) {
                var m;
                (v.forEach(function (s) {
                  m = m ? ", ".concat(m) : "";
                  var h = s.dataset,
                    v = h.name,
                    g = h.valueEscaped;
                  m = "input[name='"
                    .concat(v, "'][data-value-escaped='")
                    .concat(g, "']")
                    .concat(m);
                }),
                  t$2(m, h).forEach(function (s) {
                    s.checked = !1;
                  }));
              }
            })(v),
            y(),
            r$1("filters:filter-removed"),
            m(this.getState())
          );
        },
        removeRange: function s(v) {
          return (
            t$2("[data-range-input]", h).forEach(function (s) {
              s.value = "";
            }),
            y(),
            v(this.getState())
          );
        },
        clearAll: function s(h) {
          return (
            (m = ""),
            g.forEach(function (s) {
              s.reset();
            }),
            h(this.getState())
          );
        },
      }
    );
  },
  FILTERS_REMOVE = "collection:filters:remove",
  RANGE_REMOVE = "collection:range:remove",
  EVERYTHING_CLEAR = "collection:clear",
  FILTERS_UPDATE = "collection:filters:update",
  updateFilters = function s(h) {
    return r$1(FILTERS_UPDATE, null, {
      target: h,
    });
  },
  removeFilters = function s(h) {
    return r$1(FILTERS_REMOVE, null, {
      target: h,
    });
  },
  filtersUpdated = function s(h) {
    return c(FILTERS_UPDATE, h);
  },
  filtersRemoved = function s(h) {
    return c(FILTERS_REMOVE, h);
  },
  everythingCleared = function s(h) {
    return c(EVERYTHING_CLEAR, h);
  },
  rangeRemoved = function s(h) {
    return c(RANGE_REMOVE, h);
  },
  filterHandler = function s(h) {
    var v = h.container,
      m = h.renderCB,
      g = null,
      y = null,
      b = null;

    function _() {
      var s = new URL(window.location).search.replace("?", "");
      (m(s, !1),
        o$1({
          url: s,
        }));
    }
    return (
      (y = filtering(v)),
      o$1(y.getState()),
      (g = [
        filtersRemoved(function (s, h) {
          var v = h.target;
          y.removeFilters(v, function (s) {
            (m(s.url), o$1(s)());
          });
        }),
        rangeRemoved(function () {
          y.removeRange(function (s) {
            (m(s.url), o$1(s)());
          });
        }),
        filtersUpdated(function (s, h) {
          var v = h.target;
          y.filtersUpdated(v, function (s) {
            (m(s.url), o$1(s)());
          });
        }),
        everythingCleared(function () {
          y.clearAll(function (s) {
            (m(s.url), o$1(s)());
          });
        }),
      ]),
      (b = new Delegate(v)).on("click", "[data-remove-filter]", function (s) {
        (s.preventDefault(), removeFilters([s.target]));
      }),
      window.addEventListener("popstate", _),
      {
        unload: function s() {
          (b && b.off(),
            g &&
              g.forEach(function (s) {
                return s();
              }),
            window.removeEventListener("popstate", _));
        },
      }
    );
  },
  strings$2 = window.theme.strings,
  priceRange = function s(h) {
    var v = t$2("input", h),
      m = v[0],
      g = v[1],
      y = [
        e$2(v, "change", function s(h) {
          var v, y, _, $;
          if (
            ((y = Number((v = h.currentTarget).value)),
            (_ = Number(v.getAttribute("min"))),
            ($ = Number(v.getAttribute("max"))),
            y < _ && (v.value = _),
            y > $ && (v.value = $),
            k(),
            "" !== m.value || "" !== g.value)
          ) {
            var S,
              E,
              T = _slicedToArray(b.noUiSlider.get(), 2);
            ((E = T[0]),
              (S = T[1]),
              (E = Math.floor(E)),
              (S = Math.floor(S)),
              E !== Math.floor(m.value) && b.noUiSlider.set([m.value, null]),
              S !== Math.floor(g.value) && b.noUiSlider.set([null, g.value]));
          }
        }),
      ],
      b = n$2("[data-range-slider]", h),
      _ = Math.floor(m.value ? m.value : m.getAttribute("min")),
      $ = Math.floor(g.value ? g.value : g.getAttribute("max"));

    function k() {
      (g.value && m.setAttribute("max", g.value),
        m.value && g.setAttribute("min", m.value),
        "" === m.value && g.setAttribute("min", 0),
        "" === g.value && m.setAttribute("max", g.getAttribute("max")));
    }
    return (
      import(flu.chunks.nouislider).then(function (s) {
        (s.noUiSlider.create(b, {
          start: [
            m.value ? m.value : m.getAttribute("min"),
            g.value ? g.value : g.getAttribute("max"),
          ],
          handleAttributes: [
            {
              "aria-label": strings$2.accessibility.range_lower,
            },
            {
              "aria-label": strings$2.accessibility.range_upper,
            },
          ],
          connect: !0,
          range: {
            min: parseInt(m.getAttribute("min")),
            max: parseInt(g.getAttribute("max")),
          },
        }),
          b.noUiSlider.on("slide", function (s) {
            var h,
              v,
              y = _slicedToArray(s, 2);
            ((v = y[0]),
              (h = y[1]),
              (m.value = Math.floor(v)),
              (g.value = Math.floor(h)),
              k());
          }),
          b.noUiSlider.on("set", function (s) {
            var h, v;
            ((v = Math.floor(s[0])),
              (h = Math.floor(s[1])),
              v != _ &&
                ((m.value = v),
                m.dispatchEvent(
                  new Event("change", {
                    bubbles: !0,
                  }),
                ),
                (_ = Math.floor(m.value ? m.value : m.getAttribute("min")))),
              h != $ &&
                ((g.value = h),
                g.dispatchEvent(
                  new Event("change", {
                    bubbles: !0,
                  }),
                ),
                ($ = Math.floor(g.value ? g.value : g.getAttribute("max")))),
              k());
          }),
          k());
      }),
      {
        unload: function s() {
          (y.forEach(function (s) {
            return s();
          }),
            b.noUiSlider.destroy());
        },
        reset: function s() {
          (b.noUiSlider.set([m.getAttribute("min"), g.getAttribute("max")], !1),
            (m.value = ""),
            (g.value = ""),
            (_ = Math.floor(m.getAttribute("min"))),
            ($ = Math.floor(g.getAttribute("max"))),
            k());
        },
        validateRange: function s() {
          v.forEach(function (s) {
            return k();
          });
        },
      }
    );
  };

function replaceElement(s, h) {
  var v = n$2(s, h),
    m = n$2(s);
  v && m && m.parentElement.replaceChild(v, m);
}
var sel$1 = {
    drawer: "[data-filter-drawer]",
    drawerTitle: "[data-filter-drawer-title]",
    filter: "[data-filter]",
    filterItem: "[data-filter-item]",
    filterTarget: "[data-filter-drawer-target]",
    flyouts: "[data-filter-modal]",
    button: "[data-button]",
    wash: "[data-drawer-wash]",
    sort: "[data-sort]",
    close: "[data-close-icon]",
    group: ".filter-drawer__group",
    groupToggle: "[data-drawer-group-toggle]",
    panel: ".filter-drawer__panel",
    flyoutWrapper: "[data-filer-modal-wrapper]",
    priceRange: "[data-price-range]",
    resultsCount: "[data-results-count]",
    activeFilters: "[data-active-filters]",
    activeFilterCount: "[data-active-filter-count]",
  },
  classes$3 = {
    active: "active",
    activeFilters: "filters-active",
    fixed: "is-fixed",
    filterDisabled: "filter-item__content--disabled",
  },
  filterDrawer = function s(h) {
    if (!h) return !1;
    var v = n$2(sel$1.drawer, h);
    if (!v) return !1;
    var m = t$2(sel$1.flyouts, v),
      g = n$2(sel$1.wash, v),
      y = t$2("[data-range-input]", v),
      b = null,
      _ = null,
      $ = null;
    shouldAnimate(h) && ($ = animateFilterDrawer(v));
    var k = n$2(sel$1.priceRange, v);
    k && (_ = priceRange(k));
    var S = [
      e$2(t$2(sel$1.filterTarget, h), "click", function s(m) {
        m.preventDefault();
        var g = m.currentTarget.dataset.filterDrawerTarget,
          y = n$2('[data-filter-modal="'.concat(g, '"]'), v);
        ((b = createFocusTrap(y, {
          allowOutsideClick: !0,
        })),
          u$1(v, classes$3.fixed),
          setTimeout(function () {
            (shouldAnimate(h) && $.open(y),
              u$1(v, classes$3.active),
              u$1(y, classes$3.active));
          }, 0),
          y.setAttribute("aria-hidden", "false"),
          b.activate(),
          document.body.setAttribute("data-fluorescent-overlay-open", "true"),
          disableBodyScroll(h, {
            allowTouchMove: function s(h) {
              for (; h && h !== document.body; ) {
                if (null !== h.getAttribute("data-scroll-lock-ignore"))
                  return !0;
                h = h.parentNode;
              }
            },
            reserveScrollBarGap: !0,
          }));
      }),
      e$2(v, "change", function s(h) {
        var m, g;
        h.target.classList.contains("filter-item__checkbox")
          ? ((m = h.target),
            !m.classList.contains(classes$3.filterDisabled) &&
              (I(m),
              _ && _.validateRange(),
              debounce(function () {
                return updateFilters(v);
              }, 1e3)()))
          : h.target.classList.contains("filter-item__radio") &&
            ((g = h), I(g.target), _ && _.validateRange(), updateFilters(v));
      }),
      e$2(g, "click", E),
      e$2(
        t$2("".concat(sel$1.button, ", ").concat(sel$1.clearAll), v),
        "click",
        function s(h) {
          h.preventDefault();
          var m = h.currentTarget.dataset.button,
            g = h.currentTarget.closest(sel$1.flyouts),
            y = g.dataset.filterModal;
          if (("close" === m && E(), "__sort" === y))
            "clear-all" === m &&
              (t$2(
                '[data-filter-modal="__sort"] '.concat(sel$1.sort),
                v,
              ).forEach(function (s) {
                n$2("input", s).checked = !1;
              }),
              i$1(
                h.currentTarget.closest(sel$1.panel),
                classes$3.activeFilters,
              ));
          else {
            if ("clear-all" === m) {
              t$2("input", g).forEach(function (s) {
                s.checked = !1;
              });
              var b = h.currentTarget.closest(sel$1.panel);
              (i$1(
                [].concat(_toConsumableArray$1(t$2(sel$1.group, b)), [b]),
                classes$3.activeFilters,
              ),
                _ && _.reset(),
                updateFilters(v));
            }
            if ("group_toggle" === m) {
              var $,
                k,
                S,
                T,
                C = n$2(
                  "#".concat(h.currentTarget.getAttribute("aria-controls")),
                ),
                I = "true" === h.currentTarget.getAttribute("aria-expanded");
              (slideStop(C),
                I
                  ? (($ = h.currentTarget),
                    (k = C),
                    slideUp(k),
                    $.setAttribute("aria-expanded", !1),
                    k.setAttribute("aria-hidden", !0))
                  : ((S = h.currentTarget),
                    (T = C),
                    slideDown(T),
                    S.setAttribute("aria-expanded", !0),
                    T.setAttribute("aria-hidden", !1)));
            }
          }
        },
      ),
      e$2(t$2(sel$1.close, v), "click", E),
      e$2(v, "keydown", function (s) {
        27 === s.keyCode && E();
      }),
      e$2(y, "change", function s(h) {
        I(h.currentTarget);
        var m = h.target.closest(sel$1.group);
        (m && l(m, classes$3.activeFilters, C()), updateFilters(v));
      }),
      c("filters:filter-removed", function () {
        t$2(sel$1.panel, v).forEach(function (s) {
          var h = !1,
            v = n$2("[data-range-input]", s);
          (T(t$2("input", s)) && (h = !0),
            v && C() && (h = !0),
            l(s, classes$3.activeFilters, h));
        });
      }),
    ];

    function E(s) {
      (s && s.preventDefault(),
        b && b.deactivate(),
        i$1(m, classes$3.active),
        i$1(v, classes$3.active),
        m.forEach(function (s) {
          return s.setAttribute("aria-hidden", "true");
        }),
        document.body.setAttribute("data-fluorescent-overlay-open", "false"),
        enableBodyScroll(h),
        setTimeout(function () {
          (i$1(v, classes$3.fixed), shouldAnimate(h) && $.close(m));
        }, 500));
    }

    function T(s) {
      return s.some(function (s) {
        return s.checked;
      });
    }

    function C() {
      return y.some(function (s) {
        return "" !== s.value;
      });
    }

    function I(s) {
      var h = s.closest(sel$1.panel);
      if (h) {
        var v = T(t$2("input", h)) || C();
        l(h, classes$3.activeFilters, v);
      }
    }
    return {
      renderFilters: function s(h) {
        (t$2("".concat(sel$1.drawer, " ").concat(sel$1.filterItem), h).forEach(
          function (s) {
            (replaceElement(
              ""
                .concat(sel$1.drawer, " ")
                .concat(sel$1.filterItem, '[for="')
                .concat(s.getAttribute("for"), '"] .filter-item__checkbox'),
              h,
            ),
              replaceElement(
                ""
                  .concat(sel$1.drawer, " ")
                  .concat(sel$1.filterItem, '[for="')
                  .concat(s.getAttribute("for"), '"] .filter-item__count'),
                h,
              ));
          },
        ),
          t$2(
            "".concat(sel$1.drawer, " ").concat(sel$1.groupToggle),
            h,
          ).forEach(function (s) {
            updateInnerHTML(
              ""
                .concat(sel$1.drawer, ' [data-drawer-group-toggle="')
                .concat(s.getAttribute("data-drawer-group-toggle"), '"]'),
              h,
            );
          }),
          updateInnerHTML(
            "".concat(sel$1.drawer, " ").concat(sel$1.resultsCount),
            h,
          ),
          updateInnerHTML(
            "".concat(sel$1.drawer, " ").concat(sel$1.activeFilters),
            h,
          ),
          updateInnerHTML(
            "".concat(sel$1.drawer, " ").concat(sel$1.drawerTitle),
            h,
          ),
          updateInnerHTML(
            "[data-mobile-filters] [data-mobile-filters-toggle]",
            h,
          ));
      },
      unload: function s() {
        (S.forEach(function (s) {
          return s();
        }),
          _ && _.unload());
      },
    };
  },
  sel = {
    bar: "[data-filter-bar]",
    filterItem: "[data-filter-item]",
    dropdownToggle: "[data-dropdown-toggle]",
    group: "[data-filter-group]",
    groupLabels: "[data-filter-group-label]",
    groupValues: "[data-filter-group-values]",
    groupReset: "[data-filter-group-reset]",
    groupHeader: "[data-group-values-header]",
    priceRange: "[data-price-range]",
    rangeInput: "[data-range-input]",
    removeRange: "[data-remove-range]",
    filterInputs: "[data-filter-item-input]",
    sortInputs: "[data-sort-item-input]",
    resultsCount: "[data-results-count]",
    activeFilters: "[data-active-filters]",
    clearAll: "[data-clear-all-filters]",
  },
  classes$2 = {
    activeFilters: "filters-active",
    filterDisabled: "filter-item__content--disabled",
    filterBarActive: "filter-bar__filters-inner--active",
    filterBarWashActive: "filter-bar--wash-active",
    filterGroupActive: "filter-group--active",
    filterGroupRight: "filter-group__values--right",
  },
  filterBar = function s(h) {
    if (!h) return !1;
    var v = n$2(sel.bar, h),
      m = t$2(sel.groupLabels, v),
      g = t$2(sel.rangeInput, v),
      y = n$2(sel.priceRange, v),
      b = null,
      _ = null;
    y && (_ = priceRange(y));
    var $ = [
      e$2(window, "click", function s(h) {
        var m,
          g,
          y,
          $ = h.target.closest(sel.group),
          C = h.target.closest(sel.dropdownToggle),
          I = h.target.closest(sel.groupReset),
          A = h.target.closest(sel.removeRange),
          L = h.target.closest(sel.clearAll);
        ($ || S(),
          C &&
            ((m = C),
            "true" === m.getAttribute("aria-expanded")
              ? (S(), E(m))
              : (S(),
                (function s(h) {
                  var m = h.closest(sel.group);
                  h.setAttribute("aria-expanded", !0);
                  var g = n$2("#".concat(h.getAttribute("aria-controls")), v),
                    y = h.dataset.dropdownToggle;
                  g &&
                    ("filter-bar-filters" === y
                      ? (slideStop(g),
                        slideDown(g).then(function () {
                          g.setAttribute("aria-hidden", !1);
                        }))
                      : (g.setAttribute("aria-hidden", !1),
                        m &&
                          (u$1(m, classes$2.filterGroupActive),
                          T(m, g),
                          u$1(v, classes$2.filterBarWashActive),
                          (b = createFocusTrap(m, {
                            allowOutsideClick: !0,
                          })).activate())));
                })(m))),
          I &&
            ((g = I),
            (y = g.closest(sel.groupValues)),
            "price_range" === y.dataset.filterType
              ? k()
              : (t$2(sel.filterInputs, y).forEach(function (s) {
                  s.checked = !1;
                }),
                updateFilters(v))),
          A && (h.preventDefault(), k()),
          L &&
            (h.preventDefault(),
            _ && _.reset(),
            t$2("".concat(sel.filterInputs), v).forEach(function (s) {
              s.checked = !1;
            }),
            updateFilters(v)));
      }),
      e$2(v, "change", function s(h) {
        var v = h.target.closest(
            ""
              .concat(sel.bar, " ")
              .concat(sel.filterInputs, ", ")
              .concat(sel.bar, " ")
              .concat(sel.sortInputs),
          ),
          m = h.target.closest("".concat(sel.bar, " ").concat(sel.rangeInput));
        v ? (I(), C(v)) : m && (I(), C(m));
      }),
      c("filters:filter-removed", function () {
        var s;
        return (
          (s = !1),
          void (((g && A()) || L(t$2(sel.filterInputs, v))) && (s = !0),
          l(v, classes$2.activeFilters, s))
        );
      }),
      e$2(v, "keydown", function (s) {
        27 === s.keyCode && S();
      }),
    ];

    function k() {
      (_ && _.reset(), I(), updateFilters(v));
    }

    function S() {
      m.forEach(function (s) {
        E(s);
      });
    }

    function E(s) {
      var h = s.closest(sel.group);
      (i$1(v, classes$2.filterBarWashActive),
        s.setAttribute("aria-expanded", !1));
      var m = n$2("#".concat(s.getAttribute("aria-controls")), v),
        g = s.dataset.dropdownToggle;
      m &&
        (m.setAttribute("aria-hidden", !0),
        "filter-bar-filters" === g
          ? (slideStop(m), slideUp(m))
          : h && (i$1(h, classes$2.filterGroupActive), b && b.deactivate()));
    }

    function T(s, h) {
      i$1(h, classes$2.filterGroupRight);
      var v = s.parentElement.getBoundingClientRect(),
        m = s.getBoundingClientRect(),
        g = h.getBoundingClientRect();
      m.x + g.width >= v.width && u$1(h, classes$2.filterGroupRight);
    }

    function C(s) {
      !s.classList.contains(classes$2.filterDisabled) &&
        (I(),
        _ && _.validateRange(),
        debounce(function () {
          return updateFilters(v);
        }, 1e3)());
    }

    function I() {
      var s = L(t$2(sel.filterInputs, v)) || A();
      l(v, classes$2.activeFilters, s);
    }

    function A() {
      return g.some(function (s) {
        return "" !== s.value;
      });
    }

    function L(s) {
      return s.some(function (s) {
        return s.checked;
      });
    }
    return {
      renderFilters: function s(h) {
        ((m = document.querySelectorAll(".columns-teaser__wrapper")),
          (g = L(t$2(sel.filterInputs, v)) || A()),
          m.length > 0 &&
            m.forEach((s) => {
              g
                ? s.classList.add("hidden")
                : !g &&
                  s.classList.contains("hidden") &&
                  s.classList.remove("hidden");
            }),
          t$2("".concat(sel.bar, " ").concat(sel.filterItem), h).forEach(
            function (s) {
              (replaceElement(
                ""
                  .concat(sel.bar, " ")
                  .concat(sel.filterItem, '[for="')
                  .concat(s.getAttribute("for"), '"] .filter-item__checkbox'),
                h,
              ),
                replaceElement(
                  ""
                    .concat(sel.bar, " ")
                    .concat(sel.filterItem, '[for="')
                    .concat(s.getAttribute("for"), '"] .filter-item__count'),
                  h,
                ));
            },
          ),
          updateInnerHTML("".concat(sel.bar, " ").concat(sel.resultsCount), h),
          updateInnerHTML("".concat(sel.bar, " ").concat(sel.activeFilters), h),
          updateInnerHTML("".concat(sel.bar, " ").concat(sel.groupHeader), h));
        var m,
          g,
          y = t$2("".concat(sel.bar, " ").concat(sel.dropdownToggle), h);
        (y.length > 0 &&
          y.forEach(function (s) {
            updateInnerHTML(
              ""
                .concat(sel.bar, ' [data-dropdown-toggle="')
                .concat(s.getAttribute("data-dropdown-toggle"), '"]'),
              h,
            );
          }),
          t$2("".concat(sel.bar, " ").concat(sel.groupHeader), h).forEach(
            function (s) {
              updateInnerHTML(
                ""
                  .concat(sel.bar, ' [data-group-values-header="')
                  .concat(s.getAttribute("data-group-values-header"), '"]'),
                h,
              );
            },
          ),
          t$2(sel.dropdownToggle, v).forEach(function (s) {
            if ("true" === s.getAttribute("aria-expanded")) {
              var h = s.closest(sel.group),
                m = n$2("#".concat(s.getAttribute("aria-controls")), v);
              h && m && T(h, m);
            }
          }));
      },
      unload: function s() {
        ($.forEach(function (s) {
          return s();
        }),
          _ && _.unload(),
          b && b.deactivate());
      },
    };
  },
  selectors$2 = {
    infiniteScrollContainer: ".collection__infinite-container",
    infiniteScrollTrigger: ".collection__infinite-trigger",
    partial: "[data-partial]",
    filterDrawer: "[data-filter-drawer]",
    filterBar: "[data-filter-bar]",
    loader: ".collection__loading",
    paginationItemCount: "[data-pagination-item-count]",
    productItems: ".product-item",
  },
  classes$1 = {
    active: "is-active",
    hideProducts: "animation--collection-products-hide",
  },
  strings$1 = window.theme.strings;
(register("collection", {
  infiniteScroll: null,
  onLoad: function s() {
    var h = this.container.dataset,
      v = h.collectionItemCount,
      m = h.paginationType;
    parseInt(v) &&
      ((this.filterDrawerEl = n$2(selectors$2.filterDrawer, this.container)),
      (this.filterbarEl = n$2(selectors$2.filterBar, this.container)),
      (this.paginationItemCount = n$2(
        selectors$2.paginationItemCount,
        this.container,
      )),
      (this.filterDrawerEl || this.filterbarEl) &&
        ((this.partial = n$2(selectors$2.partial, this.container)),
        (this.filterDrawer = filterDrawer(this.container)),
        (this.filterBar = filterBar(this.container)),
        (this.filterHandler = filterHandler({
          container: this.container,
          renderCB: this._renderView.bind(this),
        }))),
      (this.paginationType = m),
      (this.paginated = "paginated" === this.paginationType),
      (this.infiniteScrollTrigger = n$2(
        selectors$2.infiniteScrollTrigger,
        this.container,
      )),
      this.paginated || this._initInfiniteScroll(),
      (this.productItem = ProductItem(this.container)),
      shouldAnimate(this.container) &&
        (this.animateCollection = animateCollection(this.container)));
  },
  _initInfiniteScroll: function s() {
    var h = this,
      v = {
        container: selectors$2.infiniteScrollContainer,
        pagination: selectors$2.infiniteScrollTrigger,
        loadingText: "Loading...",
        callback: function s() {
          var v;
          (h.productItem && h.productItem.unload(),
            (h.productItem = ProductItem(h.container)),
            null === (v = h.animateCollection) ||
              void 0 === v ||
              v.infiniteScrollReveal(),
            h._updatePaginationCount(),
            r$1("collection:updated"));
        },
      };
    ("click" === this.paginationType && (v.method = "click"),
      (this.infiniteScroll = new Ajaxinate(v)));
  },
  _updatePaginationCount: function s() {
    var h = t$2(selectors$2.productItems, this.container).length,
      v = strings$1.pagination.viewing
        .replace("{{ of }}", "1-".concat(h))
        .replace("{{ total }}", this.partial.dataset.collectionProductsCount);
    this.paginationItemCount.innerHTML = ""
      .concat(v, " ")
      .concat(strings$1.pagination.products);
  },
  _renderView: function s(h) {
    var v = this,
      m = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1],
      g = ""
        .concat(window.location.pathname, "?section_id=")
        .concat(this.container.dataset.sectionId, "&")
        .concat(h),
      y = n$2(selectors$2.loader, this.container);
    (u$1(this.partial, classes$1.hideProducts),
      u$1(y, classes$1.active),
      fetch(g)
        .then(function (s) {
          return s.text();
        })
        .then(function (s) {
          m && v._updateURLHash(h);
          var g,
            b = new DOMParser().parseFromString(s, "text/html"),
            _ = n$2(selectors$2.partial, b);
          ((v.partial.innerHTML = _.innerHTML),
            (v.partial.dataset.collectionProductsCount =
              _.dataset.collectionProductsCount),
            null === (g = v.animateCollection) ||
              void 0 === g ||
              g.updateContents(),
            !v.paginated &&
              v.infiniteScrollTrigger &&
              ((v.infiniteScrollTrigger.innerHTML = ""),
              v._initInfiniteScroll()),
            v.filterDrawer && v.filterDrawer.renderFilters(b),
            v.filterBar && v.filterBar.renderFilters(b),
            v.productItem && v.productItem.unload(),
            (v.productItem = ProductItem(v.container)),
            (v.paginationItemCount = n$2(
              selectors$2.paginationItemCount,
              v.container,
            )),
            i$1(y, classes$1.active),
            r$1("collection:updated"));
        }));
  },
  _updateURLHash: function s(h) {
    history.pushState(
      {
        searchParams: h,
      },
      "",
      "".concat(window.location.pathname).concat(h && "?".concat(h)),
    );
  },
  onUnload: function s() {
    var h;
    (this.infiniteScroll && this.infiniteScroll.destroy(),
      this.filterHandler && this.filterHandler.unload(),
      this.filterDrawer && this.filterDrawer.unload(),
      this.filterBar && this.filterBar.unload(),
      this.filtering && this.filtering.unload(),
      this.productItem && this.productItem.unload(),
      null === (h = this.animateCollection) || void 0 === h || h.destroy());
  },
}),
  register("login", {
    onLoad: function s() {
      var h = n$2('[data-part="login"]', this.container),
        v = n$2('[data-part="reset"]', this.container),
        m = t$2("[data-toggle]", this.container),
        g = n$2(".form-status__message--error", v),
        y = n$2(".form-status__message--success", v),
        b = n$2("[data-success-message]", this.container);

      function _(s) {
        (s && s.preventDefault(),
          l([h, v], "hide"),
          h.setAttribute("aria-hidden", a$1(h, "hide")),
          v.setAttribute("aria-hidden", a$1(v, "hide")));
      }
      (y && (u$1(b, "visible"), u$1([h, v], "hide")),
        g && _(),
        (this.toggleClick = e$2(m, "click", _)));
    },
    onUnload: function s() {
      this.toggleClick();
    },
  }),
  register("addresses", {
    onLoad: function s() {
      var h = this;
      ((this.modals = t$2("[data-address-modal]", this.container)),
        (this.focusTrap = null));
      var v = t$2("[data-overlay]", this.container),
        m = t$2("[data-open]", this.container),
        g = t$2("[data-close]", this.container),
        y = t$2("[data-remove]", this.container),
        b = t$2("[data-country-option]", this.container) || [];
      ((this.events = [
        e$2(m, "click", function (s) {
          return h.openModal(s);
        }),
        e$2(
          [].concat(_toConsumableArray$1(g), _toConsumableArray$1(v)),
          "click",
          function (s) {
            return h.closeModal(s);
          },
        ),
        e$2(y, "click", function (s) {
          return h.removeAddress(s);
        }),
        e$2(this.modals, "keydown", function (s) {
          27 === s.keyCode && h.closeModal(s);
        }),
      ]),
        b.forEach(function (s) {
          var h = s.dataset.formId;
          new window.Shopify.CountryProvinceSelector(
            "AddressCountry_" + h,
            "AddressProvince_" + h,
            {
              hideElement: "AddressProvinceContainer_" + h,
            },
          );
        }));
    },
    onUnload: function s() {
      this.events.forEach(function (s) {
        return s();
      });
    },
    openModal: function s(h) {
      h.preventDefault();
      var v = h.currentTarget.dataset.open,
        m = this.modals.find(function (s) {
          return s.dataset.addressModal == v;
        });
      (u$1(m, "active"),
        (this.focusTrap = createFocusTrap(m, {
          allowOutsideClick: !0,
        })),
        this.focusTrap.activate(),
        document.body.setAttribute("data-fluorescent-overlay-open", "true"),
        disableBodyScroll(m, {
          allowTouchMove: function s(h) {
            for (; h && h !== document.body; ) {
              if (null !== h.getAttribute("data-scroll-lock-ignore")) return !0;
              h = h.parentNode;
            }
          },
          reserveScrollBarGap: !0,
        }),
        setTimeout(function () {
          u$1(m, "visible");
        }, 50));
    },
    closeModal: function s(h) {
      h.preventDefault();
      var v = h.target.closest(".addresses__modal");
      (document.body.setAttribute("data-fluorescent-overlay-open", "false"),
        enableBodyScroll(v),
        this.focusTrap.deactivate(),
        i$1(v, "visible"),
        setTimeout(function () {
          i$1(v, "active");
        }, 350));
    },
    removeAddress: function s(h) {
      var v = h.currentTarget.dataset,
        m = v.confirmMessage,
        g = v.target;
      confirm(m) &&
        window.Shopify.postLink(g, {
          parameters: {
            _method: "delete",
          },
        });
    },
  }),
  register("article", {
    onLoad: function s() {
      focusFormStatus(this.container);
      var h = n$2(".social-share", this.container);
      (h && (this.socialShare = SocialShare(h)),
        wrapIframes(t$2("iframe", this.container)),
        wrapTables(t$2("table", this.container)),
        shouldAnimate(this.container) &&
          (this.animateArticle = animateArticle(this.container)));
    },
    onUnload: function s() {
      var h;
      (this.socialShare && this.socialShare(),
        null === (h = this.animateArticle) || void 0 === h || h.destroy());
    },
  }),
  register("password", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animatePassword = animatePassword(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animatePassword) || void 0 === h || h.destroy();
    },
  }));
var selectors$1 = {
  video: ".about__block-video",
};
register("page", {
  onLoad: function s() {
    var h = this,
      v = t$2(selectors$1.video, this.container);
    ((this.videoHandlers = []),
      v.length &&
        v.forEach(function (s) {
          h.videoHandlers.push(backgroundVideoHandler(s.parentNode));
        }),
      (this.accordions = Accordions(t$2(".accordion", this.container))),
      wrapIframes(t$2("iframe", this.container)),
      wrapTables(t$2("table", this.container)),
      shouldAnimate(this.container) &&
        (this.animatePage = animatePage(this.container)));
  },
  onUnload: function s() {
    var h;
    (this.accordions.unload(),
      this.videoHandlers.forEach(function (s) {
        return s();
      }),
      null === (h = this.animatePage) || void 0 === h || h.destroy());
  },
});
var selectors = {
    searchSection: ".search",
    searchBanner: ".search-header",
    infiniteScrollContainer: ".search__infinite-container",
    infiniteScrollTrigger: ".search__infinite-trigger",
    partial: "[data-partial]",
    filterDrawer: "[data-filter-drawer]",
    filterBar: "[data-filter-bar]",
    loader: ".search__loading",
    paginationItemCount: "[data-pagination-item-count]",
    searchItems: ".product-item, .search-item",
  },
  classes = {
    active: "is-active",
    hideProducts: "animation--search-products-hide",
  },
  strings = window.theme.strings;
if (
  (register("search", {
    infiniteScroll: null,
    onLoad: function s() {
      ((this.searchBannerEl = n$2(selectors.searchBanner, this.container)),
        shouldAnimate(this.searchBannerEl) &&
          (this.animateSearchBanner = animateSearchBanner(
            this.searchBannerEl,
          )));
      var h = this.container.dataset,
        v = h.searchItemCount,
        m = h.paginationType;
      parseInt(v) &&
        ((this.searchSectionEl = n$2(selectors.searchSection, this.container)),
        (this.filterDrawerEl = n$2(selectors.filterDrawer, this.container)),
        (this.filterBarEl = n$2(selectors.filterBar, this.container)),
        (this.paginationItemCount = n$2(
          selectors.paginationItemCount,
          this.container,
        )),
        this.filterBarEl &&
          ((this.partial = n$2(selectors.partial, this.container)),
          (this.filterDrawer = filterDrawer(this.searchSectionEl)),
          (this.filterBar = filterBar(this.searchSectionEl)),
          (this.filterHandler = filterHandler({
            container: this.searchSectionEl,
            renderCB: this._renderView.bind(this),
          }))),
        (this.paginationType = m),
        (this.paginated = "paginated" === this.paginationType),
        (this.infiniteScrollTrigger = n$2(
          selectors.infiniteScrollTrigger,
          this.container,
        )),
        this.paginated || this._initInfiniteScroll(),
        (this.productItem = ProductItem(this.container)),
        shouldAnimate(this.searchSectionEl) &&
          (this.animateSearch = animateSearch(this.searchSectionEl)));
    },
    _initInfiniteScroll: function s() {
      var h = this,
        v = {
          container: selectors.infiniteScrollContainer,
          pagination: selectors.infiniteScrollTrigger,
          loadingText: "Loading...",
          callback: function s() {
            var v;
            (h.productItem && h.productItem.unload(),
              (h.productItem = ProductItem(h.container)),
              null === (v = h.animateSearch) ||
                void 0 === v ||
                v.infiniteScrollReveal(),
              h._updatePaginationCount(),
              r$1("collection:updated"));
          },
        };
      ("click" === this.paginationType && (v.method = "click"),
        (this.infiniteScroll = new Ajaxinate(v)));
    },
    _updatePaginationCount: function s() {
      var h = t$2(selectors.searchItems, this.container).length,
        v = strings.pagination.viewing
          .replace("{{ of }}", "1-".concat(h))
          .replace("{{ total }}", this.partial.dataset.searchResultsCount);
      this.paginationItemCount.innerHTML = ""
        .concat(v, " ")
        .concat(strings.pagination.results);
    },
    _renderView: function s(h) {
      var v = this,
        m = !(arguments.length > 1) || void 0 === arguments[1] || arguments[1],
        g = ""
          .concat(window.location.pathname, "?section_id=")
          .concat(this.container.dataset.sectionId, "&")
          .concat(h),
        y = n$2(selectors.loader, this.container);
      (u$1(y, classes.active),
        fetch(g)
          .then(function (s) {
            return s.text();
          })
          .then(function (s) {
            m && v._updateURLHash(h);
            var g,
              b = new DOMParser().parseFromString(s, "text/html"),
              _ = n$2(selectors.partial, b);
            ((v.partial.innerHTML = _.innerHTML),
              (v.partial.dataset.searchResultsCount =
                _.dataset.searchResultsCount),
              null === (g = v.animateSearch) ||
                void 0 === g ||
                g.updateContents(),
              !v.paginated &&
                v.infiniteScrollTrigger &&
                ((v.infiniteScrollTrigger.innerHTML = ""),
                v._initInfiniteScroll()),
              v.filterDrawer && v.filterDrawer.renderFilters(b),
              v.filterBar && v.filterBar.renderFilters(b),
              v.productItem && v.productItem.unload(),
              (v.productItem = ProductItem(v.container)),
              (v.paginationItemCount = n$2(
                selectors.paginationItemCount,
                v.container,
              )),
              i$1(y, classes.active),
              r$1("collection:updated"));
          }));
    },
    _updateURLHash: function s(h) {
      history.pushState(
        {
          searchParams: h,
        },
        "",
        "".concat(window.location.pathname).concat(h && "?".concat(h)),
      );
    },
    onUnload: function s() {
      var h, v;
      (this.infiniteScroll && this.infiniteScroll.destroy(),
        this.filterHandler && this.filterHandler.unload(),
        this.filterDrawer && this.filterDrawer.unload(),
        this.filterBar && this.filterBar.unload(),
        this.filtering && this.filtering.unload(),
        this.productItem && this.productItem.unload(),
        null === (h = this.animateSearch) || void 0 === h || h.destroy(),
        null === (v = this.animateSearchBanner) || void 0 === v || v.destroy());
    },
  }),
  register("contact", {
    onLoad: function s() {
      ((this.accordions = Accordions(t$2(".accordion", this.container))),
        wrapIframes(t$2("iframe", this.container)),
        wrapTables(t$2("table", this.container)));
    },
    onUnload: function s() {
      this.accordions.unload();
    },
  }),
  register("blog", {
    onLoad: function s() {
      var h = n$2("#blog-mobile-nav", this.container);
      (h &&
        (this.mobileNavSelectEvent = e$2(h, "change", function () {
          window.location.href = h.value;
        })),
        shouldAnimate(this.container) &&
          (this.animateBlog = animateBlog(this.container)));
    },
    onUnload: function s() {
      var h;
      (null === (h = this.animateBlog) || void 0 === h || h.destroy(),
        this.mobileNavSelectEvent && this.mobileNavSelectEvent.unsubscribe());
    },
  }),
  register("collection-banner", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateCollectionBanner = animateCollectionBanner(
          this.container,
        ));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateCollectionBanner) ||
        void 0 === h ||
        h.destroy();
    },
  }),
  register("list-collections", {
    onLoad: function s() {
      shouldAnimate(this.container) &&
        (this.animateListCollections = animateListCollections(this.container));
    },
    onUnload: function s() {
      var h;
      null === (h = this.animateListCollections) || void 0 === h || h.destroy();
    },
  }),
  HTMLElement.prototype.hasOwnProperty("inert") ||
    import(flu.chunks.polyfillInert),
  !0 === window.Shopify.designMode)
)
  (u$1(document.documentElement, "theme-editor"),
    document.documentElement.classList.add("theme-editor"));
else {
  var h = n$2(".theme-editor-scroll-offset", document);
  h && h.parentNode.removeChild(h);
}
var loadSections = function s() {
  (load("*"),
    o$1({
      SelectedProductSection: null,
    }));
};

function initCreateSwiperPromise() {
  window.LoadSwiper = import(flu.chunks.swiper);
}

function initCreateLightboxPromise() {
  window.LoadLightbox = import(flu.chunks.photoswipe);
}
("complete" === document.readyState || "interactive" === document.readyState
  ? loadSections()
  : e$2(document, "DOMContentLoaded", loadSections),
  isMobile$1({
    tablet: !0,
    featureDetect: !0,
  }) && u$1(document.body, "is-mobile"),
  pageTransition(),
  handleTab(),
  sectionClasses(),
  productLightbox(),
  initCreateSwiperPromise(),
  initCreateLightboxPromise());
var quickViewModalElement = n$2("[data-quick-view-modal]", document);
quickViewModalElement && quickViewModal(quickViewModalElement);
var modalElement = n$2("[data-modal]", document);
modal(modalElement);
var flashModal = n$2("[data-flash-alert]", document);
flashAlertModal(flashModal);
var availabilityDrawer = n$2("[data-store-availability-drawer]", document);
storeAvailabilityDrawer(availabilityDrawer);
var headerOverlayContainer = document.querySelector("[data-header-overlay]");
(headerOverlay(headerOverlayContainer),
  backToTop(),
  (window.SHA = "50ca614f05"),
  (window.loadScriptsByAttribute = function (s) {
    let h = document.querySelectorAll(`script[${s}]`);
    h.forEach((s) => {
      let h = document.createElement("script");
      ((h.type = "text/javascript"),
        s.src ? (h.src = s.src) : (h.textContent = s.textContent),
        document.head.appendChild(h),
        s.remove());
    });
  }),
  document.addEventListener("click", function (s) {
    let h = s.target;
    if (h.hasAttribute("data-show-more-btn")) {
      let v = h.closest("[data-switch-introduction]");
      (v.querySelector("[data-show-long-content]")?.classList.remove("hidden"),
        v.querySelector("[data-show-less-content]")?.classList.add("hidden"),
        v.querySelector("[data-show-less-btn]")?.classList.remove("hidden"),
        v
          .querySelectorAll("[data-show-more-btn]")
          .forEach((btn) => btn.classList.add("hidden")));
    }
    if (h.hasAttribute("data-show-less-btn")) {
      let m = h.closest("[data-switch-introduction]");
      (m.querySelector("[data-show-long-content]")?.classList.add("hidden"),
        m.querySelector("[data-show-less-content]")?.classList.remove("hidden"),
        m
          .querySelectorAll("[data-show-more-btn]")
          .forEach((btn) => btn.classList.remove("hidden")),
        h.classList.add("hidden"));
    }
  }));
